/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(60);
	module.exports = __webpack_require__(38);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(62);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(14);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _SortingContext = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var langMap = {
		'islex_DA': 'DK',
		'islex_NO-N': 'NO',
		'islex_FI': 'FI',
		'islex_NO-B': 'NO',
		'islex_FO': 'FO',
		'islex_FRA': 'FR',
		'islex_TYS': 'DE',
		'islex_SE': 'SE',
		'islex_EN': 'EN',
		'islex_POL': 'POL'
	};
	
	var MalidCard = function (_Component) {
		_inherits(MalidCard, _Component);
	
		function MalidCard(props) {
			_classCallCheck(this, MalidCard);
	
			var _this = _possibleConstructorReturn(this, (MalidCard.__proto__ || Object.getPrototypeOf(MalidCard)).call(this, props));
	
			_this.expandButtonClickHandler = _this.expandButtonClickHandler.bind(_this);
	
			var minimizedDatasets = localStorage.getItem('malid_minimized_datasets') ? JSON.parse(localStorage.getItem('malid_minimized_datasets')) : [];
	
			_this.state = {
				initialized: false,
				minimized: minimizedDatasets.indexOf(_this.props.database) > -1,
				showInfo: false
			};
			return _this;
		}
	
		_createClass(MalidCard, [{
			key: 'expandButtonClickHandler',
			value: function expandButtonClickHandler() {
				this.setState({
					minimized: !this.state.minimized
				}, function () {
					var minimizedDatasets = localStorage.getItem('malid_minimized_datasets') ? JSON.parse(localStorage.getItem('malid_minimized_datasets')) : [];
	
					if (this.state.minimized) {
						minimizedDatasets.push(this.props.database);
					} else {
						minimizedDatasets = _underscore2.default.without(minimizedDatasets, this.props.database);
					}
	
					localStorage.setItem('malid_minimized_datasets', JSON.stringify(_underscore2.default.uniq(minimizedDatasets)));
				}.bind(this));
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				setTimeout(function () {
					this.setState({
						initialized: true
					});
				}.bind(this), 100);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				if (this.props.children !== prevProps.children) {
					this.setState({
						showInfo: false
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var isAnySortingEnabled = this.context;
				return _react2.default.createElement(
					'div',
					{ className: 'card' + (this.props.database ? ' database-' + this.props.database : '') + (this.props.className ? ' ' + this.props.className : '') + (this.state.initialized ? ' initialized' : '') + (this.state.minimized ? ' minimized' : '') + (!this.props.visible && !this.props.frontPage || this.props.forceHidden ? ' hidden' : '') + (isAnySortingEnabled ? ' sorting-enabled' : ''),
						style: {
							transitionDelay: this.props.count / 10 + 's'
						}
					},
					_react2.default.createElement(
						'div',
						{ className: 'card-header' + (!this.props.visible && !this.props.frontPage ? ' hidden' : ''),
							style: this.state.minimized ? { cursor: 'pointer' } : null, onClick: function onClick() {
								if (_this2.state.minimized) {
									_this2.expandButtonClickHandler();
								}
							} },
						_react2.default.createElement(
							'div',
							{ className: 'card-header-top-row' },
							_react2.default.createElement(
								'div',
								{ className: 'dict-flag ' + this.props.database + '-flag' },
								this.props.includeFlags && !this.props.frontPage && langMap[this.props.database] && _react2.default.createElement('img', {
									src: '/img/flags/' + langMap[this.props.database] + '.svg',
									alt: langMap[this.props.database]
								})
							),
							_react2.default.createElement(
								'p',
								{ className: 'malid-card-title' },
								this.props.title
							),
							!this.props.frontPage && _react2.default.createElement('button', { className: 'info-button', onClick: function onClick() {
									return _this2.setState({
										showInfo: !_this2.state.showInfo
									});
								} })
						),
						this.props.subTitle && _react2.default.createElement(
							'div',
							{ className: 'subtitle' },
							this.props.subTitle
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'card-body' },
						(this.state.showInfo || this.props.frontPage) && _react2.default.createElement('p', { className: 'card-text' + (!this.props.frontPage ? ' card-info' : ''), dangerouslySetInnerHTML: { __html: this.props.aboutText } }),
						this.state.showInfo && _react2.default.createElement('hr', null),
						!this.props.frontPage && !this.props.showInfo && this.props.children
					),
					_react2.default.createElement(
						'button',
						{ className: 'expand-button', onClick: this.expandButtonClickHandler },
						_react2.default.createElement(
							'span',
							{ className: 'label' },
							this.state.minimized ? window.l('database_display_in_results') : window.l('database_hide_in_results')
						),
						_react2.default.createElement('span', { className: 'icon' })
					)
				);
			}
		}]);
	
		return MalidCard;
	}(_react.Component);
	
	MalidCard.contextType = _SortingContext.SortingContext;
	exports.default = MalidCard;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(57);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		gaTrackingId: 'G-6DPTSXCH00',
	
		// apiRoot: 'http://130.208.108.86:8095/malid/',
		pageUrl: '/',
		apiRoot:  false ? '//130.208.108.86:8095/malid/' : '/api_proxy/'
		// apiRoot: '/api_proxy/'
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 7 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(52)();
	}


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SortingContext = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SortingContext = exports.SortingContext = _react2.default.createContext(false);

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		plural: function plural(singular, _plural, num) {
			try {
				if (String(num).endsWith('1') && num !== 11) {
					return singular;
				} else {
					return _plural;
				}
			} catch (e) {
				return _plural;
			}
		}
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(45);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(17);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(56);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
	    var current = global._;
	    var exports = global._ = factory();
	    exports.noConflict = function () { global._ = current; return exports; };
	  }()));
	}(this, (function () {
	  //     Underscore.js 1.13.7
	  //     https://underscorejs.org
	  //     (c) 2009-2024 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Current version.
	  var VERSION = '1.13.7';
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = (typeof self == 'object' && self.self === self && self) ||
	            (typeof global == 'object' && global.global === global && global) ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // Modern feature detection.
	  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
	      supportsDataView = typeof DataView !== 'undefined';
	
	  // All **ECMAScript 5+** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create,
	      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = isNaN,
	      _isFinite = isFinite;
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  // The largest integer that can be represented exactly.
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || (type === 'object' && !!obj);
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a `toString`-based type tester.
	  function tagTester(name) {
	    var tag = '[object ' + name + ']';
	    return function(obj) {
	      return toString.call(obj) === tag;
	    };
	  }
	
	  var isString = tagTester('String');
	
	  var isNumber = tagTester('Number');
	
	  var isDate = tagTester('Date');
	
	  var isRegExp = tagTester('RegExp');
	
	  var isError = tagTester('Error');
	
	  var isSymbol = tagTester('Symbol');
	
	  var isArrayBuffer = tagTester('ArrayBuffer');
	
	  var isFunction = tagTester('Function');
	
	  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
	  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  var isFunction$1 = isFunction;
	
	  var hasObjectTag = tagTester('Object');
	
	  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
	  // In IE 11, the most common among them, this problem also applies to
	  // `Map`, `WeakMap` and `Set`.
	  // Also, there are cases where an application can override the native
	  // `DataView` object, in cases like that we can't use the constructor
	  // safely and should just rely on alternate `DataView` checks
	  var hasDataViewBug = (
	        supportsDataView && (!/\[native code\]/.test(String(DataView)) || hasObjectTag(new DataView(new ArrayBuffer(8))))
	      ),
	      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));
	
	  var isDataView = tagTester('DataView');
	
	  // In IE 10 - Edge 13, we need a different heuristic
	  // to determine whether an object is a `DataView`.
	  // Also, in cases where the native `DataView` is
	  // overridden we can't rely on the tag itself.
	  function alternateIsDataView(obj) {
	    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
	  }
	
	  var isDataView$1 = (hasDataViewBug ? alternateIsDataView : isDataView);
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native `Array.isArray`.
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Internal function to check whether `key` is an own property name of `obj`.
	  function has$1(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  }
	
	  var isArguments = tagTester('Arguments');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return has$1(obj, 'callee');
	      };
	    }
	  }());
	
	  var isArguments$1 = isArguments;
	
	  // Is a given object a finite number?
	  function isFinite$1(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN$1(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  // Common internal logic for `isArrayLike` and `isBufferLike`.
	  function createSizePropertyCheck(getSizeProperty) {
	    return function(collection) {
	      var sizeProperty = getSizeProperty(collection);
	      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
	    }
	  }
	
	  // Internal helper to generate a function to obtain property `key` from `obj`.
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  // Internal helper to obtain the `byteLength` property of an object.
	  var getByteLength = shallowProperty('byteLength');
	
	  // Internal helper to determine whether we should spend extensive checks against
	  // `ArrayBuffer` et al.
	  var isBufferLike = createSizePropertyCheck(getByteLength);
	
	  // Is a given value a typed array?
	  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
	  function isTypedArray(obj) {
	    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
	    // Otherwise, fall back on the above regular expression.
	    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
	                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
	  }
	
	  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);
	
	  // Internal helper to obtain the `length` property of an object.
	  var getLength = shallowProperty('length');
	
	  // Internal helper to create a simple lookup structure.
	  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
	  // circular imports. `emulatedSet` is a one-off solution that only works for
	  // arrays of strings.
	  function emulatedSet(keys) {
	    var hash = {};
	    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
	    return {
	      contains: function(key) { return hash[key] === true; },
	      push: function(key) {
	        hash[key] = true;
	        return keys.push(key);
	      }
	    };
	  }
	
	  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
	  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
	  // needed.
	  function collectNonEnumProps(obj, keys) {
	    keys = emulatedSet(keys);
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has$1(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    // Skip the more expensive `toString`-based type checks if `obj` has no
	    // `.length`.
	    var length = getLength(obj);
	    if (typeof length == 'number' && (
	      isArray(obj) || isString(obj) || isArguments$1(obj)
	    )) return length === 0;
	    return getLength(keys(obj)) === 0;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	  // If Underscore is called as a function, it returns a wrapped object that can
	  // be used OO-style. This wrapper holds altered versions of all functions added
	  // through `_.mixin`. Wrapped objects may be chained.
	  function _$1(obj) {
	    if (obj instanceof _$1) return obj;
	    if (!(this instanceof _$1)) return new _$1(obj);
	    this._wrapped = obj;
	  }
	
	  _$1.VERSION = VERSION;
	
	  // Extracts the result from a wrapped and chained object.
	  _$1.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxies for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;
	
	  _$1.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // Internal function to wrap or shallow-copy an ArrayBuffer,
	  // typed array or DataView to a new view, reusing the buffer.
	  function toBufferView(bufferSource) {
	    return new Uint8Array(
	      bufferSource.buffer || bufferSource,
	      bufferSource.byteOffset || 0,
	      getByteLength(bufferSource)
	    );
	  }
	
	  // We use this string twice, so give it a name for minification.
	  var tagDataView = '[object DataView]';
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _$1) a = a._wrapped;
	    if (b instanceof _$1) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    // Work around a bug in IE 10 - Edge 13.
	    if (hasDataViewBug && className == '[object Object]' && isDataView$1(a)) {
	      if (!isDataView$1(b)) return false;
	      className = tagDataView;
	    }
	    switch (className) {
	      // These types are compared by value.
	      case '[object RegExp]':
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	      case '[object ArrayBuffer]':
	      case tagDataView:
	        // Coerce to typed array so we can fall through.
	        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays && isTypedArray$1(a)) {
	        var byteLength = getByteLength(a);
	        if (byteLength !== getByteLength(b)) return false;
	        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
	        areArrays = true;
	    }
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
	                               isFunction$1(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Retrieve all the enumerable property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Since the regular `Object.prototype.toString` type tests don't work for
	  // some types in IE 11, we use a fingerprinting heuristic instead, based
	  // on the methods. It's not great, but it's the best we got.
	  // The fingerprint method lists are defined below.
	  function ie11fingerprint(methods) {
	    var length = getLength(methods);
	    return function(obj) {
	      if (obj == null) return false;
	      // `Map`, `WeakMap` and `Set` have no enumerable keys.
	      var keys = allKeys(obj);
	      if (getLength(keys)) return false;
	      for (var i = 0; i < length; i++) {
	        if (!isFunction$1(obj[methods[i]])) return false;
	      }
	      // If we are testing against `WeakMap`, we need to ensure that
	      // `obj` doesn't have a `forEach` method in order to distinguish
	      // it from a regular `Map`.
	      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
	    };
	  }
	
	  // In the interest of compact minification, we write
	  // each string in the fingerprints only once.
	  var forEachName = 'forEach',
	      hasName = 'has',
	      commonInit = ['clear', 'delete'],
	      mapTail = ['get', hasName, 'set'];
	
	  // `Map`, `WeakMap` and `Set` each have slightly different
	  // combinations of the above sublists.
	  var mapMethods = commonInit.concat(forEachName, mapTail),
	      weakMapMethods = commonInit.concat(mapTail),
	      setMethods = ['add'].concat(commonInit, forEachName, hasName);
	
	  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');
	
	  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');
	
	  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');
	
	  var isWeakSet = tagTester('WeakSet');
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of `_.object` with one argument.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction$1(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in
	  // object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Create a naked function reference for surrogate-prototype-swapping.
	  function ctor() {
	    return function(){};
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    var Ctor = ctor();
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes `interceptor` with the `obj` and then returns `obj`.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Normalize a (deep) property `path` to array.
	  // Like `_.iteratee`, this function can be customized.
	  function toPath$1(path) {
	    return isArray(path) ? path : [path];
	  }
	  _$1.toPath = toPath$1;
	
	  // Internal wrapper for `_.toPath` to enable minification.
	  // Similar to `cb` for `_.iteratee`.
	  function toPath(path) {
	    return _$1.toPath(path);
	  }
	
	  // Internal function to obtain a nested property in `obj` along `path`.
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Get the value of the (deep) property on `path` from `object`.
	  // If any property in `path` does not exist or if the value is
	  // `undefined`, return `defaultValue` instead.
	  // The `path` is normalized through `_.toPath`.
	  function get(object, path, defaultValue) {
	    var value = deepGet(object, toPath(path));
	    return isUndefined(value) ? defaultValue : value;
	  }
	
	  // Shortcut function for checking if an object has a given property directly on
	  // itself (in other words, not on a prototype). Unlike the internal `has`
	  // function, this public version can also traverse nested properties.
	  function has(obj, path) {
	    path = toPath(path);
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (!has$1(obj, key)) return false;
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indices.
	  function property(path) {
	    path = toPath(path);
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `_.identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only `argCount` argument.
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	  _$1.iteratee = iteratee;
	
	  // The function we call internally to generate a callback. It invokes
	  // `_.iteratee` if overridden, otherwise `baseIteratee`.
	  function cb(value, context, argCount) {
	    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Returns the results of applying the `iteratee` to each element of `obj`.
	  // In contrast to `_.map` it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function noop(){}
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) return noop;
	    return function(path) {
	      return get(obj, path);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between `min` and `max` (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // Internal helper to generate functions for escaping and unescaping strings
	  // to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	
	  // Internal list of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Function for escaping strings to HTML interpolation.
	  var _escape = createEscaper(escapeMap);
	
	  // Internal list of HTML entities for unescaping.
	  var unescapeMap = invert(escapeMap);
	
	  // Function for unescaping strings from HTML interpolation.
	  var _unescape = createEscaper(unescapeMap);
	
	  // By default, Underscore uses ERB-style template delimiters. Change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _$1.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `_.templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  function escapeChar(match) {
	    return '\\' + escapes[match];
	  }
	
	  // In order to prevent third-party code injection through
	  // `_.templateSettings.variable`, we test it against the following regular
	  // expression. It is intentionally a bit more liberal than just matching valid
	  // identifiers, but still prevents possible loopholes through defaults or
	  // destructuring assignment.
	  var bareIdentifier = /^\s*(\w|\$)+\s*$/;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _$1.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    var argument = settings.variable;
	    if (argument) {
	      // Insure against third-party code injection. (CVE-2021-23358)
	      if (!bareIdentifier.test(argument)) throw new Error(
	        'variable is not a bare identifier: ' + argument
	      );
	    } else {
	      // If a variable is not specified, place data values in local scope.
	      source = 'with(obj||{}){\n' + source + '}\n';
	      argument = 'obj';
	    }
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(argument, '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _$1);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    path = toPath(path);
	    var length = path.length;
	    if (!length) {
	      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction$1(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _$1(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // Internal function to execute `sourceFunc` bound to `context` with optional
	  // `args`. Determines whether to execute a function as a constructor or as a
	  // normal function.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _$1;
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally).
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Internal helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var isArrayLike = createSizePropertyCheck(getLength);
	
	  // Internal implementation of a recursive `flatten` function.
	  function flatten$1(input, depth, strict, output) {
	    output = output || [];
	    if (!depth && depth !== 0) {
	      depth = Infinity;
	    } else if (depth <= 0) {
	      return output.concat(input);
	    }
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
	        // Flatten current level of array or arguments object.
	        if (depth > 1) {
	          flatten$1(value, depth - 1, strict, output);
	          idx = output.length;
	        } else {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, keys) {
	    keys = flatten$1(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	    return obj;
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _$1, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // When a sequence of calls of the returned function ends, the argument
	  // function is triggered. The end of a sequence is defined by the `wait`
	  // parameter. If `immediate` is passed, the argument function will be
	  // triggered at the beginning of the sequence instead of at the end.
	  function debounce(func, wait, immediate) {
	    var timeout, previous, args, result, context;
	
	    var later = function() {
	      var passed = now() - previous;
	      if (wait > passed) {
	        timeout = setTimeout(later, wait - passed);
	      } else {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	        // This check is needed because `func` can recursively invoke `debounced`.
	        if (!timeout) args = context = null;
	      }
	    };
	
	    var debounced = restArguments(function(_args) {
	      context = this;
	      args = _args;
	      previous = now();
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	        if (immediate) result = func.apply(context, args);
	      }
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = args = context = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the
	  // Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Returns the first key on an object that passes a truth test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a truth test.
	  var findIndex = createPredicateIndexFinder(1);
	
	  // Returns the last index on an array-like that passes a truth test.
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN$1);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	
	  // Return the position of the last occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Convenience version of a common use case of `_.find`: getting the first
	  // object containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // The cornerstone for collection functions, an `each`
	  // implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Internal helper to create a reducing function, iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements pass a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object passes a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction$1(path)) {
	      func = path;
	    } else {
	      path = toPath(path);
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `_.map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `_.filter`: selecting only
	  // objects containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Safely create a real, live array from anything iterable.
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together.
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `_.map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = toArray(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Split a collection into two arrays: one whose elements all pass the given
	  // truth test, and one whose elements all do not pass the truth test.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Return the number of elements in a collection.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Internal `_.pick` helper function to determine whether `key` is an enumerable
	  // property name of `obj`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the allowed properties.
	  var pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (isFunction$1(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten$1(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the disallowed properties.
	  var omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (isFunction$1(iteratee)) {
	      iteratee = negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = map(flatten$1(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the first entry of the `array`. Especially useful on
	  // the `arguments` object. Passing an **n** will return the rest N values in the
	  // `array`.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Flatten out an array, either recursively (by default), or up to `depth`.
	  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
	  function flatten(array, depth) {
	    return flatten$1(array, depth, false);
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = flatten$1(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(flatten$1(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = (array && max(array, getLength).length) || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _$1(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _$1[name] = obj[name];
	      _$1.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_$1, args));
	      };
	    });
	    return _$1;
	  }
	
	  // Add all mutator `Array` functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) {
	        method.apply(obj, arguments);
	        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
	          delete obj[0];
	        }
	      }
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor `Array` functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) obj = method.apply(obj, arguments);
	      return chainResult(this, obj);
	    };
	  });
	
	  // Named Exports
	
	  var allExports = {
	    __proto__: null,
	    VERSION: VERSION,
	    restArguments: restArguments,
	    isObject: isObject,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    isBoolean: isBoolean,
	    isElement: isElement,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isArrayBuffer: isArrayBuffer,
	    isDataView: isDataView$1,
	    isArray: isArray,
	    isFunction: isFunction$1,
	    isArguments: isArguments$1,
	    isFinite: isFinite$1,
	    isNaN: isNaN$1,
	    isTypedArray: isTypedArray$1,
	    isEmpty: isEmpty,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    get: get,
	    has: has,
	    mapObject: mapObject,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    toPath: toPath$1,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: _escape,
	    unescape: _unescape,
	    templateSettings: templateSettings,
	    template: template,
	    result: result,
	    uniqueId: uniqueId,
	    chain: chain,
	    iteratee: iteratee,
	    partial: partial,
	    bind: bind,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    findKey: findKey,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    find: find,
	    detect: find,
	    findWhere: findWhere,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    partition: partition,
	    toArray: toArray,
	    size: size,
	    pick: pick,
	    omit: omit,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    transpose: unzip,
	    zip: zip,
	    object: object,
	    range: range,
	    chunk: chunk,
	    mixin: mixin,
	    'default': _$1
	  };
	
	  // Default Export
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _ = mixin(allExports);
	  // Legacy Node.js API.
	  _._ = _;
	
	  return _;
	
	})));
	//# sourceMappingURL=underscore-umd.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(16);
	function _inheritsLoose(t, o) {
	  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 16 */
/***/ function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 17 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(3);
	
	var _SearchResultsList = __webpack_require__(36);
	
	var _SearchResultsList2 = _interopRequireDefault(_SearchResultsList);
	
	var _LinkView = __webpack_require__(26);
	
	var _LinkView2 = _interopRequireDefault(_LinkView);
	
	var _AppMenu = __webpack_require__(19);
	
	var _AppMenu2 = _interopRequireDefault(_AppMenu);
	
	var _AutocompleteInput = __webpack_require__(20);
	
	var _AutocompleteInput2 = _interopRequireDefault(_AutocompleteInput);
	
	var _eventbusjs = __webpack_require__(42);
	
	var _eventbusjs2 = _interopRequireDefault(_eventbusjs);
	
	var _GoogleAnalytics = __webpack_require__(23);
	
	var _GoogleAnalytics2 = _interopRequireDefault(_GoogleAnalytics);
	
	var _config = __webpack_require__(4);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _MatomoVeftalning = __webpack_require__(28);
	
	var _MatomoVeftalning2 = _interopRequireDefault(_MatomoVeftalning);
	
	__webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
		_inherits(App, _Component);
	
		function App(props) {
			_classCallCheck(this, App);
	
			var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
			window.eventBus = _eventbusjs2.default;
	
			//window.app = this;
	
			_this.inputChangeHandler = _this.inputChangeHandler.bind(_this);
			_this.searchButtonClickHandler = _this.searchButtonClickHandler.bind(_this);
			_this.searchKeyDownHandler = _this.searchKeyDownHandler.bind(_this);
			_this.menuButtonClickHandler = _this.menuButtonClickHandler.bind(_this);
			_this.inputFocusHandler = _this.inputFocusHandler.bind(_this);
			_this.languageChangedHandler = _this.languageChangedHandler.bind(_this);
	
			_this.state = {
				searchString: '',
				inputFocus: false,
				menuOpen: false
			};
			return _this;
		}
	
		_createClass(App, [{
			key: 'languageChangedHandler',
			value: function languageChangedHandler() {
				this.forceUpdate();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				// Hér hlustum við eftir breytingu á route
				this.refs.router.history.listen(function (event) {
					this.setState({
						routePath: event.pathname,
						menuOpen: false
					});
	
					window.scrollTo(0, 0);
				}.bind(this));
	
				document.addEventListener('mousedown', function (event) {
					if (!this.state.menuOpen) {
						return;
					}
	
					if (this.refs.menuButton.contains(event.target)) {
						event.stopPropagation();
	
						return;
					}
	
					if (this.refs.appMenu && this.refs.appMenu.refs.menuContent && !this.refs.appMenu.refs.menuContent.contains(event.target)) {
						this.setState({
							menuOpen: false
						});
					}
				}.bind(this));
	
				window.eventBus.addEventListener('Lang.languageChanged', this.languageChangedHandler);
	
				setTimeout(function () {
					this.refs.searchInput.refs.inputField.focus();
				}.bind(this), 100);
			}
		}, {
			key: 'inputFocusHandler',
			value: function inputFocusHandler() {
				this.refs.searchInput.refs.inputField.select();
			}
		}, {
			key: 'menuButtonClickHandler',
			value: function menuButtonClickHandler(event) {
				if (!this.state.menuOpen) {
					this.refs.appMenu.refs.menuContent.scrollTop = 0;
				}
	
				this.setState({
					menuOpen: !this.state.menuOpen
				});
			}
		}, {
			key: 'inputChangeHandler',
			value: function inputChangeHandler(event) {
				var stateObj = {};
	
				stateObj[event.target.name] = event.target.value;
	
				this.setState(stateObj);
			}
		}, {
			key: 'searchKeyDownHandler',
			value: function searchKeyDownHandler(event) {
				if (event.keyCode === 13) {
					// enter
					this.searchButtonClickHandler();
				}
			}
		}, {
			key: 'searchButtonClickHandler',
			value: function searchButtonClickHandler() {
				if (this.state.searchString !== '') {
					this.refs.router.history.push('/leit/' + this.state.searchString);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_reactRouterDom.BrowserRouter,
					{ ref: 'router' },
					_react2.default.createElement(
						_react2.default.Fragment,
						null,
						_react2.default.createElement(
							'div',
							{ className: 'app-container' + (this.state.menuOpen ? ' menu-open' : '') },
							_react2.default.createElement(
								'header',
								{ id: 'mainHeader', className: 'main-header' },
								_react2.default.createElement(
									'div',
									{ className: 'container' },
									_react2.default.createElement(
										'div',
										{ className: 'd-flex' },
										_react2.default.createElement(
											'button',
											{ className: 'app-menu-button menu-button', ref: 'menuButton', onClick: this.menuButtonClickHandler },
											_react2.default.createElement(
												'span',
												{ className: 'hamburger-icon' },
												_react2.default.createElement('span', { className: 'icon-middle' }),
												_react2.default.createElement('span', { className: 'icon-before-after' })
											)
										),
										_react2.default.createElement(
											'a',
											{ className: 'navbar-brand', href: '/', rel: 'home' },
											'm\xE1li\xF0.is'
										),
										_react2.default.createElement(
											'div',
											{ className: 'input-group' },
											_react2.default.createElement(
												'label',
												{ htmlFor: 'search', className: 'screen-reader-text' },
												window.l('leita')
											),
											_react2.default.createElement(_AutocompleteInput2.default, { ref: 'searchInput',
												inputClassName: 'form-control',
												searchUrl: _config2.default.apiRoot + 'flettulisti/$s',
												onChange: this.inputChangeHandler,
												inputName: 'searchString',
												value: this.state.searchString,
												type: 'text',
												valueField: 'fletta',
												headerText: 'H\xE6gt er a\xF0 nota * og _ sem algildist\xE1kn.',
												onFocus: this.inputFocusHandler,
	
												onEnter: this.searchButtonClickHandler,
												onItemSelect: function onItemSelect(event) {
													_this2.setState({
														searchString: event.fletta
													}, function () {
														_this2.searchButtonClickHandler();
													});
												},
												placeholder: window.l('leita'),
												minChars: 3,
												selectedItemClass: 'active',
												disableAutoFill: false,
												listLabelFormatFunc: function listLabelFormatFunc(item) {
													return _react2.default.createElement(
														_react2.default.Fragment,
														null,
														_react2.default.createElement(
															'span',
															{ className: 'link' },
															item.fletta
														),
														_react2.default.createElement('br', null),
														_react2.default.createElement(
															'small',
															null,
															item.sofn
														)
													);
												}
											}),
											_react2.default.createElement(
												'span',
												{ className: 'input-group-btn' },
												_react2.default.createElement('button', { className: 'btn btn-default search-button', onClick: this.searchButtonClickHandler })
											)
										),
										_react2.default.createElement(
											'a',
											{ className: 'sam-logo', href: 'http://www.arnastofnun.is' },
											_react2.default.createElement('img', { className: 'single', alt: '\xC1rnastofnun', src: '/img/sam-logo-single.png' }),
											_react2.default.createElement('img', { className: 'full', alt: '\xC1rnastofnun', src: '/img/sam-logo.png' })
										)
									)
								)
							),
							_react2.default.createElement(_reactRouterDom.Route, { exact: true, strict: true, path: '/',
								render: function (routeProps) {
									var _this3 = this;
	
									if (routeProps.location.search && routeProps.location.search.substr(0, '?search='.length) === '?search=') {
										setTimeout(function () {
											if (_this3.refs.router) {
												_this3.refs.router.history.push('/leit/' + routeProps.location.search.replace('?search=', ''));
											}
										}, 100);
									}
									return _react2.default.createElement(_SearchResultsList2.default, { frontPage: true });
								}.bind(this) }),
							_react2.default.createElement(_reactRouterDom.Route, { strict: true, path: '/leit/:searchString',
								render: function (routeProps) {
									return _react2.default.createElement(_SearchResultsList2.default, Object.assign({ onSearch: function (event) {
											if (event.searchString !== this.state.searchString) {
												this.setState({
													searchString: event.searchString
												});
											}
										}.bind(this) }, routeProps));
								}.bind(this) }),
							_react2.default.createElement(_reactRouterDom.Route, { path: '/leit/:searchString/link',
								render: function render(routeProps) {
									return _react2.default.createElement(_LinkView2.default, routeProps);
								} })
						),
						_react2.default.createElement(
							'div',
							{ id: 'appMenu', className: 'main-menu' + (this.state.menuOpen ? ' open' : '') },
							_react2.default.createElement(
								'button',
								{ className: 'app-menu-button close-button', onClick: function () {
										this.setState({
											menuOpen: false
										});
									}.bind(this) },
								_react2.default.createElement(
									'span',
									{ className: 'hamburger-icon black open' },
									_react2.default.createElement('span', { className: 'icon-middle' }),
									_react2.default.createElement('span', { className: 'icon-before-after' })
								)
							),
							_react2.default.createElement(_AppMenu2.default, { ref: 'appMenu', menuOpen: this.state.menuOpen })
						),
						_react2.default.createElement(_GoogleAnalytics2.default, null),
						_react2.default.createElement(_MatomoVeftalning2.default, null)
					)
				);
			}
		}]);
	
		return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(4);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppMenu = function (_Component) {
	    _inherits(AppMenu, _Component);
	
	    function AppMenu(props) {
	        _classCallCheck(this, AppMenu);
	
	        var _this = _possibleConstructorReturn(this, (AppMenu.__proto__ || Object.getPrototypeOf(AppMenu)).call(this, props));
	
	        _this.toggleDarkMode = function (event) {
	            event.preventDefault();
	            var nextMode = !_this.state.darkMode;
	
	            _this.setState({ darkMode: nextMode }, function () {
	                document.body.classList.toggle('dark-mode', nextMode);
	                localStorage.setItem('theme', nextMode ? 'dark' : 'light');
	            });
	        };
	
	        _this.state = {
	            menuContent: null,
	            currentPage: -1,
	            darkMode: false
	        };
	        return _this;
	    }
	
	    _createClass(AppMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var savedTheme = localStorage.getItem('theme');
	            var mediaQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
	
	            var prefersDark = savedTheme ? savedTheme === 'dark' : mediaQuery && mediaQuery.matches;
	
	            if (prefersDark) {
	                document.body.classList.add('dark-mode');
	                this.setState({ darkMode: true });
	            }
	
	            if (!savedTheme && mediaQuery) {
	                this.handleSystemThemeChange = function (e) {
	                    if (!localStorage.getItem('theme')) {
	                        var isDark = e.matches;
	                        document.body.classList.toggle('dark-mode', isDark);
	                        _this2.setState({ darkMode: isDark });
	                    }
	                };
	
	                mediaQuery.addEventListener('change', this.handleSystemThemeChange);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var mediaQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
	            if (mediaQuery && this.handleSystemThemeChange) {
	                mediaQuery.removeEventListener('change', this.handleSystemThemeChange);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.menuOpen && !this.state.menuContent && !prevProps.menuOpen) {
	                this.fetchMenuContent();
	            }
	        }
	    }, {
	        key: 'fetchMenuContent',
	        value: function fetchMenuContent() {
	            var _this3 = this;
	
	            fetch(_config2.default.pageUrl + 'menu_' + window.currentLang + '_v2-2.json').then(function (res) {
	                return res.json();
	            }).then(function (json) {
	                return _this3.setState({ menuContent: json.results });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'menu-wrapper' + (this.state.currentPage > -1 ? ' main-visible' : ''), ref: 'menuContent' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'menu-content links' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        [{ lang: 'is', name: 'Íslenska' }, { lang: 'en', name: 'English' }].map(function (lang, index) {
	                            return _react2.default.createElement(
	                                'span',
	                                { key: lang.lang },
	                                index > 0 && _react2.default.createElement(
	                                    _react2.default.Fragment,
	                                    null,
	                                    ' | '
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: '#',
	                                        className: 'lang-button',
	                                        onClick: function onClick(event) {
	                                            event.preventDefault();
	                                            window.Lang.setCurrentLang(lang.lang);
	                                            _this4.fetchMenuContent();
	                                        }
	                                    },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        lang.name
	                                    )
	                                )
	                            );
	                        }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            ' | '
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'dark-mode-toggle', onClick: this.toggleDarkMode },
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                this.state.darkMode ? '☼ Dagshamur' : '☾ Nátthamur'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'menu-links' },
	                        this.state.menuContent && this.state.menuContent.map(function (item, index) {
	                            return _react2.default.createElement(
	                                'a',
	                                {
	                                    className: 'menu-link',
	                                    key: index,
	                                    onClick: function onClick() {
	                                        return _this4.setState({ currentPage: index });
	                                    }
	                                },
	                                item.titill
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'menu-content main' },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            className: 'menu-link',
	                            onClick: function onClick() {
	                                return _this4.setState({ currentPage: -1 });
	                            }
	                        },
	                        _react2.default.createElement('img', { className: 'menu-link-back-arrow', alt: 'Go back', src: '/img/back-icon.png' }),
	                        window.l('menu_back')
	                    ),
	                    this.state.currentPage > -1 && this.state.menuContent && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            this.state.menuContent[this.state.currentPage].titill
	                        ),
	                        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.menuContent[this.state.currentPage].efni } })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AppMenu;
	}(_react.Component);
	
	exports.default = AppMenu;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutocompleteInput = function (_Component) {
		_inherits(AutocompleteInput, _Component);
	
		function AutocompleteInput(props) {
			_classCallCheck(this, AutocompleteInput);
	
			var _this = _possibleConstructorReturn(this, (AutocompleteInput.__proto__ || Object.getPrototypeOf(AutocompleteInput)).call(this, props));
	
			_this.inputValueChangeHandler = _this.inputValueChangeHandler.bind(_this);
			_this.inputFocusHandler = _this.inputFocusHandler.bind(_this);
			_this.inputBlurHandler = _this.inputBlurHandler.bind(_this);
			_this.inputKeyDownHandler = _this.inputKeyDownHandler.bind(_this);
	
			_this.state = {
				inputValue: props.value || '',
				data: [],
				listIndex: -1
			};
			return _this;
		}
	
		_createClass(AutocompleteInput, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(props) {
				if (props.value !== this.state.inputValue) {
					this.setState({
						inputValue: props.value
					});
				}
			}
		}, {
			key: 'inputValueChangeHandler',
			value: function inputValueChangeHandler(event) {
				this.cancelled = false;
	
				event.persist();
	
				if (event.target.value === '') {
					this.setState({
						inputValue: '',
						data: [],
						listIndex: -1
					});
	
					if (this.props.onChange) {
						this.props.onChange({
							target: {
								name: this.props.inputName || '',
								value: ''
							}
						});
					}
				} else {
					this.setState({
						inputValue: event.target.value
					}, function () {
						if (this.state.inputValue.indexOf(',') > -1) {
							var inputStrings = this.state.inputValue.split(',');
							var searchValue = inputStrings[inputStrings.length - 1];
	
							if (searchValue !== '') {
								this.fetchData(searchValue);
							}
						} else {
							this.fetchData(this.state.inputValue);
						}
	
						if (this.props.onChange) {
							this.props.onChange(event);
						}
					}.bind(this));
				}
			}
		}, {
			key: 'inputKeyDownHandler',
			value: function inputKeyDownHandler(event) {
				this.cancelled = false;
	
				event.persist();
	
				if (event.keyCode === 38 && this.props.valueField) {
					// upp
					if (this.state.listIndex > 0) {
						this.setState({
							listIndex: this.state.listIndex - 1,
							inputValue: this.assignInputValue(this.props.valueField ? this.state.data[this.state.listIndex - 1][this.props.valueField] : this.state.data[this.state.listIndex - 1])
						}, function () {
							if (this.props.onChange) {
								this.props.onChange(event);
							}
						}.bind(this));
					}
				}
				if (event.keyCode === 40 && !this.props.disableAutoFill) {
					// niður
					if (this.state.listIndex < this.state.data.length && this.state.data[this.state.listIndex + 1]) {
						this.setState({
							listIndex: this.state.listIndex + 1,
							inputValue: this.assignInputValue(this.props.valueField ? this.state.data[this.state.listIndex + 1][this.props.valueField] : this.state.data[this.state.listIndex + 1])
						}, function () {
							if (this.props.onChange) {
								this.props.onChange(event);
							}
						}.bind(this));
					}
				}
				if (event.keyCode === 13) {
					// enter
					this.cancelled = true;
	
					if (this.state.listIndex > -1 && !this.props.disableAutoFill) {
						if (this.props.onItemSelect) {
							this.props.onItemSelect(this.state.data[this.state.listIndex]);
						}
	
						this.setState({
							listIndex: -1,
							data: []
						});
					} else {
						this.setState({
							listIndex: -1,
							data: []
						}, function () {
							if (this.props.onEnter) {
								this.props.onEnter();
							}
						}.bind(this));
					}
				}
			}
		}, {
			key: 'inputFocusHandler',
			value: function inputFocusHandler() {
				if (this.props.onFocus) {
					this.props.onFocus();
				}
			}
		}, {
			key: 'inputBlurHandler',
			value: function inputBlurHandler() {
				this.cancelled = true;
	
				setTimeout(function () {
					this.setState({
						data: [],
						listIndex: -1
					});
				}.bind(this), 200);
			}
		}, {
			key: 'assignInputValue',
			value: function assignInputValue(value) {
				if (this.props.disableAutoFill) {
					return;
				}
	
				var inputValue = this.state.inputValue;
	
				var ret = '';
	
				if (inputValue.indexOf(',') > -1) {
					var inputValues = inputValue.split(',');
					inputValues[inputValues.length - 1] = value;
	
					ret = inputValues.join(',');
				} else {
					ret = value;
				}
				return ret;
			}
		}, {
			key: 'itemClickHandler',
			value: function itemClickHandler(item, dataItem) {
				if (this.props.onItemSelect) {
					this.props.onItemSelect(dataItem);
				}
	
				this.setState({
					inputValue: this.assignInputValue(item)
				}, function () {
					if (this.props.onChange) {
						this.props.onChange({
							target: {
								name: this.props.inputName || '',
								value: this.state.inputValue
							}
						});
					}
				}.bind(this));
			}
		}, {
			key: 'fetchData',
			value: function fetchData(str) {
				if (this.waitingForFetch || this.props.minChars && str.length < this.props.minChars) {
					return;
				}
	
				this.waitingForFetch = true;
	
				fetch(this.props.searchUrl.replace('$s', str)).then(function (response) {
					return response.json();
				}).then(function (json) {
					if (!this.cancelled) {
						this.setState({
							data: this.props.dataFormatFunc ? this.props.dataFormatFunc(json[this.props.responseDataField || 'data']) : this.props.responseDataField ? json[this.props.responseDataField] : json,
							listIndex: -1
						});
					}
					this.waitingForFetch = false;
				}.bind(this)).catch(function (ex) {
					console.log('parsing failed', ex);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var items = this.state.data.map(function (item, index) {
					return _react2.default.createElement(
						'a',
						{ href: '#', key: index, className: 'list-group-item item' + (this.state.listIndex === index ? ' ' + (this.props.selectedItemClass || 'selected') : ''),
	
							onClick: function (event) {
								event.preventDefault();
								this.itemClickHandler(this.props.valueField ? item[this.props.valueField] : item, item);
							}.bind(this) },
						this.props.listLabelFormatFunc ? this.props.listLabelFormatFunc(item) : this.props.valueField ? item[this.props.valueField] : item
					);
				}.bind(this));
	
				if (items.length > 0) {
					document.body.classList.add('autocomplete-open');
				} else {
					document.body.classList.remove('autocomplete-open');
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: 'container', className: 'autocomplete-input' + (items.length > 0 ? ' open' : '') },
					_react2.default.createElement('input', { className: this.props.inputClassName,
						ref: 'inputField',
						type: 'text',
						name: this.props.inputName || '',
						value: this.state.inputValue,
						onChange: this.inputValueChangeHandler,
						onBlur: this.inputBlurHandler,
						onFocus: this.inputFocusHandler,
						onKeyDown: this.inputKeyDownHandler,
						placeholder: this.props.placeholder }),
					items.length > 0 && _react2.default.createElement(
						'div',
						{ className: 'autocomplete-list list-group' },
						this.props.headerText && _react2.default.createElement(
							'div',
							{ className: 'list-group-item list-group-item-light' },
							_react2.default.createElement(
								'small',
								null,
								this.props.headerText
							)
						),
						items
					)
				);
			}
		}]);
	
		return AutocompleteInput;
	}(_react.Component);
	
	exports.default = AutocompleteInput;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BinView = function (_Component) {
		_inherits(BinView, _Component);
	
		function BinView() {
			_classCallCheck(this, BinView);
	
			return _possibleConstructorReturn(this, (BinView.__proto__ || Object.getPrototypeOf(BinView)).apply(this, arguments));
		}
	
		_createClass(BinView, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: window.l('bin_title'),
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0,
						frontPage: this.props.frontPage,
						aboutText: window.l('bin_about'),
						database: 'bin_malid2' },
					this.props.data && this.props.data.map(function (item, index) {
						return item.flettur.map(function (fletta, flettaIndex) {
							return _react2.default.createElement(
								'p',
								{ className: 'card-text', key: index + '-' + (fletta.id || flettaIndex) },
								_react2.default.createElement(
									'a',
									{ href: 'http://bin.arnastofnun.is/leit/?id=' + fletta.id, target: '_blank' },
									item.lemma
								),
								' ',
								fletta.kennimyndir && fletta.kennimyndir.length > 0 ? fletta.kennimyndir + ', ' : '',
								_react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: fletta.ofl } })
							);
						});
					})
				);
			}
		}]);
	
		return BinView;
	}(_react.Component);
	
	exports.default = BinView;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlondalView = function (_Component) {
		_inherits(BlondalView, _Component);
	
		function BlondalView() {
			_classCallCheck(this, BlondalView);
	
			return _possibleConstructorReturn(this, (BlondalView.__proto__ || Object.getPrototypeOf(BlondalView)).apply(this, arguments));
		}
	
		_createClass(BlondalView, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: window.l('blondal_title'),
						subTitle: window.l('blondal_subtitle'),
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0,
						frontPage: this.props.frontPage,
						database: 'blondal',
						aboutText: window.l('blondal_about'),
						className: 'truncated' },
					this.props.data && this.props.data.map(function (item, index) {
	
						return _react2.default.createElement(
							_react2.default.Fragment,
							{ key: index },
							index > 0 && _react2.default.createElement('hr', { className: 'divider' }),
							_react2.default.createElement(
								'p',
								{ className: 'card-text' + (item.fletta.length > 1000 ? ' preview' : '') },
								_react2.default.createElement(
									'em',
									null,
									item.bok
								),
								_react2.default.createElement('br', null),
								_react2.default.createElement('br', null),
								_react2.default.createElement('span', { className: 'font-andron', dangerouslySetInnerHTML: { __html: item.fletta } })
							),
							_react2.default.createElement(
								'p',
								{ className: 'card-text' },
								_react2.default.createElement(
									'a',
									{ target: 'blank', className: 'text-light', href: 'https://blondal.arnastofnun.is/faersla/' + item.id },
									'Sj\xE1 f\xE6rslu \xED or\xF0ab\xF3k'
								)
							)
						);
					})
				);
			}
		}]);
	
		return BlondalView;
	}(_react.Component);
	
	exports.default = BlondalView;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(3);
	
	var _config = __webpack_require__(4);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoogleAnalytics = function (_React$Component) {
		_inherits(GoogleAnalytics, _React$Component);
	
		function GoogleAnalytics() {
			_classCallCheck(this, GoogleAnalytics);
	
			return _possibleConstructorReturn(this, (GoogleAnalytics.__proto__ || Object.getPrototypeOf(GoogleAnalytics)).apply(this, arguments));
		}
	
		_createClass(GoogleAnalytics, [{
			key: 'componentWillUpdate',
			value: function componentWillUpdate(_ref) {
				var location = _ref.location,
				    history = _ref.history;
	
				var gtag = window.gtag;
	
				if (location.pathname === this.props.location.pathname) {
					// don't log identical link clicks (nav links likely)
					return;
				}
	
				if (history.action === 'PUSH' && typeof gtag === 'function') {
					var pageViewData = {
						'page_title': document.title,
						'page_location': window.location.href,
						'page_path': location.pathname
					};
	
					gtag('config', _config2.default.gaTrackingId, pageViewData);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return null;
			}
		}]);
	
		return GoogleAnalytics;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouterDom.withRouter)(GoogleAnalytics);

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IslexView = function (_Component) {
		_inherits(IslexView, _Component);
	
		function IslexView() {
			_classCallCheck(this, IslexView);
	
			return _possibleConstructorReturn(this, (IslexView.__proto__ || Object.getPrototypeOf(IslexView)).apply(this, arguments));
		}
	
		_createClass(IslexView, [{
			key: 'render',
			value: function render() {
				var langPath = ['EN', 'POL'].includes(this.props.lang) ? '' : '/tungumal/' + this.props.lang;
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: this.props.frontPage ? this.props.subTitle : this.props.title || window.l('islex_title'),
						subTitle: this.props.frontPage ? null : this.props.subTitle === this.props.title ? null : this.props.subTitle,
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0, forceHidden: this.props.hideOnFrontPage && this.props.frontPage,
						frontPage: this.props.frontPage,
						aboutText: this.props.aboutText || window.l('islex_about'),
						includeFlags: true,
						database: 'islex_' + this.props.lang },
					this.props.data && this.props.data.map(function (item, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'card-text', key: index },
							index > 0 && _react2.default.createElement('hr', { className: 'divider' }),
							!this.props.hideUrl && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								_react2.default.createElement(
									'a',
									{ target: '_blank', href: (this.props.url || 'http://islex.arnastofnun.is') + '/is/ord/' + item.id + langPath },
									item.fletta
								),
								' ',
								item.ordflokkur
							),
							this.props.hideUrl && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								_react2.default.createElement(
									'strong',
									null,
									item.fletta
								),
								' ',
								item.ordflokkur
							),
							item.lidir && item.lidir.length > 0 && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								_react2.default.createElement('br', null),
								_react2.default.createElement('br', null),
								item.lidir.map(function (lidur, lIndex) {
									return _react2.default.createElement(
										'div',
										{ className: 'lidir', key: lIndex },
										_react2.default.createElement(
											'strong',
											null,
											lidur.num
										),
										' ',
										lidur.target_lang !== '' && _react2.default.createElement(
											_react2.default.Fragment,
											null,
											lidur.target_lang,
											lidur.zmerking ? ' ' + lidur.zmerking : '',
											_react2.default.createElement('br', null)
										),
										lidur.tl_skyring && _react2.default.createElement(
											_react2.default.Fragment,
											null,
											lidur.tl_skyring,
											_react2.default.createElement('br', null)
										)
									);
								})
							),
							item.merking && item.merking.length > 0 && item.merking[0].target_lang !== '' && _react2.default.createElement(
								'div',
								{ className: 'merking' },
								_react2.default.createElement('hr', null),
								item.merking.map(function (merking, mIndex) {
									return _react2.default.createElement(
										_react2.default.Fragment,
										{ key: mIndex },
										merking.target_lang,
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										merking.daemalisti && merking.daemalisti.length > 0 && merking.daemalisti.map(function (daemi, dIndex) {
											return _react2.default.createElement(
												_react2.default.Fragment,
												{ key: dIndex },
												_react2.default.createElement(
													'div',
													{ className: 'daemi-thyding' },
													_react2.default.createElement(
														'em',
														null,
														_react2.default.createElement(
															'strong',
															null,
															daemi.daemi
														)
													),
													_react2.default.createElement('br', null),
													_react2.default.createElement(
														'p',
														{ className: 'thyding' },
														daemi.thyding
													)
												)
											);
										})
									);
								})
							),
							item.ordasambandalisti && item.ordasambandalisti.length > 0 && _react2.default.createElement(
								'div',
								{ className: 'ordasambond' },
								_react2.default.createElement('hr', null),
								item.ordasambandalisti.map(function (ordasamband, osIndex) {
									return _react2.default.createElement(
										_react2.default.Fragment,
										{ key: osIndex },
										_react2.default.createElement(
											'div',
											{ className: 'daemi-thyding' },
											_react2.default.createElement(
												'em',
												null,
												_react2.default.createElement(
													'strong',
													null,
													ordasamband.ordasamband
												)
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement(
												'p',
												{ className: 'thyding' },
												ordasamband.thyding.split("''").join("'"),
												_react2.default.createElement('br', null)
											)
										)
									);
								})
							),
							item.skyring && item.skyring.map(function (skyring, skIndex) {
								return _react2.default.createElement(
									_react2.default.Fragment,
									{ key: skIndex },
									skyring.texti,
									_react2.default.createElement('br', null)
								);
							}),
							item.daemi && item.daemi.map(function (daemi, dIndex) {
								return _react2.default.createElement(
									_react2.default.Fragment,
									{ key: dIndex },
									_react2.default.createElement(
										'strong',
										null,
										_react2.default.createElement(
											'em',
											null,
											daemi.texti
										)
									),
									_react2.default.createElement('br', null)
								);
							}),
							item.sostaeda && item.sostaeda.map(function (sostaeda, dIndex) {
								return _react2.default.createElement(
									_react2.default.Fragment,
									{ key: dIndex },
									sostaeda.texti,
									_react2.default.createElement('br', null),
									sostaeda.skyring && sostaeda.skyring.map(function (skyring, skIndex) {
										return _react2.default.createElement(
											'div',
											{ className: 'ml-4' },
											skyring.texti
										);
									})
								);
							}),
							item.ostaeda && item.ostaeda.map(function (ostaeda, dIndex) {
								return _react2.default.createElement(
									_react2.default.Fragment,
									{ key: dIndex },
									ostaeda.texti,
									_react2.default.createElement('br', null),
									ostaeda.skyring && ostaeda.skyring.map(function (skyring, skIndex) {
										return _react2.default.createElement(
											'div',
											{ className: 'ml-4' },
											skyring.texti
										);
									})
								);
							}),
							!this.props.hideUrl && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									'a',
									{ target: '_blank',
										className: 'text-light',
										href: (this.props.url || 'http://islex.arnastofnun.is') + '/is/ord/' + item.id + langPath },
									item.merking_fjoldi === 1 ? 'Fara í orðabók' : 'Sj\xE1 ' + item.merking_fjoldi + ' merkingar \xED or\xF0ab\xF3k'
								)
							)
						);
					}.bind(this))
				);
			}
		}]);
	
		return IslexView;
	}(_react.Component);
	
	exports.default = IslexView;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KataView = function (_Component) {
		_inherits(KataView, _Component);
	
		function KataView() {
			_classCallCheck(this, KataView);
	
			return _possibleConstructorReturn(this, (KataView.__proto__ || Object.getPrototypeOf(KataView)).apply(this, arguments));
		}
	
		_createClass(KataView, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: window.l('kata_title'),
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0,
						frontPage: this.props.frontPage,
						aboutText: window.l('kata_about'),
						database: 'kata' },
					this.props.data && this.props.data.map(function (item, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'card-text', key: index },
							index > 0 && _react2.default.createElement('hr', { className: 'divider' }),
							_react2.default.createElement(
								'a',
								{ target: 'blank', href: 'https://islenskordabok.arnastofnun.is/ord/' + item.id },
								item.fletta
							),
							' ',
							item.ordflokkur,
							item.lidur && item.lidur.length > 0 && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								_react2.default.createElement('br', null),
								_react2.default.createElement('br', null),
								item.lidur.map(function (lidur, lIndex) {
									return _react2.default.createElement(
										'div',
										{ className: 'lidir', key: lIndex },
										lIndex > 0 && _react2.default.createElement('hr', null),
										_react2.default.createElement(
											'strong',
											null,
											lidur.numer
										),
										' ',
										lidur.skyring && lidur.skyring.map(function (lSkyring, lsIndex) {
											return _react2.default.createElement(
												_react2.default.Fragment,
												{ key: lsIndex },
												lSkyring.skyring,
												_react2.default.createElement('br', null)
											);
										}),
										lidur.daemalisti && lidur.daemalisti.map(function (daemi, dIndex) {
											return _react2.default.createElement(
												_react2.default.Fragment,
												{ key: dIndex },
												dIndex === 0 && _react2.default.createElement('br', null),
												_react2.default.createElement(
													'small',
													null,
													'D\xE6mi: '
												),
												_react2.default.createElement(
													'em',
													null,
													daemi.daemi
												),
												_react2.default.createElement('br', null)
											);
										}),
										lidur.ostaedur && lidur.ostaedur.map(function (ostaeda, oIndex) {
											return _react2.default.createElement(
												_react2.default.Fragment,
												{ key: oIndex },
												oIndex === 0 && _react2.default.createElement('br', null),
												_react2.default.createElement(
													'em',
													null,
													ostaeda.ostaeda
												),
												_react2.default.createElement('br', null)
											);
										})
									);
								})
							),
							item.merking && item.merking.length > 0 && item.merking[0].target_lang !== '' && _react2.default.createElement(
								'div',
								{ className: 'merking' },
								_react2.default.createElement('hr', null),
								item.merking.map(function (merking, mIndex) {
									return _react2.default.createElement(
										_react2.default.Fragment,
										{ key: mIndex },
										merking.target_lang,
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										merking.daemalisti && merking.daemalisti.length > 0 && merking.daemalisti.map(function (daemi, dIndex) {
											return _react2.default.createElement(
												_react2.default.Fragment,
												{ key: dIndex },
												_react2.default.createElement(
													'em',
													null,
													_react2.default.createElement(
														'strong',
														null,
														daemi.daemi
													)
												),
												_react2.default.createElement('br', null),
												daemi.thyding
											);
										})
									);
								})
							),
							item.ordasambandalisti && item.ordasambandalisti.length > 0 && _react2.default.createElement(
								'div',
								{ className: 'ordasambond' },
								_react2.default.createElement('hr', null),
								item.ordasambandalisti.map(function (ordasamband, osIndex) {
									return _react2.default.createElement(
										_react2.default.Fragment,
										{ key: osIndex },
										_react2.default.createElement(
											'em',
											null,
											_react2.default.createElement(
												'strong',
												null,
												ordasamband.ordasamband
											)
										),
										_react2.default.createElement('br', null),
										ordasamband.thyding,
										_react2.default.createElement('br', null)
									);
								})
							),
							item.skyring && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								_react2.default.createElement('br', null),
								item.skyring.map(function (skyring, skIndex) {
									return _react2.default.createElement(
										_react2.default.Fragment,
										{ key: skIndex },
										skyring.skyring,
										_react2.default.createElement('br', null)
									);
								})
							),
							item.daemi && item.daemi.map(function (daemi, dIndex) {
								return _react2.default.createElement(
									_react2.default.Fragment,
									{ key: dIndex },
									_react2.default.createElement(
										'strong',
										null,
										_react2.default.createElement(
											'em',
											null,
											daemi.texti
										)
									),
									_react2.default.createElement('br', null)
								);
							}),
							item.sostaeda && item.sostaeda.map(function (sostaeda, dIndex) {
								return _react2.default.createElement(
									_react2.default.Fragment,
									{ key: dIndex },
									sostaeda.texti,
									_react2.default.createElement('br', null),
									sostaeda.skyring && sostaeda.skyring.map(function (skyring, skIndex) {
										return _react2.default.createElement(
											'div',
											{ className: 'ml-4' },
											skyring.texti
										);
									})
								);
							}),
							item.ostaeda && item.ostaeda.map(function (ostaeda, dIndex) {
								return _react2.default.createElement(
									_react2.default.Fragment,
									{ key: dIndex },
									ostaeda.texti,
									_react2.default.createElement('br', null),
									ostaeda.skyring && ostaeda.skyring.map(function (skyring, skIndex) {
										return _react2.default.createElement(
											'div',
											{ className: 'ml-4' },
											skyring.texti
										);
									})
								);
							}),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'a',
								{ target: 'blank', className: 'text-light', href: 'https://islenskordabok.arnastofnun.is/ord/' + item.id },
								item.fj_merkinga === 1 ? 'Fara í orðabók' : 'Sjá ' + item.fj_merkinga + ' merkingar í orðabók'
							)
						);
					})
				);
			}
		}]);
	
		return KataView;
	}(_react.Component);
	
	exports.default = KataView;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkView = function (_Component) {
		_inherits(LinkView, _Component);
	
		function LinkView() {
			_classCallCheck(this, LinkView);
	
			return _possibleConstructorReturn(this, (LinkView.__proto__ || Object.getPrototypeOf(LinkView)).apply(this, arguments));
		}
	
		_createClass(LinkView, [{
			key: 'render',
			value: function render() {
				var link = this.props.location.search.replace('?link=', '');
				return _react2.default.createElement(
					'div',
					{ className: 'link-view' },
					_react2.default.createElement(
						'div',
						{ className: 'link-header', onClick: function () {
								this.props.history.push('/leit/' + this.props.match.params.searchString);
							}.bind(this) },
						link
					),
					_react2.default.createElement(
						'div',
						{ className: 'frame-container' },
						_react2.default.createElement('iframe', { className: 'link-frame', width: '100%', border: '0', src: link })
					)
				);
			}
		}]);
	
		return LinkView;
	}(_react.Component);
	
	exports.default = LinkView;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MalfarView = function (_Component) {
		_inherits(MalfarView, _Component);
	
		function MalfarView() {
			_classCallCheck(this, MalfarView);
	
			return _possibleConstructorReturn(this, (MalfarView.__proto__ || Object.getPrototypeOf(MalfarView)).apply(this, arguments));
		}
	
		_createClass(MalfarView, [{
			key: 'cleanHtml',
			value: function cleanHtml(html) {
				if (!html) return '';
				var parser = new DOMParser();
				var doc = parser.parseFromString(html, 'text/html');
	
				doc.querySelectorAll('[style]').forEach(function (el) {
					return el.removeAttribute('style');
				});
	
				return doc.body.innerHTML;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: window.l('malfar_title'),
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0,
						frontPage: this.props.frontPage,
						database: 'malfar',
						aboutText: window.l('malfar_about'),
						className: 'truncated' },
					this.props.data && this.props.data.map(function (item, index) {
						return _react2.default.createElement(
							_react2.default.Fragment,
							{ key: index },
							index > 0 && _react2.default.createElement('hr', null),
							item.flokkur_nr === 57 && _react2.default.createElement(
								'p',
								{ className: 'card-text' },
								_react2.default.createElement(
									'em',
									null,
									'\xDAr pistlum J\xF3ns G. Fri\xF0j\xF3nssonar'
								)
							),
							item.flokkur_nr === 60 && _react2.default.createElement(
								'p',
								{ className: 'card-text' },
								_react2.default.createElement(
									'em',
									null,
									'\xDAr \xCDslensku m\xE1li, \xFE\xE1ttum J\xF3ns G. Fri\xF0j\xF3nssonar'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'card-text' + (item.faersla.length > 1000 ? ' preview' : '') },
								_react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: _this2.cleanHtml(item.faersla) } })
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'a',
									{ target: 'blank', className: 'text-light', href: 'http://malfar.arnastofnun.is/grein/' + item.id },
									'Lesa grein \xED m\xE1lfarsbanka'
								)
							)
						);
					})
				);
			}
		}]);
	
		return MalfarView;
	}(_react.Component);
	
	exports.default = MalfarView;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MatomoVeftalning = function (_React$Component) {
		_inherits(MatomoVeftalning, _React$Component);
	
		function MatomoVeftalning() {
			_classCallCheck(this, MatomoVeftalning);
	
			return _possibleConstructorReturn(this, (MatomoVeftalning.__proto__ || Object.getPrototypeOf(MatomoVeftalning)).apply(this, arguments));
		}
	
		_createClass(MatomoVeftalning, [{
			key: 'componentWillUpdate',
			value: function componentWillUpdate(_ref) {
				var location = _ref.location,
				    history = _ref.history;
	
				if (window._paq && window._paq.push) {
					var _paq = window._paq;
	
					if (location.pathname === this.props.location.pathname) {
						return;
					}
	
					_paq.push(['setCustomUrl', location.pathname]);
					_paq.push(['setDocumentTitle', document.title]);
					_paq.push(['trackPageView']);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return null;
			}
		}]);
	
		return MatomoVeftalning;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouterDom.withRouter)(MatomoVeftalning);

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NyyrdiView = function (_Component) {
		_inherits(NyyrdiView, _Component);
	
		function NyyrdiView() {
			_classCallCheck(this, NyyrdiView);
	
			return _possibleConstructorReturn(this, (NyyrdiView.__proto__ || Object.getPrototypeOf(NyyrdiView)).apply(this, arguments));
		}
	
		_createClass(NyyrdiView, [{
			key: 'formatDate',
			value: function formatDate(dateStr) {
				var months = ['janúar', 'febrúar', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'september', 'október', 'nóvember', 'desember'];
	
				try {
					var d = new Date(dateStr);
	
					return d.getDate() + '. ' + months[d.getMonth()] + ' ' + d.getFullYear();
				} catch (e) {
					console.log(e);
					return '';
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: window.l('nyyrdi_title'),
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0,
						frontPage: this.props.frontPage,
						aboutText: window.l('nyyrdi_about'),
						database: 'nyyrdi' },
					this.props.data && this.props.data.map(function (item, index) {
	
						return _react2.default.createElement(
							_react2.default.Fragment,
							{ key: index },
							index > 0 && _react2.default.createElement('hr', null),
							_react2.default.createElement(
								'p',
								{ className: 'card-text' },
								_react2.default.createElement(
									'a',
									{ target: 'blank', href: 'https://nyyrdi.arnastofnun.is/nyyrdi/' + item.id },
									_react2.default.createElement(
										'strong',
										null,
										item.nyyrdi
									)
								),
								', ',
								item.ordflokkur
							),
							item.skyring && item.skyring.length > 0 && item.skyring.map(function (skyring, skIndex) {
								return _react2.default.createElement(
									_react2.default.Fragment,
									{ key: skIndex },
									skIndex > 0 && _react2.default.createElement('hr', null),
									_react2.default.createElement(
										'p',
										{ className: 'card-text' },
										skyring
									)
								);
							}),
							_react2.default.createElement(
								'p',
								{ className: 'card-text' },
								_react2.default.createElement(
									'em',
									null,
									'Skr\xE1\xF0 ',
									this.formatDate(item.skraningardagur)
								)
							)
						);
					}.bind(this))
				);
			}
		}]);
	
		return NyyrdiView;
	}(_react.Component);
	
	exports.default = NyyrdiView;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ONPView = function (_Component) {
	  _inherits(ONPView, _Component);
	
	  function ONPView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ONPView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ONPView.__proto__ || Object.getPrototypeOf(ONPView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      onpData: [],
	      loading: false,
	      error: null
	    }, _this.extractIds = function (data) {
	      if (!data) return [];
	
	      var arr = Array.isArray(data) ? data : [data];
	      var ids = [];
	
	      for (var i = 0; i < arr.length; i++) {
	        if (arr[i] && arr[i].id) {
	          ids.push(arr[i].id);
	        }
	      }
	
	      return ids;
	    }, _this.loadData = function (props) {
	      var ids = _this.extractIds(props.data);
	
	      if (!ids.length) {
	        _this.setState({ onpData: [], loading: false, error: null });
	        return;
	      }
	
	      _this.setState({ loading: true, error: null, onpData: [] });
	
	      var requests = ids.map(function (id) {
	        return fetch("https://onp.ku.dk/json/onp/" + id).then(function (res) {
	          return res.json();
	        });
	      });
	
	      Promise.all(requests).then(function (results) {
	        _this.setState({ onpData: results, loading: false });
	      }).catch(function (err) {
	        console.error(err);
	        _this.setState({ error: err, loading: false });
	      });
	    }, _this.cleanONPText = function (str) {
	      return str;
	      if (!str) return "";
	
	      return str.replace(/<\\u[0-9a-fA-F]{4}.*?>/g, "").replace(/●+/g, "").replace(/\u2e22/g, "").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").replace(/<(?!\/?u\b)[^>]+>/g, "").replace(/^[IVX]+\.\s*/i, "").replace(/^\d+\)\s*/, "").trim();
	    }, _this.getTotalExampleCount = function (item) {
	      if (!item || !Array.isArray(item.senses)) {
	        return 0;
	      }
	
	      return item.senses.reduce(function (total, sense) {
	        var examples = sense["ontolex:example"];
	
	        if (!Array.isArray(examples)) {
	          return total;
	        }
	
	        return total + examples.length;
	      }, 0);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ONPView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.loadData(this.props);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var prevIds = this.extractIds(prevProps.data);
	      var newIds = this.extractIds(this.props.data);
	
	      if (JSON.stringify(prevIds) !== JSON.stringify(newIds)) {
	        this.loadData(this.props);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.onpData;
	
	      if (!data || !Array.isArray(data)) {
	        data = [];
	      }
	
	      return _react2.default.createElement(
	        _MalidCard2.default,
	        {
	          title: window.l("onp_title"),
	          count: this.props.count || data.length,
	          visible: data.length > 0,
	          frontPage: this.props.frontPage,
	          database: "onp",
	          aboutText: window.l("onp_about"),
	          className: "truncated"
	        },
	        this.state.loading && _react2.default.createElement(
	          "div",
	          null,
	          "S\xE6ki g\xF6gn \u2026"
	        ),
	        this.state.error && _react2.default.createElement(
	          "div",
	          null,
	          "G\xF6gn vantar"
	        ),
	        !this.state.loading && data.length === 0 && _react2.default.createElement(
	          "div",
	          null,
	          "G\xF6gn vantar"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "onp-senses-container" },
	          data.map(function (item, index) {
	            var writtenRep = item && item.canonicalForm && item.canonicalForm.writtenRep ? item.canonicalForm.writtenRep : "—";
	
	            var oldestCitation = item && item["onp-oldest-citation"] ? item["onp-oldest-citation"] : {};
	
	            return _react2.default.createElement(
	              "div",
	              { className: "onp-sense-container", key: "data-item-" + index },
	              _react2.default.createElement(
	                "strong",
	                { className: "onp-lemma" },
	                writtenRep
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "onp-example-container" },
	                _react2.default.createElement(
	                  "u",
	                  { className: "onp-example-title" },
	                  "Elsta d\xE6mi:"
	                ),
	                _react2.default.createElement("p", { className: "onp-example-text", dangerouslySetInnerHTML: { __html: _this2.cleanONPText(oldestCitation["citation-text"]) } }),
	                _react2.default.createElement(
	                  "a",
	                  { href: oldestCitation["canonical-uri"], target: "_blank", className: "onp-citation-text" },
	                  "(",
	                  oldestCitation["work-title"],
	                  ", ",
	                  oldestCitation["msdate"],
	                  ")"
	                )
	              ),
	              item && item["onp-canonicalurl"] && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "a",
	                  { className: "text-light", href: item["onp-canonicalurl"], target: "_blank", rel: "noopener noreferrer" },
	                  window.l("open_dict_generic"),
	                  " (",
	                  _this2.getTotalExampleCount(item),
	                  " d\xE6mi)"
	                )
	              ),
	              index < data.length - 1 && _react2.default.createElement("hr", { className: "onp-item-divider" })
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ONPView;
	}(_react.Component);
	
	exports.default = ONPView;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrdabankiView = function (_Component) {
		_inherits(OrdabankiView, _Component);
	
		function OrdabankiView() {
			_classCallCheck(this, OrdabankiView);
	
			return _possibleConstructorReturn(this, (OrdabankiView.__proto__ || Object.getPrototypeOf(OrdabankiView)).apply(this, arguments));
		}
	
		_createClass(OrdabankiView, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: window.l('ordabanki_title'),
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0,
						frontPage: this.props.frontPage,
						aboutText: window.l('ordabanki_about'),
						database: 'ordabanki' },
					this.props.data && this.props.data.map(function (item, index) {
						return _react2.default.createElement(
							_react2.default.Fragment,
							{ key: index },
							index > 0 && _react2.default.createElement('hr', { className: 'divider' }),
							_react2.default.createElement(
								'p',
								{ className: 'card-text', key: index },
								_react2.default.createElement(
									'a',
									{ target: '_blank', href: 'https://idordabanki.arnastofnun.is/faersla/' + item.id_hugtak },
									_react2.default.createElement(
										'strong',
										null,
										item.hugtak_ord
									)
								),
								_react2.default.createElement('br', null),
								'[',
								item.ordasafn,
								']',
								item.sersvid && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									' (',
									_react2.default.createElement(
										'em',
										null,
										item.sersvid
									),
									')'
								),
								_react2.default.createElement('br', null),
								item.samheiti && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									_react2.default.createElement(
										'strong',
										null,
										'samheiti'
									),
									' ',
									item.samheiti.map(function (samheiti, sIndex) {
										return _react2.default.createElement(
											_react2.default.Fragment,
											{ key: sIndex },
											sIndex > 0 && _react2.default.createElement(
												_react2.default.Fragment,
												null,
												', '
											),
											samheiti.sh
										);
									}),
									_react2.default.createElement('br', null)
								),
								item.skilgreining && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									'[skilgreining] ',
									_react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: item.skilgreining } }),
									_react2.default.createElement('br', null)
								),
								item.skyring && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									'[sk\xFDring] ',
									_react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: item.skyring } }),
									_react2.default.createElement('br', null)
								),
								item.thyding && item.thyding.map(function (thyding, tIndex) {
									return _react2.default.createElement(
										_react2.default.Fragment,
										{ key: tIndex },
										'[',
										thyding.tungumal,
										'] ',
										_react2.default.createElement(
											'strong',
											null,
											thyding.erlent_ord
										),
										_react2.default.createElement('br', null)
									);
								})
							)
						);
					})
				);
			}
		}]);
	
		return OrdabankiView;
	}(_react.Component);
	
	exports.default = OrdabankiView;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	var _helpers = __webpack_require__(10);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrdanetView = function (_Component) {
		_inherits(OrdanetView, _Component);
	
		function OrdanetView() {
			_classCallCheck(this, OrdanetView);
	
			return _possibleConstructorReturn(this, (OrdanetView.__proto__ || Object.getPrototypeOf(OrdanetView)).apply(this, arguments));
		}
	
		_createClass(OrdanetView, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: window.l('ordanet_title'),
						subTitle: window.l('ordanet_subtitle'),
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0,
						frontPage: this.props.frontPage,
						aboutText: window.l('ordanet_about'),
						database: 'ordanet' },
					this.props.data && this.props.data.map(function (item, index) {
						var flettuLink = item.samheitavensl + item.parast + item.hugtakavensl + item.samsetningar === 0;
	
						return _react2.default.createElement(
							_react2.default.Fragment,
							{ key: index },
							index > 0 && _react2.default.createElement('hr', { className: 'divider' }),
							_react2.default.createElement(
								'p',
								{ className: 'card-text' },
								_react2.default.createElement(
									'a',
									{ target: '_blank', href: 'https://ordanet.arnastofnun.is/fletta/' + (flettuLink ? item.fletta : item.id) },
									item.fletta
								),
								' ',
								item.ordflokkur,
								item.greining ? ' ' + item.greining : '',
								_react2.default.createElement('br', null),
								item.samheitavensl > 0 && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									'Samheitavensl vi\xF0 ',
									item.samheitavensl,
									' ',
									_helpers2.default.plural('flettu', 'flettur', item.samheitavensl),
									'. Sj\xE1 ',
									_react2.default.createElement(
										'a',
										{ target: '_blank', className: 'text-light', href: 'https://ordanet.arnastofnun.is/fletta/grannheiti/' + item.id },
										'grannheiti'
									),
									' og ',
									_react2.default.createElement(
										'a',
										{ target: '_blank', className: 'text-light', href: 'https://ordanet.arnastofnun.is/fletta/metin_vensl/' + item.id },
										'metin vensl'
									),
									'.',
									_react2.default.createElement('br', null)
								),
								item.parast > 0 && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									'Parast vi\xF0 ',
									item.parast,
									' ',
									_helpers2.default.plural('flettu', 'flettur', item.parast),
									'. Sj\xE1 ',
									_react2.default.createElement(
										'a',
										{ target: '_blank', className: 'text-light', href: 'https://ordanet.arnastofnun.is/fletta/por/' + item.id },
										_helpers2.default.plural('par', 'pör', item.parast)
									),
									' og ',
									_react2.default.createElement(
										'a',
										{ target: '_blank', className: 'text-light', href: 'https://ordanet.arnastofnun.is/fletta/skyldheiti/' + item.id },
										'skyldheiti'
									),
									'.',
									_react2.default.createElement('br', null)
								),
								item.hugtakavensl > 0 && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									'Tengist ',
									item.hugtakavensl,
									' ',
									_helpers2.default.plural('flettu', 'flettum', item.hugtakavensl),
									' innan hugtakanna ',
									_react2.default.createElement(
										_react2.default.Fragment,
										null,
										item.hugtok.map(function (hugtak, hIndex) {
											return _react2.default.createElement(
												_react2.default.Fragment,
												{ key: hIndex },
												hIndex > 0 && hIndex === item.hugtok.length - 1 && _react2.default.createElement(
													_react2.default.Fragment,
													null,
													' og '
												),
												hIndex > 0 && hIndex < item.hugtok.length - 1 && item.hugtok.length > 1 && _react2.default.createElement(
													_react2.default.Fragment,
													null,
													', '
												),
												_react2.default.createElement(
													'a',
													{ target: '_blank', className: 'text-light', href: 'https://ordanet.arnastofnun.is/fletta/hugtok/' + (hugtak.id || hugtak.hugtak) },
													hugtak.hugtak
												)
											);
										})
									),
									_react2.default.createElement('br', null)
								),
								item.samsetningar > 0 && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									'Li\xF0ur \xED ',
									item.samsetningar,
									' ',
									_react2.default.createElement(
										'a',
										{ target: '_blank', className: 'text-light', href: 'https://ordanet.arnastofnun.is/fletta/samsett/' + item.id },
										_helpers2.default.plural('samsetningu', 'samsetningum', item.samsetningar)
									),
									'.',
									_react2.default.createElement('br', null)
								),
								item.fleiryrt > 0 && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									'Li\xF0ur \xED ',
									item.fleiryrt,
									' ',
									_helpers2.default.plural('fleiryrtri flettu', 'fleiryrtum flettum', item.fleiryrt),
									'.',
									_react2.default.createElement('br', null)
								)
							)
						);
					})
				);
			}
		}]);
	
		return OrdanetView;
	}(_react.Component);
	
	exports.default = OrdanetView;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrdsifjabokView = function (_Component) {
	  _inherits(OrdsifjabokView, _Component);
	
	  function OrdsifjabokView() {
	    _classCallCheck(this, OrdsifjabokView);
	
	    return _possibleConstructorReturn(this, (OrdsifjabokView.__proto__ || Object.getPrototypeOf(OrdsifjabokView)).apply(this, arguments));
	  }
	
	  _createClass(OrdsifjabokView, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _MalidCard2.default,
	        {
	          title: window.l("ordsifjabok_title"),
	          subTitle: window.l("ordsifjabok_subtitle"),
	          count: this.props.count,
	          visible: this.props.data && this.props.data.length > 0,
	          frontPage: this.props.frontPage,
	          aboutText: window.l("ordsifjabok_about"),
	          database: "ordsifjabok"
	        },
	        this.props.data && this.props.data.filter(function (item, index, self) {
	          return self.findIndex(function (t) {
	            return t.id === item.id;
	          }) === index;
	        }).map(function (item, index) {
	          return _react2.default.createElement(
	            _react2.default.Fragment,
	            { key: index },
	            index > 0 && _react2.default.createElement("hr", null),
	            _react2.default.createElement("p", { className: "card-text font-andron", key: index, dangerouslySetInnerHTML: { __html: item.faersla_html } }),
	            _react2.default.createElement(
	              "p",
	              { className: "card-text" },
	              _react2.default.createElement(
	                "a",
	                { target: "_blank", href: "https://ordsifjabok.arnastofnun.is/faersla/" + item.id, className: "text-light" },
	                "Sj\xE1 f\xE6rslu \xED or\xF0ab\xF3k"
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return OrdsifjabokView;
	}(_react.Component);
	
	exports.default = OrdsifjabokView;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlondalView = function (_Component) {
		_inherits(BlondalView, _Component);
	
		function BlondalView() {
			_classCallCheck(this, BlondalView);
	
			return _possibleConstructorReturn(this, (BlondalView.__proto__ || Object.getPrototypeOf(BlondalView)).apply(this, arguments));
		}
	
		_createClass(BlondalView, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: window.l('ritmalssafn_title'),
						subTitle: window.l('ritmalssafn_subtitle'),
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0,
						frontPage: this.props.frontPage,
						aboutText: window.l('ritmalssafn_about'),
						database: 'ritmalssafn' },
					this.props.data && this.props.data.map(function (item, index) {
						return _react2.default.createElement(
							_react2.default.Fragment,
							{ key: index },
							index > 0 && _react2.default.createElement('hr', null),
							_react2.default.createElement(
								'p',
								{ className: 'card-text', key: index },
								_react2.default.createElement(
									'strong',
									null,
									_react2.default.createElement(
										'a',
										{ target: '_blank', href: 'http://ritmalssafn.arnastofnun.is/daemi/' + item.id },
										item.fletta
									)
								),
								' ',
								item.ordflokkur,
								_react2.default.createElement('br', null),
								item.fjoldi_aldur
							)
						);
					})
				);
			}
		}]);
	
		return BlondalView;
	}(_react.Component);
	
	exports.default = BlondalView;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RussneskaView = function (_Component) {
		_inherits(RussneskaView, _Component);
	
		function RussneskaView() {
			_classCallCheck(this, RussneskaView);
	
			return _possibleConstructorReturn(this, (RussneskaView.__proto__ || Object.getPrototypeOf(RussneskaView)).apply(this, arguments));
		}
	
		_createClass(RussneskaView, [{
			key: 'formatHtml',
			value: function formatHtml(html) {
				var formatted = html.split('<LIÐUR>').join('<br/><strong>').split('</LIÐUR>').join('</strong> ').split('<RUS>').join('<span>').split('</RUS>').join('</span><br/>').split('<FRASI>').join('<em><strong>').split('</FRASI>').join('</strong></em><br/>').split('<DÆMI>').join('<em><strong>').split('</DÆMI>').join('</strong></em><br/>');
	
				if (formatted.substr(0, 13) === '<br/><strong>') {
					formatted = formatted.substr(5);
				}
	
				return formatted;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: window.l('russneska_title'),
						subTitle: '1962',
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0,
						frontPage: this.props.frontPage,
						database: 'russneska',
						aboutText: window.l('russneska_about'),
						className: 'truncated' },
					this.props.data && this.props.data.map(function (item, index) {
	
						return _react2.default.createElement(
							_react2.default.Fragment,
							{ key: index },
							index > 0 && _react2.default.createElement('hr', { className: 'divider' }),
							_react2.default.createElement(
								'p',
								{ className: 'card-text' + (item.html.length > 1000 ? ' preview' : '') },
								_react2.default.createElement(
									'a',
									{ target: '_blank', href: 'https://ymsir.arnastofnun.is/russ/russ?ord=' + item.id },
									_react2.default.createElement(
										'strong',
										null,
										item.fletta
									)
								),
								' ',
								item.ofl,
								_react2.default.createElement('br', null),
								_react2.default.createElement('br', null),
								_react2.default.createElement('span', { className: '', dangerouslySetInnerHTML: { __html: _this2.formatHtml(item.html) } })
							),
							_react2.default.createElement(
								'p',
								{ className: 'card-text' },
								_react2.default.createElement(
									'a',
									{ target: '_blank', href: 'https://ymsir.arnastofnun.is/russ/russ?ord=' + item.id, className: 'text-light' },
									'Sj\xE1 f\xE6rslu \xED or\xF0ab\xF3k'
								)
							)
						);
					})
				);
			}
		}]);
	
		return RussneskaView;
	}(_react.Component);
	
	exports.default = RussneskaView;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(3);
	
	var _reactSortablejs = __webpack_require__(61);
	
	var _OrdsifjabokView = __webpack_require__(33);
	
	var _OrdsifjabokView2 = _interopRequireDefault(_OrdsifjabokView);
	
	var _BlondalView = __webpack_require__(22);
	
	var _BlondalView2 = _interopRequireDefault(_BlondalView);
	
	var _RitmalssafnView = __webpack_require__(34);
	
	var _RitmalssafnView2 = _interopRequireDefault(_RitmalssafnView);
	
	var _BinViewV = __webpack_require__(21);
	
	var _BinViewV2 = _interopRequireDefault(_BinViewV);
	
	var _KataView = __webpack_require__(25);
	
	var _KataView2 = _interopRequireDefault(_KataView);
	
	var _OrdanetView = __webpack_require__(32);
	
	var _OrdanetView2 = _interopRequireDefault(_OrdanetView);
	
	var _MalfarView = __webpack_require__(27);
	
	var _MalfarView2 = _interopRequireDefault(_MalfarView);
	
	var _StafsetningView = __webpack_require__(37);
	
	var _StafsetningView2 = _interopRequireDefault(_StafsetningView);
	
	var _OrdabankiView = __webpack_require__(31);
	
	var _OrdabankiView2 = _interopRequireDefault(_OrdabankiView);
	
	var _IslexView = __webpack_require__(24);
	
	var _IslexView2 = _interopRequireDefault(_IslexView);
	
	var _NyyrdiView = __webpack_require__(29);
	
	var _NyyrdiView2 = _interopRequireDefault(_NyyrdiView);
	
	var _RussneskaView = __webpack_require__(35);
	
	var _RussneskaView2 = _interopRequireDefault(_RussneskaView);
	
	var _ONPView = __webpack_require__(30);
	
	var _ONPView2 = _interopRequireDefault(_ONPView);
	
	var _underscore = __webpack_require__(14);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _config = __webpack_require__(4);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(10);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _SortingContext = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Suggestions = function (_Component) {
		_inherits(Suggestions, _Component);
	
		function Suggestions(props) {
			_classCallCheck(this, Suggestions);
	
			var _this = _possibleConstructorReturn(this, (Suggestions.__proto__ || Object.getPrototypeOf(Suggestions)).call(this, props));
	
			_this.state = {
				data: []
			};
			return _this;
		}
	
		_createClass(Suggestions, [{
			key: 'fetchData',
			value: function fetchData(searchString) {
				var _this2 = this;
	
				fetch(_config2.default.apiRoot + 'othekkt/' + searchString).then(function (response) {
					return response.json();
				}).then(function (json) {
					_this2.setState({
						data: json[0].othekktlisti.flettur
					});
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.searchString) {
					this.fetchData(this.props.searchString);
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				if (this.props.searchString !== prevProps.searchString) {
					this.fetchData(this.props.searchString);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				return this.state.data.length > 0 ? _react2.default.createElement(
					_react2.default.Fragment,
					null,
					_react2.default.createElement('hr', { style: { margin: 0 } }),
					_react2.default.createElement(
						'div',
						{ className: 'card-body text-center' },
						'\xC1ttir \xFE\xFA vi\xF0 ',
						this.state.data.map(function (item, index) {
							return _react2.default.createElement(
								_react2.default.Fragment,
								{ key: index },
								index > 0 && index === _this3.state.data.length - 1 && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									' e\xF0a '
								),
								index > 0 && index < _this3.state.data.length - 1 && _this3.state.data.length > 1 && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									', '
								),
								_react2.default.createElement(
									_reactRouterDom.Link,
									{ to: '/leit/' + item },
									item
								)
							);
						}),
						'?'
					)
				) : null;
			}
		}]);
	
		return Suggestions;
	}(_react.Component);
	
	// function Aprilgabb() {
	// 	const [init, setInit] = useState(false);
	
	// 	useEffect(() => {
	// 		setTimeout(() => setInit(true), 1000);
	// 	}, []);
	
	// 	return <div className="card initialized" style={{
	// 		background: 'rgb(93,104,0)',
	// 		background: 'linear-gradient(31deg, rgba(93,104,0,1) 0%, rgba(0,104,65,1) 100%)',
	// 		color: 'white',
	// 		padding: '40px',
	// 		textAlign: 'center',
	// 		margin: '20px 0 40px 0',
	// 		opacity: init ? 1 : 0,
	// 		transform: init ? 'scale(1) rotate(-1.5deg)' : 'scale(0.9) rotate(0deg)',
	// 		transition: 'all 1000ms ease-in-out'
	// 	}}>
	// 		<div style={{
	// 			fontSize: '30px',
	// 			fontWeight: 'bold',
	// 			marginBottom: '20px'
	// 		}}>Þú hefur hlaupið 1. apríl!</div>
	// 		<div style={{
	// 			fontSize: '18px'
	// 		}}>Árnastofnun ætlar ekki að eyða orðum úr gagnasöfnum sínum. Þvert á móti leggjum við kapp á að halda utan um orðaforða íslenskunnar, jafnt orð sem eru í stöðugri notkun en einnig eldri og sjaldgæfari orð sem finna má í hinum fjölmörgu orðasöfnum okkar.</div>
	// 	</div>
	// }
	
	var SearchResultsList = function (_Component2) {
		_inherits(SearchResultsList, _Component2);
	
		function SearchResultsList(props) {
			_classCallCheck(this, SearchResultsList);
	
			/*
	  this.foolWords = [
	  	'aðhneiging',
	  	'drymbildrútur',
	  	'dugandlegur',
	  	'glatarí',
	  	'hnóhnika',
	  	'jarðvarp',
	  	'lýðskyldur',
	  	'mótorhjólhestur',
	  	'nítugur',
	  	'nýsmánlegur',
	  	'rampóneraður',
	  	'reiknishaldari',
	  	'röskvi',
	  	'skýjablesi',
	  	'slauksamur',
	  	'svíri',
	  	'tísaldalegur',
	  	'tísaldarlegur',
	  	'traðjóla',
	  	'veðurkápa',
	  ]
	  */
	
			var _this4 = _possibleConstructorReturn(this, (SearchResultsList.__proto__ || Object.getPrototypeOf(SearchResultsList)).call(this, props));
	
			_this4.initialState = {};
			_this4.localStorageKey = 'malid_sorting_v3.4';
			_this4.dataCategories = {
				'flokkur1': [{
					id: 'kata'
				}, {
					id: 'bin_malid2'
				}, {
					id: 'stafsetning'
				}, {
					id: 'ordanet'
				}, {
					id: 'malfar'
				}, {
					id: 'ordabanki'
				}, {
					id: 'nyyrdi'
				}],
				'flokkur3': [{
					id: 'danska'
				}, {
					id: 'saenska'
				}, {
					id: 'norska'
				}, {
					id: 'nynorsk'
				}, {
					id: 'finnska'
				}, {
					id: 'faereyska'
				}, {
					id: 'franska'
				}, {
					id: 'thyska'
				}, {
					id: 'polska'
				}, {
					id: 'enska'
				}],
				'flokkur2': [{
					id: 'blondal'
				}, {
					id: 'ritmalssafn'
				}, {
					id: 'ordsifjabok'
				}, {
					id: 'russneska'
				}, {
					id: 'onp'
				}]
			};
			_this4.initialState = {
				searchResults: {},
				fetching: true,
				initialized: false,
				enableSorting: {
					flokkur1: false,
					flokkur3: false,
					flokkur2: false
				},
				selectedTab: localStorage.getItem(_this4.localStorageKey + '_tab') ? localStorage.getItem(_this4.localStorageKey + '_tab') : 'flokkur1',
				isSortingMode: false,
				resultCollectionCount: {
					total: -1,
					flokkur1: 0,
					flokkur3: 0,
					flokkur2: 0
				}
			};
	
			_this4.url = _config2.default.apiRoot;
	
			_this4.searchResultsLinkHandler = _this4.searchResultsLinkHandler.bind(_this4);
	
			// this.initialState.sorting = localStorage.getItem(this.localStorageKey) ? JSON.parse(localStorage.getItem(this.localStorageKey)) : this.dataCategories;
			var savedSorting = localStorage.getItem(_this4.localStorageKey) ? JSON.parse(localStorage.getItem(_this4.localStorageKey)) : null;
	
			if (savedSorting) {
				savedSorting = _this4.confirmSortingData(savedSorting);
			} else {
				savedSorting = _this4.dataCategories;
			}
			_this4.initialState.sorting = savedSorting;
			_this4.state = _this4.initialState;
			return _this4;
		}
	
		_createClass(SearchResultsList, [{
			key: 'confirmSortingData',
			value: function confirmSortingData(sortingData) {
				var _this5 = this;
	
				try {
					var _loop = function _loop(key) {
						_this5.dataCategories[key].forEach(function (item, i) {
							if (_underscore2.default.filter(sortingData[key], function (sortingItem) {
								return item.id === sortingItem.id;
							}).length === 0) {
								sortingData[key].push(item);
							}
						});
					};
	
					for (var key in sortingData) {
						_loop(key);
					}
				} catch (e) {}
				return sortingData;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.match.params.searchString) {
					this.fetchData();
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// Skoðað hvort breytur hafa breyst og hvort component eigi að uppfærast
				if (prevProps.match.params.searchString !== this.props.match.params.searchString) {
					this.fetchData();
				}
			}
		}, {
			key: 'componentDidCatch',
			value: function componentDidCatch(error, errorInfo) {
				var _this6 = this;
	
				setTimeout(function () {
					window.localStorage.clear();
	
					_this6.initialState.sorting = _this6.dataCategories;
	
					_this6.setState(_this6.initialState);
	
					if (window.location.hash !== '#v') {
						window.location.hash = 'v';
						window.location.reload();
					}
				}, 500);
			}
		}, {
			key: 'searchResultsLinkHandler',
			value: function searchResultsLinkHandler(link) {
				//this.props.history.push('/leit/'+this.props.match.params.searchString+'/link/?link='+link);
	
				window.location.href = link;
			}
		}, {
			key: 'getResultCollectionsCount',
			value: function getResultCollectionsCount(data) {
				var _this7 = this;
	
				var count = {
					total: 0,
					flokkur1: 0,
					flokkur3: 0,
					flokkur2: 0
				};
	
				try {
					var _loop2 = function _loop2(key) {
						if (data[key] && data[key].length > 0) {
							if (_underscore2.default.find(_this7.dataCategories.flokkur1, function (item) {
								return item.id === key;
							})) {
								count.total++;
								count.flokkur1++;
							}
	
							if (_underscore2.default.find(_this7.dataCategories.flokkur2, function (item) {
								return item.id === key;
							})) {
								count.total++;
								count.flokkur2++;
							}
	
							if (_underscore2.default.find(_this7.dataCategories.flokkur3, function (item) {
								return item.id === key;
							})) {
								count.total++;
								count.flokkur3++;
							}
						}
					};
	
					for (var key in data) {
						_loop2(key);
					}
				} catch (e) {}
	
				count.total = count.total === 0 ? -1 : count.total;
	
				return count;
			}
		}, {
			key: 'fetchData',
			value: function fetchData() {
				window.scrollTo(0, 0);
	
				var searchString = this.props.match.params.searchString;
	
				// Sæki gögn til APA
				this.setState({
					fetching: true,
					initialized: false,
					enableSorting: this.initialState.enableSorting,
					searchResults: searchString.indexOf('*') > -1 || searchString.indexOf('_') > -1 ? [] : this.state.searchResults
				}, function () {
					for (var item in this.state.enableSorting) {
						if (this.state.enableSorting[item] && this.refs['sortable_' + item] && this.refs['sortable_' + item].sortable) {
							this.refs['sortable_' + item].sortable.options.disabled = true;
						}
					}
				}.bind(this));
	
				searchString = searchString.split('*').join('$').split('_').join('€');
	
				fetch(this.url + searchString).then(function (response) {
					return response.json();
				}).then(function (json) {
					var _this8 = this;
	
					if (!json.malid && Array.isArray(json)) {
						this.setState({
							searchResults: json,
							resultsType: 'list',
							fetching: false
						}, function () {
							_this8.setState({
								initialized: true
							});
						});
					} else {
						var resultCollectionCount = this.getResultCollectionsCount(json.malid);
	
						this.setState({
							searchResults: json.malid,
							resultCollectionCount: resultCollectionCount,
							resultsType: 'results',
							fetching: false,
							selectedTab: resultCollectionCount[this.state.selectedTab] > 0 ? this.state.selectedTab : resultCollectionCount['flokkur1'] > 0 ? 'flokkur1' : resultCollectionCount['flokkur2'] > 0 ? 'flokkur2' : 'flokkur3'
						}, function () {
							localStorage.setItem(_this8.localStorageKey + '_tab', _this8.state.selectedTab);
							_this8.setState({
								initialized: true
							});
						});
	
						if (this.props.onSearch) {
							this.props.onSearch({
								searchString: this.props.match.params.searchString
							});
						}
					}
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var isAnySortingEnabled = Object.values(this.state.enableSorting).some(Boolean);
				if (this.state.resultsType === 'list') {
					return _react2.default.createElement(
						'div',
						{ className: 'search-results container' },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-8 offset-md-2 main' },
							this.state.searchResults.length === 0 && _react2.default.createElement(
								'div',
								{ key: 'notfound', className: 'card ' + (this.state.initialized ? ' initialized' : '') },
								_react2.default.createElement(
									'div',
									{ className: 'card-body text-center' },
									window.l('notfount_part1'),
									' ',
									_react2.default.createElement(
										'strong',
										null,
										this.props.match.params.searchString
									),
									' ',
									window.l('notfount_part2')
								)
							),
							this.state.searchResults.length > 0 && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								_react2.default.createElement(
									'div',
									{ className: 'card ' + (this.state.initialized ? ' initialized' : '') },
									_react2.default.createElement(
										'div',
										{ className: 'card-body text-center' },
										_react2.default.createElement(
											'strong',
											null,
											this.state.searchResults.length
										),
										' ',
										_helpers2.default.plural('fletta fannst', 'flettur fundust', this.state.searchResults.length),
										this.state.searchResults.length > 20 ? ', fyrstu 20 eru sýndar' : ''
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'card ' + (this.state.initialized ? ' initialized' : '') },
									_react2.default.createElement(
										'div',
										{ className: 'list-group' },
										this.state.searchResults.slice(0, 20).map(function (fletta, index) {
											return _react2.default.createElement(
												'div',
												{ className: 'list-group-item item' },
												_react2.default.createElement(
													_reactRouterDom.Link,
													{ className: 'text-light', to: '/leit/' + fletta.fletta, key: index },
													fletta.fletta
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'small',
													null,
													fletta.sofn
												)
											);
										})
									)
								)
							)
						)
					);
				} else {
					var count = 0;
	
					var getCount = function getCount() {
						count++;
						return count;
					};
	
					var getResultCount = function getResultCount(category) {
						return _this9.dataCategories[category].map(function (item) {
							try {
								return _this9.state.searchResults[item.id].length;
							} catch (e) {
								return 0;
							}
						}).reduce(function (s, f) {
							return s + f;
						}, 0);
					};
	
					var resultsList = [{
						category: 'flokkur1',
						label: window.l('flokkur1_label'),
						list: {
							kata: _react2.default.createElement(_KataView2.default, {
								key: 'kata',
								onLink: this.searchResultsLinkHandler,
								data: this.state.searchResults.kata,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							bin_malid2: _react2.default.createElement(_BinViewV2.default, {
								key: 'bin_malid2',
								onLink: this.searchResultsLinkHandler,
								data: this.state.searchResults.bin_malid2,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							stafsetning: _react2.default.createElement(_StafsetningView2.default, {
								key: 'stafsetning',
								data: this.state.searchResults.stafsetning,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							ordanet: _react2.default.createElement(_OrdanetView2.default, {
								key: 'ordanet',
								onLink: this.searchResultsLinkHandler,
								data: this.state.searchResults.ordanet,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							malfar: _react2.default.createElement(_MalfarView2.default, {
								key: 'malfar',
								onLink: this.searchResultsLinkHandler,
								data: this.state.searchResults.malfar,
								count: getCount(), frontPage: this.props.frontPage }),
							ordabanki: _react2.default.createElement(_OrdabankiView2.default, {
								key: 'ordabanki',
								data: this.state.searchResults.ordabanki,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							nyyrdi: _react2.default.createElement(_NyyrdiView2.default, {
								key: 'nyyrdi',
								data: this.state.searchResults.nyyrdi,
								count: getCount(),
								frontPage: this.props.frontPage
							})
						},
						resultsCount: getResultCount('flokkur1')
					}, {
						category: 'flokkur3',
						label: window.l('flokkur3_label'),
						list: {
							danska: _react2.default.createElement(_IslexView2.default, {
								key: 'danska',
								title: '\xCDslensk-d\xF6nsk or\xF0ab\xF3k',
								subTitle: window.l('islex_title'),
								lang: 'DA',
								data: this.state.searchResults.danska,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							saenska: _react2.default.createElement(_IslexView2.default, {
								key: 'saenska',
								title: '\xCDslensk-s\xE6nsk or\xF0ab\xF3k',
								subTitle: window.l('islex_title'),
								lang: 'SE',
								data: this.state.searchResults.saenska,
								count: getCount(),
								frontPage: this.props.frontPage,
								hideOnFrontPage: true
							}),
							norska: _react2.default.createElement(_IslexView2.default, {
								key: 'norska',
								title: '\xCDslensk-norsk or\xF0ab\xF3k',
								subTitle: window.l('islex_title'),
								lang: 'NO-B',
								data: this.state.searchResults.norska,
								count: getCount(),
								frontPage: this.props.frontPage,
								hideOnFrontPage: true
							}),
							nynorsk: _react2.default.createElement(_IslexView2.default, {
								key: 'nynorsk',
								title: '\xCDslensk-n\xFDnorsk or\xF0ab\xF3k',
								subTitle: window.l('islex_title'),
								lang: 'NO-N',
								data: this.state.searchResults.nynorsk,
								count: getCount(),
								frontPage: this.props.frontPage,
								hideOnFrontPage: true
							}),
							finnska: _react2.default.createElement(_IslexView2.default, {
								key: 'finnska',
								title: '\xCDslensk-finnsk or\xF0ab\xF3k',
								subTitle: window.l('islex_title'),
								lang: 'FI',
								data: this.state.searchResults.finnska,
								count: getCount(),
								frontPage: this.props.frontPage,
								hideOnFrontPage: true
							}),
							faereyska: _react2.default.createElement(_IslexView2.default, {
								key: 'faereyska',
								title: '\xCDslensk-f\xE6reysk or\xF0ab\xF3k',
								subTitle: window.l('islex_title'),
								lang: 'FO',
								data: this.state.searchResults.faereyska,
								count: getCount(),
								frontPage: this.props.frontPage,
								hideOnFrontPage: true
							}),
							franska: _react2.default.createElement(_IslexView2.default, {
								key: 'franska',
								title: '\xCDslensk-fr\xF6nsk or\xF0ab\xF3k',
								subTitle: 'LEX\xCDA',
								aboutText: window.l('lexia_about'),
								url: 'http://lexia.arnastofnun.is',
								lang: 'FRA',
								data: this.state.searchResults.franska,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							thyska: _react2.default.createElement(_IslexView2.default, {
								key: 'thyska',
								title: '\xCDslensk-\xFE\xFDsk or\xF0ab\xF3k',
								subTitle: 'LEX\xCDA',
								aboutText: window.l('lexia_about'),
								lang: 'TYS',
								url: 'http://lexia.arnastofnun.is',
								hideUrl: false,
								data: this.state.searchResults.thyska,
								count: getCount(),
								frontPage: this.props.frontPage,
								hideOnFrontPage: true
							}),
							polska: _react2.default.createElement(_IslexView2.default, {
								key: 'polska',
								title: '\xCDslensk-p\xF3lsk or\xF0ab\xF3k',
								subTitle: 'Íslensk-pólsk orðabók',
								aboutText: window.l('polsk_about'),
								lang: 'POL',
								url: 'https://pl.is',
								data: this.state.searchResults.polska,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							enska: _react2.default.createElement(_IslexView2.default, {
								key: 'enska',
								title: '\xCDslensk-ensk or\xF0ab\xF3k',
								subTitle: 'Íslensk-ensk orðabók',
								aboutText: window.l('ensk_about'),
								lang: 'EN',
								url: 'https://enska.arnastofnun.is',
								data: this.state.searchResults.enska,
								count: getCount(),
								frontPage: this.props.frontPage
							})
						},
						resultsCount: getResultCount('flokkur3')
					}, {
						category: 'flokkur2',
						label: window.l('flokkur2_label'),
						list: {
							blondal: _react2.default.createElement(_BlondalView2.default, {
								key: 'blondal',
								data: this.state.searchResults.blondal,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							ritmalssafn: _react2.default.createElement(_RitmalssafnView2.default, {
								key: 'ritmalssafn',
								data: this.state.searchResults.ritmalssafn,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							ordsifjabok: _react2.default.createElement(_OrdsifjabokView2.default, {
								key: 'ordsifjabok',
								data: this.state.searchResults.ordsifjabok,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							russneska: _react2.default.createElement(_RussneskaView2.default, {
								key: 'russneska',
								data: this.state.searchResults.russneska,
								count: getCount(),
								frontPage: this.props.frontPage
							}),
							onp: _react2.default.createElement(_ONPView2.default, {
								data: this.state.searchResults.onp,
								count: getCount(),
								key: 'onp',
								frontPage: this.props.frontPage
							})
						},
						resultsCount: getResultCount('flokkur2')
					}];
	
					return _react2.default.createElement(
						'div',
						{ className: 'search-results container' + (this.props.frontPage ? ' front' : ' results') + (this.state.enableSorting[this.state.selectedTab] ? ' enable-sorting' : '') + (this.state.fetching ? ' loading' : '') },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-8 offset-md-2 main' },
							this.state.resultCollectionCount.total > 0 && _react2.default.createElement(
								'div',
								{ className: 'search-toolbar' },
								this.state.searchResults && this.props.match.params.searchString && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									_react2.default.createElement(
										'span',
										{ className: 'search-message' },
										_react2.default.createElement(
											'strong',
											null,
											this.props.match.params.searchString
										),
										' ',
										window.l('found_part1'),
										' ',
										this.state.resultCollectionCount.total,
										' ',
										this.state.resultCollectionCount.total === 1 ? window.l('found_part2') : window.l('found_part2_plural')
									)
								),
								_react2.default.createElement(
									'button',
									{
										className: 'sort-button',
										onClick: function onClick() {
											var enableSorting = Object.assign({}, _this9.state.enableSorting);
	
											enableSorting[_this9.state.selectedTab] = !enableSorting[_this9.state.selectedTab];
	
											_this9.setState({
												enableSorting: enableSorting,
												isSortingMode: true
											});
	
											_this9.refs['sortable_' + _this9.state.selectedTab].sortable.options.disabled = !enableSorting[_this9.state.selectedTab];
	
											_this9.setState({ enableSorting: enableSorting });
										}
									},
									_react2.default.createElement(
										'span',
										null,
										window.l('rada_gagnasofnum')
									)
								)
							),
							this.state.searchResults.beygingar && this.state.searchResults.beygingar.length > 0 && this.state.searchResults.beygingar[0].flettur && this.state.searchResults.beygingar[0].flettur && this.state.searchResults.beygingar[0].flettur.length > 0 && !this.state.fetching && function () {
								var beygingar = _underscore2.default.flatten(_this9.state.searchResults.beygingar.map(function (item) {
									return item.flettur;
								}));
	
								return _react2.default.createElement(
									'div',
									{ className: 'card initialized' },
									_react2.default.createElement(
										'div',
										{ className: 'card-body text-center' },
										_react2.default.createElement(
											'strong',
											null,
											_this9.state.searchResults.beygingar[0].beygingarmynd.toLowerCase()
										),
										' getur l\xEDka veri\xF0 beygingarmynd af ',
										beygingar.map(function (item, flIndex) {
											return _react2.default.createElement(
												_react2.default.Fragment,
												{ key: flIndex },
												flIndex > 0 && flIndex === beygingar.length - 1 && _react2.default.createElement(
													_react2.default.Fragment,
													null,
													' og '
												),
												flIndex > 0 && flIndex < beygingar.length - 1 && beygingar.length > 1 && _react2.default.createElement(
													_react2.default.Fragment,
													null,
													', '
												),
												_react2.default.createElement(
													_reactRouterDom.Link,
													{ to: '/leit/' + item.lemma },
													item.lemma
												),
												' ',
												_react2.default.createElement(
													'em',
													null,
													item.kennimyndir ? item.kennimyndir + ' ' : ''
												),
												'(',
												item.ofl,
												')'
											);
										})
									)
								);
							}(),
							this.state.resultCollectionCount.total <= 0 && !this.props.frontPage && /*(this.state.searchResults.beygingar && this.state.searchResults.beygingar.length == 0) &&*/
							_react2.default.createElement(
								'div',
								{ key: 'notfound', className: 'card ' + (this.state.initialized ? ' initialized' : '') },
								_react2.default.createElement(
									'div',
									{ className: 'card-body text-center' },
									window.l('notfount_part1'),
									' ',
									_react2.default.createElement(
										'strong',
										null,
										this.props.match.params.searchString
									),
									' ',
									window.l('notfount_part2')
								),
								this.state.searchResults.beygingar && this.state.searchResults.beygingar.length === 0 && _react2.default.createElement(Suggestions, { searchString: this.props.match.params.searchString })
							),
							_react2.default.createElement(
								'p',
								{ className: 'text-message sort-message' + (this.state.enableSorting[this.state.selectedTab] ? ' visible' : '') },
								window.l('rada_gagnasofnum_info'),
								_react2.default.createElement('br', null),
								_react2.default.createElement('img', { className: 'menu-link-back-arrow smaller-arrow', alt: 'Go back', src: '/img/back-icon-red.png' }),
								_react2.default.createElement(
									'a',
									{ href: '#', onClick: function (event) {
											event.preventDefault();
	
											var enableSorting = this.state.enableSorting;
											enableSorting[this.state.selectedTab] = false;
											Object.keys(enableSorting).forEach(function (key) {
												return enableSorting[key] = false;
											});
	
											this.setState({
												enableSorting: enableSorting,
												isSortingMode: false
											}, function () {
												for (var item in this.state.enableSorting) {
													if (this.refs['sortable_' + item] && this.refs['sortable_' + item].sortable) {
														this.refs['sortable_' + item].sortable.options.disabled = true;
													}
												}
											}.bind(this));
										}.bind(this) },
									window.l('rada_gagnasofnum_lokid')
								),
								'.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'result-tabs' },
								_react2.default.createElement(
									'div',
									{ className: 'tabs' },
									!this.props.frontPage && resultsList.filter(function (item) {
										return item.resultsCount > 0;
									}).map(function (resultItem, index) {
										return _react2.default.createElement(
											'button',
											{ key: index, className: 'tab' + (_this9.state.selectedTab === resultItem.category ? ' selected' : ''), onClick: function onClick() {
													var enableSorting = Object.assign({}, _this9.state.enableSorting);
	
													if (_this9.state.isSortingMode) {
														enableSorting[resultItem.category] = true;
													}
	
													_this9.setState({
														selectedTab: resultItem.category,
														enableSorting: enableSorting
													});
	
													localStorage.setItem(_this9.localStorageKey + "_tab", resultItem.category);
												} },
											resultItem.label + ' (' + _this9.state.resultCollectionCount[resultItem.category] + ')'
										);
									}),
									this.props.frontPage && resultsList.map(function (resultItem, index) {
										return _react2.default.createElement(
											'button',
											{ key: index, disabled: _this9.state.enableSorting[_this9.state.selectedTab], className: 'tab' + (_this9.state.selectedTab === resultItem.category ? ' selected' : ''), onClick: function onClick() {
													_this9.setState({
														selectedTab: resultItem.category
													});
													localStorage.setItem(_this9.localStorageKey + '_tab', resultItem.category);
												} },
											resultItem.label
										);
									})
								),
								resultsList.filter(function (item) {
									return item.category === _this9.state.selectedTab;
								}).map(function (resultItem, index) {
									return _react2.default.createElement(
										'div',
										{ key: index, className: 'tab-content selected' },
										_this9.props.frontPage && false && _react2.default.createElement(
											'h2',
											{ className: 'tab-title' },
											_react2.default.createElement(
												'span',
												null,
												resultItem.label
											)
										),
										_react2.default.createElement(
											_SortingContext.SortingContext.Provider,
											{ value: isAnySortingEnabled },
											_react2.default.createElement(
												_reactSortablejs.ReactSortable,
												{
													list: _this9.state.sorting[resultItem.category],
													ref: "sortable_" + resultItem.category,
													disabled: !_this9.state.enableSorting[resultItem.category],
													forceFallback: navigator.userAgent.toLowerCase().includes("firefox"),
													setList: function setList(newSorting) {
														var sorting = Object.assign({}, _this9.state.sorting);
														sorting[resultItem.category] = newSorting;
	
														_this9.setState({ sorting: sorting }, function () {
															localStorage.setItem(_this9.localStorageKey, JSON.stringify(sorting));
														});
													}
												},
												_this9.state.sorting[resultItem.category].map(function (item) {
													return resultItem.list[item.id];
												})
											)
										)
									);
								})
							)
						),
						function () {
							try {
								if (btoa(_this9.props.match.params.searchString.toLowerCase()) === 'aG51YmJ1cg==') {
									return _react2.default.createElement('div', { style: {
											position: 'fixed',
											bottom: 20,
											right: 20
										}, dangerouslySetInnerHTML: { __html: atob('PGltZyBzcmM9Imh0dHBzOi8vdXBsb2FkLndpa2ltZWRpYS5vcmcvd2lraXBlZGlhL2NvbW1vbnMvMi8yOS9LbGlwZGFzLmpwZz8xNjM2NTUyOTIyNzc5IiBzdHlsZT0ibWF4LXdpZHRoOiAxMzBweDsgbWF4LWhlaWdodDogMTMwcHg7Ij4=') } });
								}
							} catch (e) {
								return null;
							}
						}()
					);
				}
			}
		}]);
	
		return SearchResultsList;
	}(_react.Component);
	
	exports.default = (0, _reactRouterDom.withRouter)(SearchResultsList);

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(3);
	
	var _MalidCard = __webpack_require__(2);
	
	var _MalidCard2 = _interopRequireDefault(_MalidCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StafsetningView = function (_Component) {
		_inherits(StafsetningView, _Component);
	
		function StafsetningView() {
			_classCallCheck(this, StafsetningView);
	
			return _possibleConstructorReturn(this, (StafsetningView.__proto__ || Object.getPrototypeOf(StafsetningView)).apply(this, arguments));
		}
	
		_createClass(StafsetningView, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_MalidCard2.default,
					{ title: window.l('stafsetning_title'),
						count: this.props.count,
						visible: this.props.data && this.props.data.length > 0 && !this.props.frontPage,
						frontPage: this.props.frontPage,
						aboutText: window.l('stafsetning_about'),
						database: 'stafsetning' },
					this.props.data && this.props.data.map(function (item, index) {
						var fletta = item.fletta;
	
						if (item.ordskipting) {
							var ordskipting = item.ordskipting;
	
							var parts = ordskipting.map(function (o, i) {
								return i === 0 ? fletta.slice(0, o) : fletta.slice(ordskipting[i - 1], o);
							});
							parts.push(fletta.slice(ordskipting[ordskipting.length - 1]));
	
							fletta = parts.join('<span class="ohlut-separator">|</span>');
						}
	
						return _react2.default.createElement(
							'p',
							{ className: 'card-text', key: index },
							item.sja && item.sja.length > 0 && _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: fletta } }),
							(!item.sja || item.sja.length === 0) && _react2.default.createElement(
								'a',
								{ target: '_blank', href: '//stafsetning.arnastofnun.is/fletta/' + item.id },
								_react2.default.createElement(
									'strong',
									null,
									_react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: fletta } })
								)
							),
							item.adgreiningarnumer && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								' ',
								item.adgreiningarnumer
							),
							item.ordflokkur && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								' ',
								item.ordflokkur
							),
							item.l_framburdur && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								' [-l:-]'
							),
							item.greinir && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								' ',
								item.greinir,
								';'
							),
							' ',
							item.kennimyndir,
							_react2.default.createElement(
								'em',
								null,
								' ',
								item.daemi ? item.daemi.split('|').join('·') : ''
							),
							' ',
							item.einnig && item.einnig.length > 0 && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								' (einnig rita\xF0 ',
								item.einnig.map(function (einnig, eIndex) {
									return _react2.default.createElement(
										_react2.default.Fragment,
										{ key: eIndex },
										eIndex > 0 && _react2.default.createElement(
											_react2.default.Fragment,
											null,
											' ,'
										),
										_react2.default.createElement(
											_reactRouterDom.Link,
											{ to: '/leit/' + einnig.visun },
											einnig.visun
										)
									);
								}),
								')'
							),
							' ',
							item.sja && item.sja.length > 0 && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								' \u2192 ',
								item.sja.map(function (sja, eIndex) {
									return _react2.default.createElement(
										_react2.default.Fragment,
										{ key: eIndex },
										eIndex > 0 && _react2.default.createElement(
											_react2.default.Fragment,
											null,
											' ,'
										),
										_react2.default.createElement(
											_reactRouterDom.Link,
											{ to: '/leit/' + sja.visun },
											sja.visun
										)
									);
								})
							),
							item.stigbreyting_annad && _react2.default.createElement(
								_react2.default.Fragment,
								null,
								' STIGB ',
								item.stigbreyting_annad
							),
							item.ritreglur && item.ritreglur.map(function (ritregla, rIndex) {
								return _react2.default.createElement(
									_react2.default.Fragment,
									null,
									rIndex > 0 && _react2.default.createElement(
										_react2.default.Fragment,
										null,
										','
									),
									' (sj\xE1 ',
									_react2.default.createElement(
										'a',
										{ target: '_blank', href: 'http://ritreglur.arnastofnun.is/#' + ritregla.regla },
										'\xA7 ',
										ritregla.regla
									),
									' \xED Ritreglum)'
								);
							})
						);
					})
				);
			}
		}]);
	
		return StafsetningView;
	}(_react.Component);
	
	exports.default = StafsetningView;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(18);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Lang = __webpack_require__(39);
	
	var _Lang2 = _interopRequireDefault(_Lang);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var savedLang = localStorage.getItem('currentLang') || 'is';
	
	//import 'whatwg-fetch';
	//import Promise from 'promise-polyfill'; 
	
	_Lang2.default.setCurrentLang(savedLang);
	
	window.Lang = _Lang2.default;
	window.l = function (phrase) {
		return _Lang2.default.get(phrase);
	};
	
	var startApp = function startApp() {
		_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));
	};
	
	if (window.cordova) {
		document.addEventListener('deviceready', startApp, false);
	} else {
		startApp();
	}

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _langData = __webpack_require__(40);
	
	var _langData2 = _interopRequireDefault(_langData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultLang = 'is';
	var storageKey = 'currentLang';
	
	exports.default = {
		collect: false,
	
		setCurrentLang: function setCurrentLang(lang) {
			window.currentLang = lang;
	
			try {
				localStorage.setItem(storageKey, lang);
			} catch (e) {
				console.warn('Could not save language to localStorage', e);
			}
	
			if (window.eventBus) {
				window.eventBus.dispatch('Lang.languageChanged');
			}
		},
	
		get: function get(phrase) {
			if (window.traceLangGet) {
				console.log('Lang.get: ' + phrase);
			}
	
			if (!window.currentLang) {
				// window.currentLang = defaultLang;
				try {
					var stored = localStorage.getItem(storageKey);
					window.currentLang = stored || defaultLang;
				} catch (e) {
					window.currentLang = defaultLang;
				}
			}
	
			if (!_langData2.default[window.currentLang]) {
				window.currentLang = defaultLang;
			}
	
			if (this.collect) {
				if (!this.notFound) {
					this.notFound = [];
				}
	
				if (!_langData2.default[window.currentLang][phrase]) {
					if (this.notFound.indexOf(phrase) === -1) {
						this.notFound.push(phrase);
						console.log('Did not find translation for "' + phrase + '"');
					}
				}
			}
	
			return !_langData2.default[window.currentLang] || !_langData2.default[window.currentLang][phrase] ? phrase : _langData2.default[window.currentLang][phrase];
		}
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		'is': {
			'bin_title': 'Beygingarlýsing íslensks nútímamáls',
			'bin_about': 'Beygingarlýsingin er safn ríflega 350.000 beygingardæma með öllum beygingarmyndum hvers orðs.',
			'kata_title': 'Íslensk nútímamálsorðabók',
			'kata_about': 'Íslensk orðabók með 56 þúsund flettum. Orðabókin er aukin og endurbætt reglulega.',
			'stafsetning_title': 'Íslensk stafsetningarorðabók',
			'stafsetning_about': 'Áður <i>Stafsetningarorðabókin</i>. Opinber réttritunarorðabók um íslensku. Hlutverk hennar er að leiðbeina um rithátt og beygingar í samræmi við hefðbundin viðhorf um vandað ritmál. Byggt er á ritreglum Íslenskrar málnefndar.',
			'ordsifjabok_title': 'Íslensk orðsifjabók',
			'ordsifjabok_subtitle': '1989',
			'ordsifjabok_about': 'Í Íslenskri orðsifjabók eftir Ásgeir Blöndal Magnússon má finna skýringar um myndun og uppruna íslenskra orða. Hafa verður í huga að orðsifjabókin er höfundarverk Ásgeirs og efnið hefur ekki verið uppfært eða endurbætt í ljósi nýrra viðhorfa eftir að bókin kom út 1989.',
			'ordanet_title': 'Íslenskt orðanet',
			'ordanet_subtitle': 'Samheiti - orðasambönd - merkingartengsl',
			'ordanet_about': 'Íslenskt orðanet sýnir merkingartengsl íslenskra orða og orðasambanda. Það sameinar hlutverk samheita- og hugtakaorðabókar og kemur að hagnýtum notum við ritun og textagerð.',
			'ordabanki_title': 'Íðorðabankinn',
			'ordabanki_about': 'Orðabanki með skýringum og íslenskum þýðingum á hugtökum á meira en 60 sérsviðum. Unnið af sérfræðingum á viðkomandi sviðum.',
			'malfar_title': 'Málfarsbankinn',
			'malfar_about': 'Safn stuttra greina um málfarsleg atriði og svör við algengum spurningum um málfar.',
			'islex_title': 'ISLEX-orðabókin',
			'islex_about': 'ISLEX er margmála orðabók á vefnum. Grunnmálið er íslenska og markmálin eru danska, sænska, norskt bókmál, nýnorska, færeyska og finnska. ISLEX er samstarfsverkefni sex norrænna fræðastofnana, á Íslandi, í Danmörku, Noregi, Svíþjóð, Færeyjum og Finnlandi. Í ISLEX eru 55 þúsund íslensk uppflettiorð.',
			'blondal_title': 'Íslensk-dönsk orðabók eftir Sigfús Blöndal',
			'blondal_subtitle': '1920–1924',
			'blondal_about': 'Íslensk-dönsk orðabók eftir Sigfús Blöndal kom út á árunum 1920−1924. Orðabókin er lykilverk í íslenskri orðabókarsögu og er hún ein stærsta íslenska orðabókin sem hefur verið gerð til þessa. Allar orðskýringar í bókinni eru á dönsku sem kann að vekja furðu nú um stundir, en á þeim árum sem verkið var í vinnslu (1903–1920) var Ísland enn hluti af Danmörku. Styrkir til starfsins og útgáfunnar komu frá dönskum sjóðum, svo og dönskum og íslenskum stjórnvöldum.',
			'nyyrdi_title': 'Nýyrðavefurinn',
			'nyyrdi_about': 'Á nýyrðavef Stofnunar Árna Magnússonar í íslenskum fræðum eru birt sýnishorn söfnunar undanfarinna ára en einnig er hægt að senda inn nýyrði.',
			'ritmalssafn_title': 'Ritmálssafn Orðabókar Háskólans',
			'ritmalssafn_subtitle': '16.–20. öld',
			'ritmalssafn_about': 'Í Ritmálssafninu eru dæmi um notkun orða úr íslenskum ritum. Þau spanna tímabilið frá miðri 16. öld til loka 20. aldar. ',
			'russneska_title': 'Íslenzk-rússnesk orðabók eftir Valeríj P. Bérkov',
			'russneska_about': 'Íslenzk-rússnesk orðabók er samin af Valéríj P. Bérkov með aðkomu Árna Böðvarssonar. Bókin kom út árið 1962 og er fyrir löngu uppseld.',
			'lexia_about': 'LEXÍA er veforðabók milli íslensku og tveggja markmála, frönsku og þýsku. Franski hlutinn er unninn í samstarfi Árnastofnunar og Stofnunar Vigdísar Finnbogadóttur í erlendum tungumálum. Í henni eru 55 þúsund íslensk uppflettiorð.',
			'ensk_about': 'Íslensk-ensk orðabók var opnuð 2025. Í henni eru 56 þúsund íslensk uppflettiorð. Athugið að orðabókin er stöðugt í vinnslu og því getur komið fyrir að það vanti enskar þýðingar við sum orðin, eða að þau eru ekki fullunnin á annan hátt.',
			'polsk_about': 'Íslensk-pólsk orðabók var opnuð 2025. Í henni eru 56 þúsund íslensk uppflettiorð.',
			'onp_title': 'Fornmálsorðabókin í Kaupmannahöfn (ONP)',
			'onp_about': 'Fornmálsorðabókin er unnin í Kaupmannahöfn á vegum Den Arnamagnæanske Kommission. Orðabókin er mjög umfangsmikil. Hún nær yfir íslenskt lausamál frá elstu handritum um miðja tólftu öld og fram til upphafs prentaldar (1540).',
	
			'leita': 'Leita',
			'menu_back': 'Til baka',
	
			'rada_gagnasofnum': 'Raða gagnasöfnum',
			'rada_gagnasofnum_info': 'Hér getur þú raðað gagnasöfnunum eins og þér hentar.',
			'rada_gagnasofnum_lokid': 'Aftur í leitarniðurstöður',
	
			'database_display_in_results': 'Birta gagnasafn í leitarniðurstöðum',
			'database_hide_in_results': 'Fela gagnasafn í leitarniðurstöðum',
	
			'flokkur1_label': 'Nútímamál',
			'flokkur2_label': 'Eldri orðabækur',
			'flokkur3_label': 'Tvímála orðabækur',
	
			'notfount_part1': 'Flettan',
			'notfount_part2': 'fannst ekki í neinu gagnasafni',
			'found_part1': 'fannst í',
			'found_part2': 'gagnasafni',
			'found_part2_plural': 'gagnasöfnum',
			'beygingarmynd_part1': 'getur líka verið beygingarmynd af',
			'open_dict_generic': 'Sjá færslu í orðabók'
		},
		'en': {
			'bin_title': 'Beygingarlýsing íslensks nútímamáls – Database of Modern Icelandic Inflection',
			'bin_about': 'This is a collection of inflectional paradigms showing conjugations and declensions of individual Icelandic words.',
			'kata_title': 'Íslensk nútímamálsorðabók – A Dictionary of Contemporary Icelandic',
			'kata_about': 'A dictionary of modern Icelandic with around 56,000 entries.',
			'stafsetning_title': 'Íslensk stafsetningarorðabók – The Icelandic Spelling Dictionary',
			'stafsetning_about': 'The 2nd edition of the Dictionary of Orthography. Rules on spelling and grammar, reviewed in 2016, are linked to the dictionary entries and appear with search results. The dictionary is a work in progress.',
			'ordsifjabok_title': 'Íslensk orðsifjabók – Icelandic Etymological Dictionary',
			'ordsifjabok_about': 'The Etymological Dictionary of Icelandic by Ásgeir Blöndal Magnússon contains explanations of word formation and origins.',
			'ordanet_title': 'Íslenskt orðanet – Icelandic Wordnet',
			'ordanet_about': 'Icelandic Word Web maps the semantic relationship of Icelandic words and phrases. It serves as both a dictionary of synonyms and word combinations for practical use in writing and editing.',
			'ordabanki_title': 'Íðorðabankinn – Terminology Bank',
			'ordabanki_about': 'A terminology dictionary with explanations and Icelandic translations of terms in more than 60 special fields. Compiled by experts in the relevant fields.',
			'malfar_title': 'Málfarsbankinn – The Language Usage Database',
			'malfar_about': 'A collection of short articles on linguistic issues and answers to frequently asked questions about language use.',
			'islex_title': 'The ISLEX Project',
			'islex_about': 'ISLEX is a multilingual dictionary between modern Icelandic and six Scandinavian target languages: Danish, Norwegian (both standards: Bokmål and Nynorsk), Swedish, Faroese and Finnish. ISLEX has 55 thousand Icelandic entries.',
			'blondal_title': 'Icelandic-Danish Dictionary, by Sigfús Blöndal',
			'blondal_subtitle': '1920–1924',
			'blondal_about': 'This Icelandic-Danish Dictionary, published in 1920−1924, is a milestone in the history of Icelandic lexicography.',
			'nyyrdi_title': 'Nýyrðavefurinn – Neologisms, coinages',
			'nyyrdi_about': 'A collection of recent neologisms and coinages suggested by members of the Icelandic speech community.',
			'ritmalssafn_title': 'Written Language Archive',
			'ritmalssafn_subtitle': '16.–20. öld',
			'ritmalssafn_about': 'The Written Language Archive contains examples of words and word use in Icelandic written sources such as books, periodicals etc from the middle of the 16th century to the end of the 20th century.',
			'russneska_title': 'Icelandic–Russian Dictionary',
			'russneska_about': 'Author: Valerij P. Bérkov, assisted by Árni Böðvarsson. Published in 1962 (has been out of print for a long time now). This electronic version of the dictionary is made in collaboration between The Árni Magnússon Institute for Icelandic Studies and The Vigdís Finnbogadóttir Institute of Foreign Languages.',
			'lexia_title': 'LEXIA',
			'lexia_about': 'LEXIA is a dictionary between Icelandic, French and German. The French part is made in collaboration of The Árni Magnússon Institute for Icelandic Studies and The Vigdís Finnbogadóttir Institute of Foreign Languages. LEXIA has 55 thousand Icelandic entries.',
			'ensk_about': 'The Icelandic-English dictionary was released in 2025. It has 56 thousand Icelandic entries. Please note that the dictionary is a work in progress and some English translations may be missing.',
			'polsk_about': 'The Icelandic-Polish dictionary was released in 2025. It has 56 thousand Icelandic entries.',
			'onp_title': 'The Dictionary of Old Norse Prose (ONP)',
			'onp_about': 'The Dictionary of Old Norse Prose (ONP), established in 1939, is part of The Arnamagnæan Collection at the University of Copenhagen. It contains vocabulary attested in Old Norse prose texts from the middle of the 12th century up until 1540. ',
	
			'leita': 'Search',
			'menu_back': 'Go back',
	
			'rada_gagnasofnum': 'Arrange datasets',
			'rada_gagnasofnum_info': 'Here you can arrange the datasets based on your own needs.',
			'rada_gagnasofnum_lokid': 'Back to search results',
	
			'database_display_in_results': 'Birta gagnasafn í leitarniðurstöðum',
			'database_hide_in_results': 'Fela gagnasafn í leitarniðurstöðum',
	
			'flokkur1_label': 'Contemporary Icelandic',
			'flokkur2_label': 'Older Sources',
			'flokkur3_label': 'Bilingual Dictionaries',
	
			'notfount_part1': ' ',
			'notfount_part2': 'not found in any database',
			'found_part1': 'found in',
			'found_part2': 'database',
			'found_part2_plural': 'databases',
			'beygingarmynd_part1': 'can also belong to the lemma'
		}
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	(function(root,factory){if(true)module.exports=factory();else if(typeof define==="function"&&define.amd)define("EventBus",[],factory);else if(typeof exports==="object")exports["EventBus"]=factory();else root["EventBus"]=factory()})(this,function(){var EventBusClass={};EventBusClass=function(){this.listeners={}};EventBusClass.prototype={addEventListener:function(type,callback,scope){var args=[];var numOfArgs=arguments.length;for(var i=0;i<numOfArgs;i++){args.push(arguments[i])}args=args.length>3?args.splice(3,args.length-1):[];if(typeof this.listeners[type]!="undefined"){this.listeners[type].push({scope:scope,callback:callback,args:args})}else{this.listeners[type]=[{scope:scope,callback:callback,args:args}]}},removeEventListener:function(type,callback,scope){if(typeof this.listeners[type]!="undefined"){var numOfCallbacks=this.listeners[type].length;var newArray=[];for(var i=0;i<numOfCallbacks;i++){var listener=this.listeners[type][i];if(listener.scope==scope&&listener.callback==callback){}else{newArray.push(listener)}}this.listeners[type]=newArray}},hasEventListener:function(type,callback,scope){if(typeof this.listeners[type]!="undefined"){var numOfCallbacks=this.listeners[type].length;if(callback===undefined&&scope===undefined){return numOfCallbacks>0}for(var i=0;i<numOfCallbacks;i++){var listener=this.listeners[type][i];if((scope?listener.scope==scope:true)&&listener.callback==callback){return true}}}return false},dispatch:function(type,target){var event={type:type,target:target};var args=[];var numOfArgs=arguments.length;for(var i=0;i<numOfArgs;i++){args.push(arguments[i])}args=args.length>2?args.splice(2,args.length-1):[];args=[event].concat(args);if(typeof this.listeners[type]!="undefined"){var listeners=this.listeners[type].slice();var numOfCallbacks=listeners.length;for(var i=0;i<numOfCallbacks;i++){var listener=listeners[i];if(listener&&listener.callback){var concatArgs=args.concat(listener.args);listener.callback.apply(listener.scope,concatArgs)}}}},getEvents:function(){var str="";for(var type in this.listeners){var numOfCallbacks=this.listeners[type].length;for(var i=0;i<numOfCallbacks;i++){var listener=this.listeners[type][i];str+=listener.scope&&listener.scope.className?listener.scope.className:"anonymous";str+=" listen for '"+type+"'\n"}}return str}};var EventBus=new EventBusClass;return EventBus});

/***/ },
/* 43 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 44 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(64)),valueEqual=_interopDefault(__webpack_require__(69));__webpack_require__(6);var invariant=_interopDefault(__webpack_require__(5));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(13);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';function _interopDefault(e){return(e&&(typeof e==='object')&&'default'in e)?e['default']:e}var React=__webpack_require__(1),React__default=_interopDefault(React),_inheritsLoose=_interopDefault(__webpack_require__(15)),PropTypes=_interopDefault(__webpack_require__(8)),gud=_interopDefault(__webpack_require__(44)),warning=_interopDefault(__webpack_require__(6));var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + gud() + '__';
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes.object.isRequired, _Provider$childContex);
	
	  var Consumer =
	  /*#__PURE__*/
	  function (_Component2) {
	    _inheritsLoose(Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes.object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default.createContext || createReactContext;module.exports=index;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(47)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = prefix || defaultDelimiter
	    var pattern = capture || group
	    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	function restrictBacktrack(delimiter, prevText) {
	  if (!prevText || prevText.indexOf(delimiter) > -1) {
	    return '[^' + escapeString(delimiter) + ']+?'
	  }
	
	  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(12);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(12);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(53);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(7),r=__webpack_require__(66);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;pa.hasOwnProperty("ReactCurrentDispatcher")||(pa.ReactCurrentDispatcher={current:null});pa.hasOwnProperty("ReactCurrentBatchConfig")||(pa.ReactCurrentBatchConfig={suspense:null});
	var qa=/^(.*)[\\\/]/,v="function"===typeof Symbol&&Symbol.for,ra=v?Symbol.for("react.element"):60103,sa=v?Symbol.for("react.portal"):60106,ta=v?Symbol.for("react.fragment"):60107,ua=v?Symbol.for("react.strict_mode"):60108,va=v?Symbol.for("react.profiler"):60114,wa=v?Symbol.for("react.provider"):60109,xa=v?Symbol.for("react.context"):60110,ya=v?Symbol.for("react.concurrent_mode"):60111,za=v?Symbol.for("react.forward_ref"):60112,Aa=v?Symbol.for("react.suspense"):60113,Ba=v?Symbol.for("react.suspense_list"):
	60120,Ca=v?Symbol.for("react.memo"):60115,Da=v?Symbol.for("react.lazy"):60116,Ea=v?Symbol.for("react.block"):60121,Fa="function"===typeof Symbol&&Symbol.iterator;function Ga(a){if(null===a||"object"!==typeof a)return null;a=Fa&&a[Fa]||a["@@iterator"];return"function"===typeof a?a:null}function Ha(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function Ia(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ta:return"Fragment";case sa:return"Portal";case va:return"Profiler";case ua:return"StrictMode";case Aa:return"Suspense";case Ba:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case xa:return"Context.Consumer";case wa:return"Context.Provider";case za:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case Ca:return Ia(a.type);case Ea:return Ia(a.render);case Da:if(a=1===a._status?a._result:null)return Ia(a)}return null}function Ja(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Ia(a.type);c=null;d&&(c=Ia(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(qa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}var Ka=null,La={};
	function Ma(){if(Ka)for(var a in La){var b=La[a],c=Ka.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!Na[c]){if(!b.extractEvents)throw Error(u(97,a));Na[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(Oa.hasOwnProperty(h))throw Error(u(99,h));Oa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Pa(k[e],g,h);e=!0}else f.registrationName?(Pa(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function Pa(a,b,c){if(Qa[a])throw Error(u(100,a));Qa[a]=b;Ra[a]=b.eventTypes[c].dependencies}var Na=[],Oa={},Qa={},Ra={};function Sa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!La.hasOwnProperty(c)||La[c]!==d){if(La[c])throw Error(u(102,c));La[c]=d;b=!0}}b&&Ma()}var Ta=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Ua=null,Va=null,Wa=null;
	function Xa(a){if(a=ma(a)){if("function"!==typeof Ua)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),Ua(a.stateNode,a.type,b))}}function Ya(a){Va?Wa?Wa.push(a):Wa=[a]:Va=a}function Za(){if(Va){var a=Va,b=Wa;Wa=Va=null;Xa(a);if(b)for(a=0;a<b.length;a++)Xa(b[a])}}function $a(a,b){return a(b)}function ab(a,b,c,d,e){return a(b,c,d,e)}function bb(){}var cb=$a,db=!1,eb=!1;function fb(){if(null!==Va||null!==Wa)bb(),Za()}
	function gb(a,b,c){if(eb)return a(b,c);eb=!0;try{return cb(a,b,c)}finally{eb=!1,fb()}}var hb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ib=Object.prototype.hasOwnProperty,jb={},kb={};
	function lb(a){if(ib.call(kb,a))return!0;if(ib.call(jb,a))return!1;if(hb.test(a))return kb[a]=!0;jb[a]=!0;return!1}function mb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function nb(a,b,c,d){if(null===b||"undefined"===typeof b||mb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var E={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){E[a]=new C(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];E[b]=new C(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){E[a]=new C(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){E[a]=new C(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){E[a]=new C(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){E[a]=new C(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){E[a]=new C(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){E[a]=new C(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){E[a]=new C(a,5,!1,a.toLowerCase(),null,!1)});var ob=/[\-:]([a-z])/g;function pb(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ob,
	pb);E[b]=new C(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ob,pb);E[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ob,pb);E[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){E[a]=new C(a,1,!1,a.toLowerCase(),null,!1)});
	E.xlinkHref=new C("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){E[a]=new C(a,1,!1,a.toLowerCase(),null,!0)});
	function qb(a,b,c,d){var e=E.hasOwnProperty(b)?E[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(nb(b,c,e,d)&&(c=null),d||null===e?lb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&qb(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	Ta&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!Ta)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<Na.length;k++){var l=Na[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){db||bb();var e=id,f=db;db=!0;try{ab(e,a,b,c,d)}finally{(db=f)||fb()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{gb(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{gb(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=Ra[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=Ta&&"CompositionEvent"in window,ke=null;Ta&&"documentMode"in document&&(ke=document.documentMode);
	var le=Ta&&"TextEvent"in window&&!ke,me=Ta&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Ya(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;Ta&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),db)mc(a);else{db=!0;try{$a(Ce,a)}finally{db=!1,fb()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=Ta&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=Ra.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(Ka)throw Error(u(101));Ka=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Ma();var xf=Nc;la=Qd;ma=xf;na=Pd;Sa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Ia(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=pa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case ra:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case sa:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	Ga(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case ra:return c.key===e?c.type===ta?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case sa:return c.key===e?l(a,b,c,d):null}if(Og(c)||Ga(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case ra:return a=a.get(null===d.key?c:d.key)||null,d.type===ta?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case sa:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||Ga(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=Ga(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ta&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case ra:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ta){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ta?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case sa:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(Ga(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=pa.ReactCurrentDispatcher,kh=pa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=pa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Qa.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(Qa.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):Qa.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(Qa.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&qb(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:Ja(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Ja(c));null!==c&&Ia(c.type);b=b.value;null!==a&&1===a.tag&&Ia(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):qb(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=pa.ReactCurrentDispatcher,dj=pa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):g.memoizedState=null}var m=0!==
	(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;break a}h=void 0;g=b;var A=e.pingCache;
	null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((Ia(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Ja(g))}S!==jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=
	h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}
	function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Ha(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===za)return 11;if(a===Ca)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ta:return Wg(c.children,e,f,b);case ya:g=8;e|=7;break;case ua:g=8;e|=1;break;case va:return a=Sh(12,c,b,e|8),a.elementType=va,a.type=va,a.expirationTime=f,a;case Aa:return a=Sh(13,c,b,e),a.type=Aa,a.elementType=Aa,a.expirationTime=f,a;case Ba:return a=Sh(19,c,b,e),a.elementType=Ba,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case wa:g=
	10;break a;case xa:g=9;break a;case za:g=11;break a;case Ca:g=14;break a;case Da:g=16;d=null;break a;case Ea:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:sa,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	Ua=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};$a=Mj;
	ab=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};bb=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};cb=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,Sa,Oa,Xd,function(a){jc(a,Wd)},Ya,Za,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:pa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.0";


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(54);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 56 */
/***/ function(module, exports) {

	/** @license React v16.13.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(59),React=_interopDefault(__webpack_require__(1)),history=__webpack_require__(11);__webpack_require__(8),__webpack_require__(6);var invariant=_interopDefault(__webpack_require__(5));function _extends(){return(_extends=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var o in t)Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,r){e.prototype=Object.create(r.prototype),(e.prototype.constructor=e).__proto__=r}function _objectWithoutPropertiesLoose(e,r){if(null==e)return{};var t,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)t=a[o],0<=r.indexOf(t)||(n[t]=e[t]);return n}var BrowserRouter=function(n){function e(){for(var e,r=arguments.length,t=new Array(r),o=0;o<r;o++)t[o]=arguments[o];return(e=n.call.apply(n,[this].concat(t))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,r=arguments.length,t=new Array(r),o=0;o<r;o++)t[o]=arguments[o];return(e=n.call.apply(n,[this].concat(t))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,r){return"function"==typeof e?e(r):e},normalizeToLocation=function(e,r){return"string"==typeof e?history.createLocation(e,null,null,r):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,r){var t=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(r){try{n&&n(r)}catch(e){throw r.preventDefault(),e}r.defaultPrevented||0!==r.button||i&&"_self"!==i||isModifiedEvent(r)||(r.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&r||t,React.createElement("a",c)}),Link=forwardRef(function(e,a){var r=e.component,i=void 0===r?LinkAnchor:r,c=e.replace,f=e.to,u=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var t=r.history,e=normalizeToLocation(resolveToLocation(f,r.location),r.location),o=e?t.createHref(e):"",n=_extends({},s,{href:o,navigate:function(){var e=resolveToLocation(f,r.location);(c?t.replace:t.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||u:n.innerRef=u,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,r=new Array(e),t=0;t<e;t++)r[t]=arguments[t];return r.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var r=e["aria-current"],l=void 0===r?"page":r,t=e.activeClassName,p=void 0===t?"active":t,h=e.activeStyle,R=e.className,d=e.exact,v=e.isActive,y=e.location,m=e.strict,w=e.style,_=e.to,L=e.innerRef,x=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var r=y||e.location,t=normalizeToLocation(resolveToLocation(_,r),r),o=t.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(r.pathname,{path:n,exact:d,strict:m}):null,i=!!(v?v(a,r):a),c=i?joinClassnames(R,p):R,f=i?_extends({},w,{},h):w,u=_extends({"aria-current":i&&l||null,className:c,style:f,to:t},x);return forwardRefShim$1!==forwardRef$1?u.ref=s||L:u.innerRef=L,React.createElement(Link,u)})});Object.keys(reactRouter).forEach(function(e){"default"!==e&&Object.defineProperty(exports,e,{enumerable:!0,get:function(){return reactRouter[e]}})}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1));__webpack_require__(8);var history=__webpack_require__(11);__webpack_require__(6);var createContext=_interopDefault(__webpack_require__(48)),invariant=_interopDefault(__webpack_require__(5)),pathToRegexp=_interopDefault(__webpack_require__(49));__webpack_require__(13);var hoistStatics=_interopDefault(__webpack_require__(46));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&this.unlisten()},e.render=function(){return React.createElement(context.Provider,{children:this.props.children||null,value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}})},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&0===r.length&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(context).history}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){return t?matchPath(useLocation().pathname,t):useContext(context).match}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(58);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(51).enable();
	  window.Promise = __webpack_require__(50);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(70);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(7);


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var Sortable = __webpack_require__(67);
	var Sortable__default = _interopDefault(Sortable);
	var classNames = _interopDefault(__webpack_require__(41));
	var react = __webpack_require__(1);
	var invariant = _interopDefault(__webpack_require__(5));
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	}
	
	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}
	
	function __spread() {
	    for (var ar = [], i = 0; i < arguments.length; i++)
	        ar = ar.concat(__read(arguments[i]));
	    return ar;
	}
	
	/**
	 * Removes the `node` from the DOM
	 * @param node
	 */
	function removeNode(node) {
	    if (node.parentElement !== null)
	        node.parentElement.removeChild(node);
	}
	/**
	 * Inserts the `newChild` node at the given index in a parent
	 * @param parent The parent HTML Element.
	 * @param newChild A HTML eement to add as a child of the parent.
	 * @param index index of the parent to place the new child in.
	 */
	function insertNodeAt(parent, newChild, index) {
	    var refChild = parent.children[index] || null;
	    parent.insertBefore(newChild, refChild);
	}
	function removeNodes(customs) {
	    customs.forEach(function (curr) { return removeNode(curr.element); });
	}
	function insertNodes(customs) {
	    customs.forEach(function (curr) {
	        insertNodeAt(curr.parentElement, curr.element, curr.oldIndex);
	    });
	}
	function createCustoms(evt, list) {
	    var mode = getMode(evt);
	    var parentElement = { parentElement: evt.from };
	    var custom = [];
	    switch (mode) {
	        case "normal":
	            var item = {
	                element: evt.item,
	                newIndex: evt.newIndex,
	                oldIndex: evt.oldIndex,
	                parentElement: evt.from
	            };
	            custom = [item];
	            break;
	        case "swap":
	            var drag = __assign({ element: evt.item, oldIndex: evt.oldIndex, newIndex: evt.newIndex }, parentElement);
	            var swap = __assign({ element: evt.swapItem, oldIndex: evt.newIndex, newIndex: evt.oldIndex }, parentElement);
	            custom = [drag, swap];
	            break;
	        case "multidrag":
	            custom = evt.oldIndicies.map(function (curr, index) { return (__assign({ element: curr.multiDragElement, oldIndex: curr.index, newIndex: evt.newIndicies[index].index }, parentElement)); });
	            break;
	    }
	    var customs = createNormalized(custom, list);
	    return customs;
	}
	/** moves items form old index to new index without breaking anything ideally. */
	function handleStateChanges(normalized, list) {
	    var a = handleStateRemove(normalized, list);
	    var b = handleStateAdd(normalized, a);
	    return b;
	}
	function handleStateRemove(normalized, list) {
	    var newList = __spread(list);
	    normalized
	        .concat()
	        .reverse()
	        .forEach(function (curr) { return newList.splice(curr.oldIndex, 1); });
	    return newList;
	}
	function handleStateAdd(normalized, list) {
	    var newList = __spread(list);
	    normalized.forEach(function (curr) { return newList.splice(curr.newIndex, 0, curr.item); });
	    return newList;
	}
	function getMode(evt) {
	    if (evt.oldIndicies && evt.oldIndicies.length > 0)
	        return "multidrag";
	    if (evt.swapItem)
	        return "swap";
	    return "normal";
	}
	function createNormalized(inputs, list) {
	    var normalized = inputs
	        .map(function (curr) { return (__assign(__assign({}, curr), { item: list[curr.oldIndex] })); })
	        .sort(function (a, b) { return a.oldIndex - b.oldIndex; });
	    return normalized;
	}
	/**
	 * Removes the following group of properties from `props`,
	 * leaving only `Sortable.Options` without any `on` methods.
	 * @param props `ReactSortable.Props`
	 */
	function destructurePropsForOptions(props) {
	    var 
	    // react sortable props
	    list = props.list, setList = props.setList, children = props.children, tag = props.tag, style = props.style, className = props.className, clone = props.clone, 
	    // sortable options that have methods we want to overwrite
	    onAdd = props.onAdd, onChange = props.onChange, onChoose = props.onChoose, onClone = props.onClone, onEnd = props.onEnd, onFilter = props.onFilter, onRemove = props.onRemove, onSort = props.onSort, onStart = props.onStart, onUnchoose = props.onUnchoose, onUpdate = props.onUpdate, onMove = props.onMove, onSpill = props.onSpill, onSelect = props.onSelect, onDeselect = props.onDeselect, options = __rest(props, ["list", "setList", "children", "tag", "style", "className", "clone", "onAdd", "onChange", "onChoose", "onClone", "onEnd", "onFilter", "onRemove", "onSort", "onStart", "onUnchoose", "onUpdate", "onMove", "onSpill", "onSelect", "onDeselect"]);
	    return options;
	}
	
	/** Holds a global reference for which react element is being dragged */
	// @todo - use context to manage this. How does one use 2 different providers?
	var store = { dragging: null };
	var ReactSortable = /** @class */ (function (_super) {
	    __extends(ReactSortable, _super);
	    function ReactSortable(props) {
	        var _this = _super.call(this, props) || this;
	        // @todo forward ref this component
	        _this.ref = react.createRef();
	        // make all state false because we can't change sortable unless a mouse gesture is made.
	        var newList = __spread(props.list).map(function (item) { return (__assign(__assign({}, item), { chosen: false, selected: false })); });
	        props.setList(newList, _this.sortable, store);
	        invariant(
	        //@ts-ignore
	        !props.plugins, "\nPlugins prop is no longer supported.\nInstead, mount it with \"Sortable.mount(new MultiDrag())\"\nPlease read the updated README.md at https://github.com/SortableJS/react-sortablejs.\n      ");
	        return _this;
	    }
	    ReactSortable.prototype.componentDidMount = function () {
	        if (this.ref.current === null)
	            return;
	        var newOptions = this.makeOptions();
	        Sortable__default.create(this.ref.current, newOptions);
	    };
	    ReactSortable.prototype.render = function () {
	        var _a = this.props, tag = _a.tag, style = _a.style, className = _a.className, id = _a.id;
	        var classicProps = { style: style, className: className, id: id };
	        // if no tag, default to a `div` element.
	        var newTag = !tag || tag === null ? "div" : tag;
	        return react.createElement(newTag, __assign({ 
	            // @todo - find a way (perhaps with the callback) to allow AntD components to work
	            ref: this.ref }, classicProps), this.getChildren());
	    };
	    ReactSortable.prototype.getChildren = function () {
	        var _a = this.props, children = _a.children, dataIdAttr = _a.dataIdAttr, _b = _a.selectedClass, selectedClass = _b === void 0 ? "sortable-selected" : _b, _c = _a.chosenClass, chosenClass = _c === void 0 ? "sortable-chosen" : _c, _d = _a.dragClass, _e = _a.fallbackClass, _f = _a.ghostClass, _g = _a.swapClass, _h = _a.filter, filter = _h === void 0 ? "sortable-filter" : _h, list = _a.list;
	        // if no children, don't do anything.
	        if (!children || children == null)
	            return null;
	        var dataid = dataIdAttr || "data-id";
	        return react.Children.map(children, function (child, index) {
	            var _a, _b, _c;
	            var item = list[index];
	            var prevClassName = child.props.className;
	            // @todo - handle the function if avalable. I don't think anyone will be doing this soon.
	            var filtered = typeof filter === "string" && (_a = {},
	                _a[filter.replace(".", "")] = !!item.filtered,
	                _a);
	            var className = classNames(prevClassName, __assign((_b = {}, _b[selectedClass] = item.selected, _b[chosenClass] = item.chosen, _b), filtered
	            // [dragClass]: true,
	            // [fallbackClass]: true,
	            // [ghostClass]: true,
	            // [swapClass]: true
	            ));
	            return react.cloneElement(child, (_c = {},
	                _c[dataid] = child.key,
	                _c.className = className,
	                _c));
	        });
	    };
	    Object.defineProperty(ReactSortable.prototype, "sortable", {
	        /** Appends the `sortable` property to this component */
	        get: function () {
	            var el = this.ref.current;
	            if (el === null)
	                return null;
	            var key = Object.keys(el).find(function (k) { return k.includes("Sortable"); });
	            if (!key)
	                return null;
	            //@ts-ignore - I know what I'm doing.
	            return el[key];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Converts all the props from `ReactSortable` into the `options` object that `Sortable.create(el, [options])` can use. */
	    ReactSortable.prototype.makeOptions = function () {
	        var _this = this;
	        var DOMHandlers = [
	            "onAdd",
	            "onChoose",
	            "onDeselect",
	            "onEnd",
	            "onRemove",
	            "onSelect",
	            "onSpill",
	            "onStart",
	            "onUnchoose",
	            "onUpdate"
	        ];
	        var NonDOMHandlers = [
	            "onChange",
	            "onClone",
	            "onFilter",
	            "onSort"
	        ];
	        var newOptions = destructurePropsForOptions(this.props);
	        DOMHandlers.forEach(function (name) { return (newOptions[name] = _this.prepareOnHandlerPropAndDOM(name)); });
	        NonDOMHandlers.forEach(function (name) { return (newOptions[name] = _this.prepareOnHandlerProp(name)); });
	        /** onMove has 2 arguments and needs to be handled seperately. */
	        var onMove = function (evt, originalEvt) {
	            var onMove = _this.props.onMove;
	            var defaultValue = evt.willInsertAfter || -1;
	            if (!onMove)
	                return defaultValue;
	            var result = onMove(evt, originalEvt, _this.sortable, store);
	            if (typeof result === 'undefined')
	                return false;
	            return result;
	        };
	        return __assign(__assign({}, newOptions), { onMove: onMove });
	    };
	    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop & an `on[Handler]` ReactSortable method.  */
	    ReactSortable.prototype.prepareOnHandlerPropAndDOM = function (evtName) {
	        var _this = this;
	        return function (evt) {
	            // call the component prop
	            _this.callOnHandlerProp(evt, evtName);
	            // calls state change
	            //@ts-ignore - until @types multidrag item is in
	            _this[evtName](evt);
	        };
	    };
	    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop */
	    ReactSortable.prototype.prepareOnHandlerProp = function (evtName) {
	        var _this = this;
	        return function (evt) {
	            // call the component prop
	            _this.callOnHandlerProp(evt, evtName);
	        };
	    };
	    /** Calls the `props.on[Handler]` function */
	    ReactSortable.prototype.callOnHandlerProp = function (evt, evtName) {
	        var propEvent = this.props[evtName];
	        if (propEvent)
	            propEvent(evt, this.sortable, store);
	    };
	    // SORTABLE DOM HANDLING
	    ReactSortable.prototype.onAdd = function (evt) {
	        var _a = this.props, list = _a.list, setList = _a.setList;
	        var otherList = __spread(store.dragging.props.list);
	        var customs = createCustoms(evt, otherList);
	        removeNodes(customs);
	        var newList = handleStateAdd(customs, list);
	        setList(newList, this.sortable, store);
	    };
	    ReactSortable.prototype.onRemove = function (evt) {
	        var _this = this;
	        var _a = this.props, list = _a.list, setList = _a.setList;
	        var mode = getMode(evt);
	        var customs = createCustoms(evt, list);
	        insertNodes(customs);
	        var newList = __spread(list);
	        // remove state if not in clone mode. otherwise, keep.
	        if (evt.pullMode !== "clone")
	            newList = handleStateRemove(customs, newList);
	        // if clone, it doesn't really remove. instead it clones in place.
	        // @todo -
	        else {
	            // switch used to get the clone
	            var customClones = customs;
	            switch (mode) {
	                case "multidrag":
	                    customClones = customs.map(function (item, index) { return (__assign(__assign({}, item), { element: evt.clones[index] })); });
	                    break;
	                case "normal":
	                    customClones = customs.map(function (item, index) { return (__assign(__assign({}, item), { element: evt.clone })); });
	                    break;
	                case "swap":
	                default: {
	                    invariant(true, "mode \"" + mode + "\" cannot clone. Please remove \"props.clone\" from <ReactSortable/> when using the \"" + mode + "\" plugin");
	                }
	            }
	            removeNodes(customClones);
	            // replace selected items with cloned items
	            customs.forEach(function (curr) {
	                var index = curr.oldIndex;
	                var newItem = _this.props.clone(curr.item, evt);
	                newList.splice(index, 1, newItem);
	            });
	        }
	        // remove item.selected from list
	        newList = newList.map(function (item) { return (__assign(__assign({}, item), { selected: false })); });
	        setList(newList, this.sortable, store);
	    };
	    ReactSortable.prototype.onUpdate = function (evt) {
	        var _a = this.props, list = _a.list, setList = _a.setList;
	        var customs = createCustoms(evt, list);
	        removeNodes(customs);
	        insertNodes(customs);
	        var newList = handleStateChanges(customs, list);
	        return setList(newList, this.sortable, store);
	    };
	    ReactSortable.prototype.onStart = function (evt) {
	        store.dragging = this;
	    };
	    ReactSortable.prototype.onEnd = function (evt) {
	        store.dragging = null;
	    };
	    ReactSortable.prototype.onChoose = function (evt) {
	        var _a = this.props, list = _a.list, setList = _a.setList;
	        var newList = __spread(list);
	        newList[evt.oldIndex].chosen = true;
	        setList(newList, this.sortable, store);
	    };
	    ReactSortable.prototype.onUnchoose = function (evt) {
	        var _a = this.props, list = _a.list, setList = _a.setList;
	        var newList = __spread(list);
	        newList[evt.oldIndex].chosen = false;
	        setList(newList, this.sortable, store);
	    };
	    ReactSortable.prototype.onSpill = function (evt) {
	        var _a = this.props, removeOnSpill = _a.removeOnSpill, revertOnSpill = _a.revertOnSpill;
	        if (removeOnSpill && !revertOnSpill)
	            removeNode(evt.item);
	    };
	    ReactSortable.prototype.onSelect = function (evt) {
	        var _a = this.props, list = _a.list, setList = _a.setList;
	        var newList = __spread(list).map(function (item) { return (__assign(__assign({}, item), { selected: false })); });
	        evt.newIndicies.forEach(function (curr) {
	            var index = curr.index;
	            if (index === -1) {
	                console.log("\"" + evt.type + "\" had indice of \"" + curr.index + "\", which is probably -1 and doesn't usually happen here.");
	                console.log(evt);
	                return;
	            }
	            newList[index].selected = true;
	        });
	        setList(newList, this.sortable, store);
	    };
	    ReactSortable.prototype.onDeselect = function (evt) {
	        var _a = this.props, list = _a.list, setList = _a.setList;
	        var newList = __spread(list).map(function (item) { return (__assign(__assign({}, item), { selected: false })); });
	        evt.newIndicies.forEach(function (curr) {
	            var index = curr.index;
	            if (index === -1)
	                return;
	            newList[index].selected = true;
	        });
	        setList(newList, this.sortable, store);
	    };
	    ReactSortable.defaultProps = {
	        clone: function (item) { return item; }
	    };
	    return ReactSortable;
	}(react.Component));
	
	Object.defineProperty(exports, 'MultiDrag', {
	    enumerable: true,
	    get: function () {
	        return Sortable.MultiDrag;
	    }
	});
	exports.Sortable = Sortable__default;
	Object.defineProperty(exports, 'Swap', {
	    enumerable: true,
	    get: function () {
	        return Sortable.Swap;
	    }
	});
	exports.ReactSortable = ReactSortable;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(7),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.0";


/***/ },
/* 63 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(63);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 65 */
/***/ function(module, exports) {

	/** @license React v0.19.0
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(65);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**!
	 * Sortable 1.10.1
	 * @author	RubaXa   <trash@rubaxa.org>
	 * @author	owenm    <owen23355@gmail.com>
	 * @license MIT
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.Sortable = factory());
	}(this, function () { 'use strict';
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _extends() {
	    _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  function _objectSpread(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	      var ownKeys = Object.keys(source);
	
	      if (typeof Object.getOwnPropertySymbols === 'function') {
	        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	        }));
	      }
	
	      ownKeys.forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    }
	
	    return target;
	  }
	
	  function _objectWithoutPropertiesLoose(source, excluded) {
	    if (source == null) return {};
	    var target = {};
	    var sourceKeys = Object.keys(source);
	    var key, i;
	
	    for (i = 0; i < sourceKeys.length; i++) {
	      key = sourceKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      target[key] = source[key];
	    }
	
	    return target;
	  }
	
	  function _objectWithoutProperties(source, excluded) {
	    if (source == null) return {};
	
	    var target = _objectWithoutPropertiesLoose(source, excluded);
	
	    var key, i;
	
	    if (Object.getOwnPropertySymbols) {
	      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	      for (i = 0; i < sourceSymbolKeys.length; i++) {
	        key = sourceSymbolKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	        target[key] = source[key];
	      }
	    }
	
	    return target;
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) {
	      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	      return arr2;
	    }
	  }
	
	  function _iterableToArray(iter) {
	    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance");
	  }
	
	  var version = "1.10.1";
	
	  function userAgent(pattern) {
	    if (typeof window !== 'undefined' && window.navigator) {
	      return !!
	      /*@__PURE__*/
	      navigator.userAgent.match(pattern);
	    }
	  }
	
	  var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
	  var Edge = userAgent(/Edge/i);
	  var FireFox = userAgent(/firefox/i);
	  var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
	  var IOS = userAgent(/iP(ad|od|hone)/i);
	  var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
	
	  var captureMode = {
	    capture: false,
	    passive: false
	  };
	
	  function on(el, event, fn) {
	    el.addEventListener(event, fn, !IE11OrLess && captureMode);
	  }
	
	  function off(el, event, fn) {
	    el.removeEventListener(event, fn, !IE11OrLess && captureMode);
	  }
	
	  function matches(
	  /**HTMLElement*/
	  el,
	  /**String*/
	  selector) {
	    if (!selector) return;
	    selector[0] === '>' && (selector = selector.substring(1));
	
	    if (el) {
	      try {
	        if (el.matches) {
	          return el.matches(selector);
	        } else if (el.msMatchesSelector) {
	          return el.msMatchesSelector(selector);
	        } else if (el.webkitMatchesSelector) {
	          return el.webkitMatchesSelector(selector);
	        }
	      } catch (_) {
	        return false;
	      }
	    }
	
	    return false;
	  }
	
	  function getParentOrHost(el) {
	    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
	  }
	
	  function closest(
	  /**HTMLElement*/
	  el,
	  /**String*/
	  selector,
	  /**HTMLElement*/
	  ctx, includeCTX) {
	    if (el) {
	      ctx = ctx || document;
	
	      do {
	        if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
	          return el;
	        }
	
	        if (el === ctx) break;
	        /* jshint boss:true */
	      } while (el = getParentOrHost(el));
	    }
	
	    return null;
	  }
	
	  var R_SPACE = /\s+/g;
	
	  function toggleClass(el, name, state) {
	    if (el && name) {
	      if (el.classList) {
	        el.classList[state ? 'add' : 'remove'](name);
	      } else {
	        var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
	        el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
	      }
	    }
	  }
	
	  function css(el, prop, val) {
	    var style = el && el.style;
	
	    if (style) {
	      if (val === void 0) {
	        if (document.defaultView && document.defaultView.getComputedStyle) {
	          val = document.defaultView.getComputedStyle(el, '');
	        } else if (el.currentStyle) {
	          val = el.currentStyle;
	        }
	
	        return prop === void 0 ? val : val[prop];
	      } else {
	        if (!(prop in style) && prop.indexOf('webkit') === -1) {
	          prop = '-webkit-' + prop;
	        }
	
	        style[prop] = val + (typeof val === 'string' ? '' : 'px');
	      }
	    }
	  }
	
	  function matrix(el, selfOnly) {
	    var appliedTransforms = '';
	
	    if (typeof el === 'string') {
	      appliedTransforms = el;
	    } else {
	      do {
	        var transform = css(el, 'transform');
	
	        if (transform && transform !== 'none') {
	          appliedTransforms = transform + ' ' + appliedTransforms;
	        }
	        /* jshint boss:true */
	
	      } while (!selfOnly && (el = el.parentNode));
	    }
	
	    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix;
	    /*jshint -W056 */
	
	    return matrixFn && new matrixFn(appliedTransforms);
	  }
	
	  function find(ctx, tagName, iterator) {
	    if (ctx) {
	      var list = ctx.getElementsByTagName(tagName),
	          i = 0,
	          n = list.length;
	
	      if (iterator) {
	        for (; i < n; i++) {
	          iterator(list[i], i);
	        }
	      }
	
	      return list;
	    }
	
	    return [];
	  }
	
	  function getWindowScrollingElement() {
	    if (IE11OrLess) {
	      return document.documentElement;
	    } else {
	      return document.scrollingElement;
	    }
	  }
	  /**
	   * Returns the "bounding client rect" of given element
	   * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
	   * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
	   * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
	   * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
	   * @param  {[HTMLElement]} container              The parent the element will be placed in
	   * @return {Object}                               The boundingClientRect of el, with specified adjustments
	   */
	
	
	  function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
	    if (!el.getBoundingClientRect && el !== window) return;
	    var elRect, top, left, bottom, right, height, width;
	
	    if (el !== window && el !== getWindowScrollingElement()) {
	      elRect = el.getBoundingClientRect();
	      top = elRect.top;
	      left = elRect.left;
	      bottom = elRect.bottom;
	      right = elRect.right;
	      height = elRect.height;
	      width = elRect.width;
	    } else {
	      top = 0;
	      left = 0;
	      bottom = window.innerHeight;
	      right = window.innerWidth;
	      height = window.innerHeight;
	      width = window.innerWidth;
	    }
	
	    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
	      // Adjust for translate()
	      container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
	      // Not needed on <= IE11
	
	      if (!IE11OrLess) {
	        do {
	          if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
	            var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container
	
	            top -= containerRect.top + parseInt(css(container, 'border-top-width'));
	            left -= containerRect.left + parseInt(css(container, 'border-left-width'));
	            bottom = top + elRect.height;
	            right = left + elRect.width;
	            break;
	          }
	          /* jshint boss:true */
	
	        } while (container = container.parentNode);
	      }
	    }
	
	    if (undoScale && el !== window) {
	      // Adjust for scale()
	      var elMatrix = matrix(container || el),
	          scaleX = elMatrix && elMatrix.a,
	          scaleY = elMatrix && elMatrix.d;
	
	      if (elMatrix) {
	        top /= scaleY;
	        left /= scaleX;
	        width /= scaleX;
	        height /= scaleY;
	        bottom = top + height;
	        right = left + width;
	      }
	    }
	
	    return {
	      top: top,
	      left: left,
	      bottom: bottom,
	      right: right,
	      width: width,
	      height: height
	    };
	  }
	  /**
	   * Checks if a side of an element is scrolled past a side of its parents
	   * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
	   * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
	   * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
	   * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
	   */
	
	
	  function isScrolledPast(el, elSide, parentSide) {
	    var parent = getParentAutoScrollElement(el, true),
	        elSideVal = getRect(el)[elSide];
	    /* jshint boss:true */
	
	    while (parent) {
	      var parentSideVal = getRect(parent)[parentSide],
	          visible = void 0;
	
	      if (parentSide === 'top' || parentSide === 'left') {
	        visible = elSideVal >= parentSideVal;
	      } else {
	        visible = elSideVal <= parentSideVal;
	      }
	
	      if (!visible) return parent;
	      if (parent === getWindowScrollingElement()) break;
	      parent = getParentAutoScrollElement(parent, false);
	    }
	
	    return false;
	  }
	  /**
	   * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
	   * and non-draggable elements
	   * @param  {HTMLElement} el       The parent element
	   * @param  {Number} childNum      The index of the child
	   * @param  {Object} options       Parent Sortable's options
	   * @return {HTMLElement}          The child at index childNum, or null if not found
	   */
	
	
	  function getChild(el, childNum, options) {
	    var currentChild = 0,
	        i = 0,
	        children = el.children;
	
	    while (i < children.length) {
	      if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
	        if (currentChild === childNum) {
	          return children[i];
	        }
	
	        currentChild++;
	      }
	
	      i++;
	    }
	
	    return null;
	  }
	  /**
	   * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
	   * @param  {HTMLElement} el       Parent element
	   * @param  {selector} selector    Any other elements that should be ignored
	   * @return {HTMLElement}          The last child, ignoring ghostEl
	   */
	
	
	  function lastChild(el, selector) {
	    var last = el.lastElementChild;
	
	    while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
	      last = last.previousElementSibling;
	    }
	
	    return last || null;
	  }
	  /**
	   * Returns the index of an element within its parent for a selected set of
	   * elements
	   * @param  {HTMLElement} el
	   * @param  {selector} selector
	   * @return {number}
	   */
	
	
	  function index(el, selector) {
	    var index = 0;
	
	    if (!el || !el.parentNode) {
	      return -1;
	    }
	    /* jshint boss:true */
	
	
	    while (el = el.previousElementSibling) {
	      if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
	        index++;
	      }
	    }
	
	    return index;
	  }
	  /**
	   * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
	   * The value is returned in real pixels.
	   * @param  {HTMLElement} el
	   * @return {Array}             Offsets in the format of [left, top]
	   */
	
	
	  function getRelativeScrollOffset(el) {
	    var offsetLeft = 0,
	        offsetTop = 0,
	        winScroller = getWindowScrollingElement();
	
	    if (el) {
	      do {
	        var elMatrix = matrix(el),
	            scaleX = elMatrix.a,
	            scaleY = elMatrix.d;
	        offsetLeft += el.scrollLeft * scaleX;
	        offsetTop += el.scrollTop * scaleY;
	      } while (el !== winScroller && (el = el.parentNode));
	    }
	
	    return [offsetLeft, offsetTop];
	  }
	  /**
	   * Returns the index of the object within the given array
	   * @param  {Array} arr   Array that may or may not hold the object
	   * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
	   * @return {Number}      The index of the object in the array, or -1
	   */
	
	
	  function indexOfObject(arr, obj) {
	    for (var i in arr) {
	      if (!arr.hasOwnProperty(i)) continue;
	
	      for (var key in obj) {
	        if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
	      }
	    }
	
	    return -1;
	  }
	
	  function getParentAutoScrollElement(el, includeSelf) {
	    // skip to window
	    if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
	    var elem = el;
	    var gotSelf = false;
	
	    do {
	      // we don't need to get elem css if it isn't even overflowing in the first place (performance)
	      if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
	        var elemCSS = css(elem);
	
	        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
	          if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
	          if (gotSelf || includeSelf) return elem;
	          gotSelf = true;
	        }
	      }
	      /* jshint boss:true */
	
	    } while (elem = elem.parentNode);
	
	    return getWindowScrollingElement();
	  }
	
	  function extend(dst, src) {
	    if (dst && src) {
	      for (var key in src) {
	        if (src.hasOwnProperty(key)) {
	          dst[key] = src[key];
	        }
	      }
	    }
	
	    return dst;
	  }
	
	  function isRectEqual(rect1, rect2) {
	    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
	  }
	
	  var _throttleTimeout;
	
	  function throttle(callback, ms) {
	    return function () {
	      if (!_throttleTimeout) {
	        var args = arguments,
	            _this = this;
	
	        if (args.length === 1) {
	          callback.call(_this, args[0]);
	        } else {
	          callback.apply(_this, args);
	        }
	
	        _throttleTimeout = setTimeout(function () {
	          _throttleTimeout = void 0;
	        }, ms);
	      }
	    };
	  }
	
	  function cancelThrottle() {
	    clearTimeout(_throttleTimeout);
	    _throttleTimeout = void 0;
	  }
	
	  function scrollBy(el, x, y) {
	    el.scrollLeft += x;
	    el.scrollTop += y;
	  }
	
	  function clone(el) {
	    var Polymer = window.Polymer;
	    var $ = window.jQuery || window.Zepto;
	
	    if (Polymer && Polymer.dom) {
	      return Polymer.dom(el).cloneNode(true);
	    } else if ($) {
	      return $(el).clone(true)[0];
	    } else {
	      return el.cloneNode(true);
	    }
	  }
	
	  function setRect(el, rect) {
	    css(el, 'position', 'absolute');
	    css(el, 'top', rect.top);
	    css(el, 'left', rect.left);
	    css(el, 'width', rect.width);
	    css(el, 'height', rect.height);
	  }
	
	  function unsetRect(el) {
	    css(el, 'position', '');
	    css(el, 'top', '');
	    css(el, 'left', '');
	    css(el, 'width', '');
	    css(el, 'height', '');
	  }
	
	  var expando = 'Sortable' + new Date().getTime();
	
	  function AnimationStateManager() {
	    var animationStates = [],
	        animationCallbackId;
	    return {
	      captureAnimationState: function captureAnimationState() {
	        animationStates = [];
	        if (!this.options.animation) return;
	        var children = [].slice.call(this.el.children);
	        children.forEach(function (child) {
	          if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
	          animationStates.push({
	            target: child,
	            rect: getRect(child)
	          });
	
	          var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation
	
	
	          if (child.thisAnimationDuration) {
	            var childMatrix = matrix(child, true);
	
	            if (childMatrix) {
	              fromRect.top -= childMatrix.f;
	              fromRect.left -= childMatrix.e;
	            }
	          }
	
	          child.fromRect = fromRect;
	        });
	      },
	      addAnimationState: function addAnimationState(state) {
	        animationStates.push(state);
	      },
	      removeAnimationState: function removeAnimationState(target) {
	        animationStates.splice(indexOfObject(animationStates, {
	          target: target
	        }), 1);
	      },
	      animateAll: function animateAll(callback) {
	        var _this = this;
	
	        if (!this.options.animation) {
	          clearTimeout(animationCallbackId);
	          if (typeof callback === 'function') callback();
	          return;
	        }
	
	        var animating = false,
	            animationTime = 0;
	        animationStates.forEach(function (state) {
	          var time = 0,
	              target = state.target,
	              fromRect = target.fromRect,
	              toRect = getRect(target),
	              prevFromRect = target.prevFromRect,
	              prevToRect = target.prevToRect,
	              animatingRect = state.rect,
	              targetMatrix = matrix(target, true);
	
	          if (targetMatrix) {
	            // Compensate for current animation
	            toRect.top -= targetMatrix.f;
	            toRect.left -= targetMatrix.e;
	          }
	
	          target.toRect = toRect;
	
	          if (target.thisAnimationDuration) {
	            // Could also check if animatingRect is between fromRect and toRect
	            if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
	            (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
	              // If returning to same place as started from animation and on same axis
	              time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
	            }
	          } // if fromRect != toRect: animate
	
	
	          if (!isRectEqual(toRect, fromRect)) {
	            target.prevFromRect = fromRect;
	            target.prevToRect = toRect;
	
	            if (!time) {
	              time = _this.options.animation;
	            }
	
	            _this.animate(target, animatingRect, toRect, time);
	          }
	
	          if (time) {
	            animating = true;
	            animationTime = Math.max(animationTime, time);
	            clearTimeout(target.animationResetTimer);
	            target.animationResetTimer = setTimeout(function () {
	              target.animationTime = 0;
	              target.prevFromRect = null;
	              target.fromRect = null;
	              target.prevToRect = null;
	              target.thisAnimationDuration = null;
	            }, time);
	            target.thisAnimationDuration = time;
	          }
	        });
	        clearTimeout(animationCallbackId);
	
	        if (!animating) {
	          if (typeof callback === 'function') callback();
	        } else {
	          animationCallbackId = setTimeout(function () {
	            if (typeof callback === 'function') callback();
	          }, animationTime);
	        }
	
	        animationStates = [];
	      },
	      animate: function animate(target, currentRect, toRect, duration) {
	        if (duration) {
	          css(target, 'transition', '');
	          css(target, 'transform', '');
	          var elMatrix = matrix(this.el),
	              scaleX = elMatrix && elMatrix.a,
	              scaleY = elMatrix && elMatrix.d,
	              translateX = (currentRect.left - toRect.left) / (scaleX || 1),
	              translateY = (currentRect.top - toRect.top) / (scaleY || 1);
	          target.animatingX = !!translateX;
	          target.animatingY = !!translateY;
	          css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
	          repaint(target); // repaint
	
	          css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
	          css(target, 'transform', 'translate3d(0,0,0)');
	          typeof target.animated === 'number' && clearTimeout(target.animated);
	          target.animated = setTimeout(function () {
	            css(target, 'transition', '');
	            css(target, 'transform', '');
	            target.animated = false;
	            target.animatingX = false;
	            target.animatingY = false;
	          }, duration);
	        }
	      }
	    };
	  }
	
	  function repaint(target) {
	    return target.offsetWidth;
	  }
	
	  function calculateRealTime(animatingRect, fromRect, toRect, options) {
	    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
	  }
	
	  var plugins = [];
	  var defaults = {
	    initializeByDefault: true
	  };
	  var PluginManager = {
	    mount: function mount(plugin) {
	      // Set default static properties
	      for (var option in defaults) {
	        if (defaults.hasOwnProperty(option) && !(option in plugin)) {
	          plugin[option] = defaults[option];
	        }
	      }
	
	      plugins.push(plugin);
	    },
	    pluginEvent: function pluginEvent(eventName, sortable, evt) {
	      var _this = this;
	
	      this.eventCanceled = false;
	
	      evt.cancel = function () {
	        _this.eventCanceled = true;
	      };
	
	      var eventNameGlobal = eventName + 'Global';
	      plugins.forEach(function (plugin) {
	        if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable
	
	        if (sortable[plugin.pluginName][eventNameGlobal]) {
	          sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
	            sortable: sortable
	          }, evt));
	        } // Only fire plugin event if plugin is enabled in this sortable,
	        // and plugin has event defined
	
	
	        if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
	          sortable[plugin.pluginName][eventName](_objectSpread({
	            sortable: sortable
	          }, evt));
	        }
	      });
	    },
	    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
	      plugins.forEach(function (plugin) {
	        var pluginName = plugin.pluginName;
	        if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
	        var initialized = new plugin(sortable, el, sortable.options);
	        initialized.sortable = sortable;
	        initialized.options = sortable.options;
	        sortable[pluginName] = initialized; // Add default options from plugin
	
	        _extends(defaults, initialized.defaults);
	      });
	
	      for (var option in sortable.options) {
	        if (!sortable.options.hasOwnProperty(option)) continue;
	        var modified = this.modifyOption(sortable, option, sortable.options[option]);
	
	        if (typeof modified !== 'undefined') {
	          sortable.options[option] = modified;
	        }
	      }
	    },
	    getEventProperties: function getEventProperties(name, sortable) {
	      var eventProperties = {};
	      plugins.forEach(function (plugin) {
	        if (typeof plugin.eventProperties !== 'function') return;
	
	        _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
	      });
	      return eventProperties;
	    },
	    modifyOption: function modifyOption(sortable, name, value) {
	      var modifiedValue;
	      plugins.forEach(function (plugin) {
	        // Plugin must exist on the Sortable
	        if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
	
	        if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
	          modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
	        }
	      });
	      return modifiedValue;
	    }
	  };
	
	  function dispatchEvent(_ref) {
	    var sortable = _ref.sortable,
	        rootEl = _ref.rootEl,
	        name = _ref.name,
	        targetEl = _ref.targetEl,
	        cloneEl = _ref.cloneEl,
	        toEl = _ref.toEl,
	        fromEl = _ref.fromEl,
	        oldIndex = _ref.oldIndex,
	        newIndex = _ref.newIndex,
	        oldDraggableIndex = _ref.oldDraggableIndex,
	        newDraggableIndex = _ref.newDraggableIndex,
	        originalEvent = _ref.originalEvent,
	        putSortable = _ref.putSortable,
	        extraEventProperties = _ref.extraEventProperties;
	    sortable = sortable || rootEl && rootEl[expando];
	    if (!sortable) return;
	    var evt,
	        options = sortable.options,
	        onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature
	
	    if (window.CustomEvent && !IE11OrLess && !Edge) {
	      evt = new CustomEvent(name, {
	        bubbles: true,
	        cancelable: true
	      });
	    } else {
	      evt = document.createEvent('Event');
	      evt.initEvent(name, true, true);
	    }
	
	    evt.to = toEl || rootEl;
	    evt.from = fromEl || rootEl;
	    evt.item = targetEl || rootEl;
	    evt.clone = cloneEl;
	    evt.oldIndex = oldIndex;
	    evt.newIndex = newIndex;
	    evt.oldDraggableIndex = oldDraggableIndex;
	    evt.newDraggableIndex = newDraggableIndex;
	    evt.originalEvent = originalEvent;
	    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
	
	    var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));
	
	    for (var option in allEventProperties) {
	      evt[option] = allEventProperties[option];
	    }
	
	    if (rootEl) {
	      rootEl.dispatchEvent(evt);
	    }
	
	    if (options[onName]) {
	      options[onName].call(sortable, evt);
	    }
	  }
	
	  var pluginEvent = function pluginEvent(eventName, sortable) {
	    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	        originalEvent = _ref.evt,
	        data = _objectWithoutProperties(_ref, ["evt"]);
	
	    PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
	      dragEl: dragEl,
	      parentEl: parentEl,
	      ghostEl: ghostEl,
	      rootEl: rootEl,
	      nextEl: nextEl,
	      lastDownEl: lastDownEl,
	      cloneEl: cloneEl,
	      cloneHidden: cloneHidden,
	      dragStarted: moved,
	      putSortable: putSortable,
	      activeSortable: Sortable.active,
	      originalEvent: originalEvent,
	      oldIndex: oldIndex,
	      oldDraggableIndex: oldDraggableIndex,
	      newIndex: newIndex,
	      newDraggableIndex: newDraggableIndex,
	      hideGhostForTarget: _hideGhostForTarget,
	      unhideGhostForTarget: _unhideGhostForTarget,
	      cloneNowHidden: function cloneNowHidden() {
	        cloneHidden = true;
	      },
	      cloneNowShown: function cloneNowShown() {
	        cloneHidden = false;
	      },
	      dispatchSortableEvent: function dispatchSortableEvent(name) {
	        _dispatchEvent({
	          sortable: sortable,
	          name: name,
	          originalEvent: originalEvent
	        });
	      }
	    }, data));
	  };
	
	  function _dispatchEvent(info) {
	    dispatchEvent(_objectSpread({
	      putSortable: putSortable,
	      cloneEl: cloneEl,
	      targetEl: dragEl,
	      rootEl: rootEl,
	      oldIndex: oldIndex,
	      oldDraggableIndex: oldDraggableIndex,
	      newIndex: newIndex,
	      newDraggableIndex: newDraggableIndex
	    }, info));
	  }
	
	  var dragEl,
	      parentEl,
	      ghostEl,
	      rootEl,
	      nextEl,
	      lastDownEl,
	      cloneEl,
	      cloneHidden,
	      oldIndex,
	      newIndex,
	      oldDraggableIndex,
	      newDraggableIndex,
	      activeGroup,
	      putSortable,
	      awaitingDragStarted = false,
	      ignoreNextClick = false,
	      sortables = [],
	      tapEvt,
	      touchEvt,
	      lastDx,
	      lastDy,
	      tapDistanceLeft,
	      tapDistanceTop,
	      moved,
	      lastTarget,
	      lastDirection,
	      pastFirstInvertThresh = false,
	      isCircumstantialInvert = false,
	      targetMoveDistance,
	      // For positioning ghost absolutely
	  ghostRelativeParent,
	      ghostRelativeParentInitialScroll = [],
	      // (left, top)
	  _silent = false,
	      savedInputChecked = [];
	  /** @const */
	
	  var documentExists = typeof document !== 'undefined',
	      PositionGhostAbsolutely = IOS,
	      CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
	      // This will not pass for IE9, because IE9 DnD only works on anchors
	  supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
	      supportCssPointerEvents = function () {
	    if (!documentExists) return; // false when <= IE11
	
	    if (IE11OrLess) {
	      return false;
	    }
	
	    var el = document.createElement('x');
	    el.style.cssText = 'pointer-events:auto';
	    return el.style.pointerEvents === 'auto';
	  }(),
	      _detectDirection = function _detectDirection(el, options) {
	    var elCSS = css(el),
	        elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
	        child1 = getChild(el, 0, options),
	        child2 = getChild(el, 1, options),
	        firstChildCSS = child1 && css(child1),
	        secondChildCSS = child2 && css(child2),
	        firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
	        secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
	
	    if (elCSS.display === 'flex') {
	      return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
	    }
	
	    if (elCSS.display === 'grid') {
	      return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
	    }
	
	    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
	      var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
	      return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
	    }
	
	    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
	  },
	      _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
	    var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
	        dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
	        dragElOppLength = vertical ? dragRect.width : dragRect.height,
	        targetS1Opp = vertical ? targetRect.left : targetRect.top,
	        targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
	        targetOppLength = vertical ? targetRect.width : targetRect.height;
	    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
	  },
	
	  /**
	   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
	   * @param  {Number} x      X position
	   * @param  {Number} y      Y position
	   * @return {HTMLElement}   Element of the first found nearest Sortable
	   */
	  _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
	    var ret;
	    sortables.some(function (sortable) {
	      if (lastChild(sortable)) return;
	      var rect = getRect(sortable),
	          threshold = sortable[expando].options.emptyInsertThreshold,
	          insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
	          insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
	
	      if (threshold && insideHorizontally && insideVertically) {
	        return ret = sortable;
	      }
	    });
	    return ret;
	  },
	      _prepareGroup = function _prepareGroup(options) {
	    function toFn(value, pull) {
	      return function (to, from, dragEl, evt) {
	        var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
	
	        if (value == null && (pull || sameGroup)) {
	          // Default pull value
	          // Default pull and put value if same group
	          return true;
	        } else if (value == null || value === false) {
	          return false;
	        } else if (pull && value === 'clone') {
	          return value;
	        } else if (typeof value === 'function') {
	          return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
	        } else {
	          var otherGroup = (pull ? to : from).options.group.name;
	          return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
	        }
	      };
	    }
	
	    var group = {};
	    var originalGroup = options.group;
	
	    if (!originalGroup || _typeof(originalGroup) != 'object') {
	      originalGroup = {
	        name: originalGroup
	      };
	    }
	
	    group.name = originalGroup.name;
	    group.checkPull = toFn(originalGroup.pull, true);
	    group.checkPut = toFn(originalGroup.put);
	    group.revertClone = originalGroup.revertClone;
	    options.group = group;
	  },
	      _hideGhostForTarget = function _hideGhostForTarget() {
	    if (!supportCssPointerEvents && ghostEl) {
	      css(ghostEl, 'display', 'none');
	    }
	  },
	      _unhideGhostForTarget = function _unhideGhostForTarget() {
	    if (!supportCssPointerEvents && ghostEl) {
	      css(ghostEl, 'display', '');
	    }
	  }; // #1184 fix - Prevent click event on fallback if dragged but item not changed position
	
	
	  if (documentExists) {
	    document.addEventListener('click', function (evt) {
	      if (ignoreNextClick) {
	        evt.preventDefault();
	        evt.stopPropagation && evt.stopPropagation();
	        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
	        ignoreNextClick = false;
	        return false;
	      }
	    }, true);
	  }
	
	  var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
	    if (dragEl) {
	      evt = evt.touches ? evt.touches[0] : evt;
	
	      var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
	
	      if (nearest) {
	        // Create imitation event
	        var event = {};
	
	        for (var i in evt) {
	          if (evt.hasOwnProperty(i)) {
	            event[i] = evt[i];
	          }
	        }
	
	        event.target = event.rootEl = nearest;
	        event.preventDefault = void 0;
	        event.stopPropagation = void 0;
	
	        nearest[expando]._onDragOver(event);
	      }
	    }
	  };
	
	  var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
	    if (dragEl) {
	      dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
	    }
	  };
	  /**
	   * @class  Sortable
	   * @param  {HTMLElement}  el
	   * @param  {Object}       [options]
	   */
	
	
	  function Sortable(el, options) {
	    if (!(el && el.nodeType && el.nodeType === 1)) {
	      throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
	    }
	
	    this.el = el; // root element
	
	    this.options = options = _extends({}, options); // Export instance
	
	    el[expando] = this;
	    var defaults = {
	      group: null,
	      sort: true,
	      disabled: false,
	      store: null,
	      handle: null,
	      draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
	      swapThreshold: 1,
	      // percentage; 0 <= x <= 1
	      invertSwap: false,
	      // invert always
	      invertedSwapThreshold: null,
	      // will be set to same as swapThreshold if default
	      removeCloneOnHide: true,
	      direction: function direction() {
	        return _detectDirection(el, this.options);
	      },
	      ghostClass: 'sortable-ghost',
	      chosenClass: 'sortable-chosen',
	      dragClass: 'sortable-drag',
	      ignore: 'a, img',
	      filter: null,
	      preventOnFilter: true,
	      animation: 0,
	      easing: null,
	      setData: function setData(dataTransfer, dragEl) {
	        dataTransfer.setData('Text', dragEl.textContent);
	      },
	      dropBubble: false,
	      dragoverBubble: false,
	      dataIdAttr: 'data-id',
	      delay: 0,
	      delayOnTouchOnly: false,
	      touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
	      forceFallback: false,
	      fallbackClass: 'sortable-fallback',
	      fallbackOnBody: false,
	      fallbackTolerance: 0,
	      fallbackOffset: {
	        x: 0,
	        y: 0
	      },
	      supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
	      emptyInsertThreshold: 5
	    };
	    PluginManager.initializePlugins(this, el, defaults); // Set default options
	
	    for (var name in defaults) {
	      !(name in options) && (options[name] = defaults[name]);
	    }
	
	    _prepareGroup(options); // Bind all private methods
	
	
	    for (var fn in this) {
	      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
	        this[fn] = this[fn].bind(this);
	      }
	    } // Setup drag mode
	
	
	    this.nativeDraggable = options.forceFallback ? false : supportDraggable;
	
	    if (this.nativeDraggable) {
	      // Touch start threshold cannot be greater than the native dragstart threshold
	      this.options.touchStartThreshold = 1;
	    } // Bind events
	
	
	    if (options.supportPointer) {
	      on(el, 'pointerdown', this._onTapStart);
	    } else {
	      on(el, 'mousedown', this._onTapStart);
	      on(el, 'touchstart', this._onTapStart);
	    }
	
	    if (this.nativeDraggable) {
	      on(el, 'dragover', this);
	      on(el, 'dragenter', this);
	    }
	
	    sortables.push(this.el); // Restore sorting
	
	    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager
	
	    _extends(this, AnimationStateManager());
	  }
	
	  Sortable.prototype =
	  /** @lends Sortable.prototype */
	  {
	    constructor: Sortable,
	    _isOutsideThisEl: function _isOutsideThisEl(target) {
	      if (!this.el.contains(target) && target !== this.el) {
	        lastTarget = null;
	      }
	    },
	    _getDirection: function _getDirection(evt, target) {
	      return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
	    },
	    _onTapStart: function _onTapStart(
	    /** Event|TouchEvent */
	    evt) {
	      if (!evt.cancelable) return;
	
	      var _this = this,
	          el = this.el,
	          options = this.options,
	          preventOnFilter = options.preventOnFilter,
	          type = evt.type,
	          touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
	          target = (touch || evt).target,
	          originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
	          filter = options.filter;
	
	      _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
	
	
	      if (dragEl) {
	        return;
	      }
	
	      if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
	        return; // only left button and enabled
	      } // cancel dnd if original target is content editable
	
	
	      if (originalTarget.isContentEditable) {
	        return;
	      }
	
	      target = closest(target, options.draggable, el, false);
	
	      if (target && target.animated) {
	        return;
	      }
	
	      if (lastDownEl === target) {
	        // Ignoring duplicate `down`
	        return;
	      } // Get the index of the dragged element within its parent
	
	
	      oldIndex = index(target);
	      oldDraggableIndex = index(target, options.draggable); // Check filter
	
	      if (typeof filter === 'function') {
	        if (filter.call(this, evt, target, this)) {
	          _dispatchEvent({
	            sortable: _this,
	            rootEl: originalTarget,
	            name: 'filter',
	            targetEl: target,
	            toEl: el,
	            fromEl: el
	          });
	
	          pluginEvent('filter', _this, {
	            evt: evt
	          });
	          preventOnFilter && evt.cancelable && evt.preventDefault();
	          return; // cancel dnd
	        }
	      } else if (filter) {
	        filter = filter.split(',').some(function (criteria) {
	          criteria = closest(originalTarget, criteria.trim(), el, false);
	
	          if (criteria) {
	            _dispatchEvent({
	              sortable: _this,
	              rootEl: criteria,
	              name: 'filter',
	              targetEl: target,
	              fromEl: el,
	              toEl: el
	            });
	
	            pluginEvent('filter', _this, {
	              evt: evt
	            });
	            return true;
	          }
	        });
	
	        if (filter) {
	          preventOnFilter && evt.cancelable && evt.preventDefault();
	          return; // cancel dnd
	        }
	      }
	
	      if (options.handle && !closest(originalTarget, options.handle, el, false)) {
	        return;
	      } // Prepare `dragstart`
	
	
	      this._prepareDragStart(evt, touch, target);
	    },
	    _prepareDragStart: function _prepareDragStart(
	    /** Event */
	    evt,
	    /** Touch */
	    touch,
	    /** HTMLElement */
	    target) {
	      var _this = this,
	          el = _this.el,
	          options = _this.options,
	          ownerDocument = el.ownerDocument,
	          dragStartFn;
	
	      if (target && !dragEl && target.parentNode === el) {
	        var dragRect = getRect(target);
	        rootEl = el;
	        dragEl = target;
	        parentEl = dragEl.parentNode;
	        nextEl = dragEl.nextSibling;
	        lastDownEl = target;
	        activeGroup = options.group;
	        Sortable.dragged = dragEl;
	        tapEvt = {
	          target: dragEl,
	          clientX: (touch || evt).clientX,
	          clientY: (touch || evt).clientY
	        };
	        tapDistanceLeft = tapEvt.clientX - dragRect.left;
	        tapDistanceTop = tapEvt.clientY - dragRect.top;
	        this._lastX = (touch || evt).clientX;
	        this._lastY = (touch || evt).clientY;
	        dragEl.style['will-change'] = 'all';
	
	        dragStartFn = function dragStartFn() {
	          pluginEvent('delayEnded', _this, {
	            evt: evt
	          });
	
	          if (Sortable.eventCanceled) {
	            _this._onDrop();
	
	            return;
	          } // Delayed drag has been triggered
	          // we can re-enable the events: touchmove/mousemove
	
	
	          _this._disableDelayedDragEvents();
	
	          if (!FireFox && _this.nativeDraggable) {
	            dragEl.draggable = true;
	          } // Bind the events: dragstart/dragend
	
	
	          _this._triggerDragStart(evt, touch); // Drag start event
	
	
	          _dispatchEvent({
	            sortable: _this,
	            name: 'choose',
	            originalEvent: evt
	          }); // Chosen item
	
	
	          toggleClass(dragEl, options.chosenClass, true);
	        }; // Disable "draggable"
	
	
	        options.ignore.split(',').forEach(function (criteria) {
	          find(dragEl, criteria.trim(), _disableDraggable);
	        });
	        on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
	        on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
	        on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
	        on(ownerDocument, 'mouseup', _this._onDrop);
	        on(ownerDocument, 'touchend', _this._onDrop);
	        on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)
	
	        if (FireFox && this.nativeDraggable) {
	          this.options.touchStartThreshold = 4;
	          dragEl.draggable = true;
	        }
	
	        pluginEvent('delayStart', this, {
	          evt: evt
	        }); // Delay is impossible for native DnD in Edge or IE
	
	        if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
	          if (Sortable.eventCanceled) {
	            this._onDrop();
	
	            return;
	          } // If the user moves the pointer or let go the click or touch
	          // before the delay has been reached:
	          // disable the delayed drag
	
	
	          on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
	          on(ownerDocument, 'touchend', _this._disableDelayedDrag);
	          on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
	          on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
	          on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
	          options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
	          _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
	        } else {
	          dragStartFn();
	        }
	      }
	    },
	    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
	    /** TouchEvent|PointerEvent **/
	    e) {
	      var touch = e.touches ? e.touches[0] : e;
	
	      if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
	        this._disableDelayedDrag();
	      }
	    },
	    _disableDelayedDrag: function _disableDelayedDrag() {
	      dragEl && _disableDraggable(dragEl);
	      clearTimeout(this._dragStartTimer);
	
	      this._disableDelayedDragEvents();
	    },
	    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
	      var ownerDocument = this.el.ownerDocument;
	      off(ownerDocument, 'mouseup', this._disableDelayedDrag);
	      off(ownerDocument, 'touchend', this._disableDelayedDrag);
	      off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
	      off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
	      off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
	      off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
	    },
	    _triggerDragStart: function _triggerDragStart(
	    /** Event */
	    evt,
	    /** Touch */
	    touch) {
	      touch = touch || evt.pointerType == 'touch' && evt;
	
	      if (!this.nativeDraggable || touch) {
	        if (this.options.supportPointer) {
	          on(document, 'pointermove', this._onTouchMove);
	        } else if (touch) {
	          on(document, 'touchmove', this._onTouchMove);
	        } else {
	          on(document, 'mousemove', this._onTouchMove);
	        }
	      } else {
	        on(dragEl, 'dragend', this);
	        on(rootEl, 'dragstart', this._onDragStart);
	      }
	
	      try {
	        if (document.selection) {
	          // Timeout neccessary for IE9
	          _nextTick(function () {
	            document.selection.empty();
	          });
	        } else {
	          window.getSelection().removeAllRanges();
	        }
	      } catch (err) {}
	    },
	    _dragStarted: function _dragStarted(fallback, evt) {
	
	      awaitingDragStarted = false;
	
	      if (rootEl && dragEl) {
	        pluginEvent('dragStarted', this, {
	          evt: evt
	        });
	
	        if (this.nativeDraggable) {
	          on(document, 'dragover', _checkOutsideTargetEl);
	        }
	
	        var options = this.options; // Apply effect
	
	        !fallback && toggleClass(dragEl, options.dragClass, false);
	        toggleClass(dragEl, options.ghostClass, true);
	        Sortable.active = this;
	        fallback && this._appendGhost(); // Drag start event
	
	        _dispatchEvent({
	          sortable: this,
	          name: 'start',
	          originalEvent: evt
	        });
	      } else {
	        this._nulling();
	      }
	    },
	    _emulateDragOver: function _emulateDragOver() {
	      if (touchEvt) {
	        this._lastX = touchEvt.clientX;
	        this._lastY = touchEvt.clientY;
	
	        _hideGhostForTarget();
	
	        var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
	        var parent = target;
	
	        while (target && target.shadowRoot) {
	          target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
	          if (target === parent) break;
	          parent = target;
	        }
	
	        dragEl.parentNode[expando]._isOutsideThisEl(target);
	
	        if (parent) {
	          do {
	            if (parent[expando]) {
	              var inserted = void 0;
	              inserted = parent[expando]._onDragOver({
	                clientX: touchEvt.clientX,
	                clientY: touchEvt.clientY,
	                target: target,
	                rootEl: parent
	              });
	
	              if (inserted && !this.options.dragoverBubble) {
	                break;
	              }
	            }
	
	            target = parent; // store last element
	          }
	          /* jshint boss:true */
	          while (parent = parent.parentNode);
	        }
	
	        _unhideGhostForTarget();
	      }
	    },
	    _onTouchMove: function _onTouchMove(
	    /**TouchEvent*/
	    evt) {
	      if (tapEvt) {
	        var options = this.options,
	            fallbackTolerance = options.fallbackTolerance,
	            fallbackOffset = options.fallbackOffset,
	            touch = evt.touches ? evt.touches[0] : evt,
	            ghostMatrix = ghostEl && matrix(ghostEl),
	            scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
	            scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
	            relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
	            dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
	            dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging
	
	        if (!Sortable.active && !awaitingDragStarted) {
	          if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
	            return;
	          }
	
	          this._onDragStart(evt, true);
	        }
	
	        if (ghostEl) {
	          if (ghostMatrix) {
	            ghostMatrix.e += dx - (lastDx || 0);
	            ghostMatrix.f += dy - (lastDy || 0);
	          } else {
	            ghostMatrix = {
	              a: 1,
	              b: 0,
	              c: 0,
	              d: 1,
	              e: dx,
	              f: dy
	            };
	          }
	
	          var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
	          css(ghostEl, 'webkitTransform', cssMatrix);
	          css(ghostEl, 'mozTransform', cssMatrix);
	          css(ghostEl, 'msTransform', cssMatrix);
	          css(ghostEl, 'transform', cssMatrix);
	          lastDx = dx;
	          lastDy = dy;
	          touchEvt = touch;
	        }
	
	        evt.cancelable && evt.preventDefault();
	      }
	    },
	    _appendGhost: function _appendGhost() {
	      // Bug if using scale(): https://stackoverflow.com/questions/2637058
	      // Not being adjusted for
	      if (!ghostEl) {
	        var container = this.options.fallbackOnBody ? document.body : rootEl,
	            rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
	            options = this.options; // Position absolutely
	
	        if (PositionGhostAbsolutely) {
	          // Get relatively positioned parent
	          ghostRelativeParent = container;
	
	          while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
	            ghostRelativeParent = ghostRelativeParent.parentNode;
	          }
	
	          if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
	            if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
	            rect.top += ghostRelativeParent.scrollTop;
	            rect.left += ghostRelativeParent.scrollLeft;
	          } else {
	            ghostRelativeParent = getWindowScrollingElement();
	          }
	
	          ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
	        }
	
	        ghostEl = dragEl.cloneNode(true);
	        toggleClass(ghostEl, options.ghostClass, false);
	        toggleClass(ghostEl, options.fallbackClass, true);
	        toggleClass(ghostEl, options.dragClass, true);
	        css(ghostEl, 'transition', '');
	        css(ghostEl, 'transform', '');
	        css(ghostEl, 'box-sizing', 'border-box');
	        css(ghostEl, 'margin', 0);
	        css(ghostEl, 'top', rect.top);
	        css(ghostEl, 'left', rect.left);
	        css(ghostEl, 'width', rect.width);
	        css(ghostEl, 'height', rect.height);
	        css(ghostEl, 'opacity', '0.8');
	        css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
	        css(ghostEl, 'zIndex', '100000');
	        css(ghostEl, 'pointerEvents', 'none');
	        Sortable.ghost = ghostEl;
	        container.appendChild(ghostEl); // Set transform-origin
	
	        css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
	      }
	    },
	    _onDragStart: function _onDragStart(
	    /**Event*/
	    evt,
	    /**boolean*/
	    fallback) {
	      var _this = this;
	
	      var dataTransfer = evt.dataTransfer;
	      var options = _this.options;
	      pluginEvent('dragStart', this, {
	        evt: evt
	      });
	
	      if (Sortable.eventCanceled) {
	        this._onDrop();
	
	        return;
	      }
	
	      pluginEvent('setupClone', this);
	
	      if (!Sortable.eventCanceled) {
	        cloneEl = clone(dragEl);
	        cloneEl.draggable = false;
	        cloneEl.style['will-change'] = '';
	
	        this._hideClone();
	
	        toggleClass(cloneEl, this.options.chosenClass, false);
	        Sortable.clone = cloneEl;
	      } // #1143: IFrame support workaround
	
	
	      _this.cloneId = _nextTick(function () {
	        pluginEvent('clone', _this);
	        if (Sortable.eventCanceled) return;
	
	        if (!_this.options.removeCloneOnHide) {
	          rootEl.insertBefore(cloneEl, dragEl);
	        }
	
	        _this._hideClone();
	
	        _dispatchEvent({
	          sortable: _this,
	          name: 'clone'
	        });
	      });
	      !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events
	
	      if (fallback) {
	        ignoreNextClick = true;
	        _this._loopId = setInterval(_this._emulateDragOver, 50);
	      } else {
	        // Undo what was set in _prepareDragStart before drag started
	        off(document, 'mouseup', _this._onDrop);
	        off(document, 'touchend', _this._onDrop);
	        off(document, 'touchcancel', _this._onDrop);
	
	        if (dataTransfer) {
	          dataTransfer.effectAllowed = 'move';
	          options.setData && options.setData.call(_this, dataTransfer, dragEl);
	        }
	
	        on(document, 'drop', _this); // #1276 fix:
	
	        css(dragEl, 'transform', 'translateZ(0)');
	      }
	
	      awaitingDragStarted = true;
	      _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
	      on(document, 'selectstart', _this);
	      moved = true;
	
	      if (Safari) {
	        css(document.body, 'user-select', 'none');
	      }
	    },
	    // Returns true - if no further action is needed (either inserted or another condition)
	    _onDragOver: function _onDragOver(
	    /**Event*/
	    evt) {
	      var el = this.el,
	          target = evt.target,
	          dragRect,
	          targetRect,
	          revert,
	          options = this.options,
	          group = options.group,
	          activeSortable = Sortable.active,
	          isOwner = activeGroup === group,
	          canSort = options.sort,
	          fromSortable = putSortable || activeSortable,
	          vertical,
	          _this = this,
	          completedFired = false;
	
	      if (_silent) return;
	
	      function dragOverEvent(name, extra) {
	        pluginEvent(name, _this, _objectSpread({
	          evt: evt,
	          isOwner: isOwner,
	          axis: vertical ? 'vertical' : 'horizontal',
	          revert: revert,
	          dragRect: dragRect,
	          targetRect: targetRect,
	          canSort: canSort,
	          fromSortable: fromSortable,
	          target: target,
	          completed: completed,
	          onMove: function onMove(target, after) {
	            return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
	          },
	          changed: changed
	        }, extra));
	      } // Capture animation state
	
	
	      function capture() {
	        dragOverEvent('dragOverAnimationCapture');
	
	        _this.captureAnimationState();
	
	        if (_this !== fromSortable) {
	          fromSortable.captureAnimationState();
	        }
	      } // Return invocation when dragEl is inserted (or completed)
	
	
	      function completed(insertion) {
	        dragOverEvent('dragOverCompleted', {
	          insertion: insertion
	        });
	
	        if (insertion) {
	          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
	          if (isOwner) {
	            activeSortable._hideClone();
	          } else {
	            activeSortable._showClone(_this);
	          }
	
	          if (_this !== fromSortable) {
	            // Set ghost class to new sortable's ghost class
	            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
	            toggleClass(dragEl, options.ghostClass, true);
	          }
	
	          if (putSortable !== _this && _this !== Sortable.active) {
	            putSortable = _this;
	          } else if (_this === Sortable.active && putSortable) {
	            putSortable = null;
	          } // Animation
	
	
	          if (fromSortable === _this) {
	            _this._ignoreWhileAnimating = target;
	          }
	
	          _this.animateAll(function () {
	            dragOverEvent('dragOverAnimationComplete');
	            _this._ignoreWhileAnimating = null;
	          });
	
	          if (_this !== fromSortable) {
	            fromSortable.animateAll();
	            fromSortable._ignoreWhileAnimating = null;
	          }
	        } // Null lastTarget if it is not inside a previously swapped element
	
	
	        if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
	          lastTarget = null;
	        } // no bubbling and not fallback
	
	
	        if (!options.dragoverBubble && !evt.rootEl && target !== document) {
	          dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted
	
	
	          !insertion && nearestEmptyInsertDetectEvent(evt);
	        }
	
	        !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
	        return completedFired = true;
	      } // Call when dragEl has been inserted
	
	
	      function changed() {
	        newIndex = index(dragEl);
	        newDraggableIndex = index(dragEl, options.draggable);
	
	        _dispatchEvent({
	          sortable: _this,
	          name: 'change',
	          toEl: el,
	          newIndex: newIndex,
	          newDraggableIndex: newDraggableIndex,
	          originalEvent: evt
	        });
	      }
	
	      if (evt.preventDefault !== void 0) {
	        evt.cancelable && evt.preventDefault();
	      }
	
	      target = closest(target, options.draggable, el, true);
	      dragOverEvent('dragOver');
	      if (Sortable.eventCanceled) return completedFired;
	
	      if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
	        return completed(false);
	      }
	
	      ignoreNextClick = false;
	
	      if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
	      : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
	        vertical = this._getDirection(evt, target) === 'vertical';
	        dragRect = getRect(dragEl);
	        dragOverEvent('dragOverValid');
	        if (Sortable.eventCanceled) return completedFired;
	
	        if (revert) {
	          parentEl = rootEl; // actualization
	
	          capture();
	
	          this._hideClone();
	
	          dragOverEvent('revert');
	
	          if (!Sortable.eventCanceled) {
	            if (nextEl) {
	              rootEl.insertBefore(dragEl, nextEl);
	            } else {
	              rootEl.appendChild(dragEl);
	            }
	          }
	
	          return completed(true);
	        }
	
	        var elLastChild = lastChild(el, options.draggable);
	
	        if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
	          // If already at end of list: Do not insert
	          if (elLastChild === dragEl) {
	            return completed(false);
	          } // assign target only if condition is true
	
	
	          if (elLastChild && el === evt.target) {
	            target = elLastChild;
	          }
	
	          if (target) {
	            targetRect = getRect(target);
	          }
	
	          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
	            capture();
	            el.appendChild(dragEl);
	            parentEl = el; // actualization
	
	            changed();
	            return completed(true);
	          }
	        } else if (target.parentNode === el) {
	          targetRect = getRect(target);
	          var direction = 0,
	              targetBeforeFirstSwap,
	              differentLevel = dragEl.parentNode !== el,
	              differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
	              side1 = vertical ? 'top' : 'left',
	              scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
	              scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
	
	          if (lastTarget !== target) {
	            targetBeforeFirstSwap = targetRect[side1];
	            pastFirstInvertThresh = false;
	            isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
	          }
	
	          direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
	          var sibling;
	
	          if (direction !== 0) {
	            // Check if target is beside dragEl in respective direction (ignoring hidden elements)
	            var dragIndex = index(dragEl);
	
	            do {
	              dragIndex -= direction;
	              sibling = parentEl.children[dragIndex];
	            } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
	          } // If dragEl is already beside target: Do not insert
	
	
	          if (direction === 0 || sibling === target) {
	            return completed(false);
	          }
	
	          lastTarget = target;
	          lastDirection = direction;
	          var nextSibling = target.nextElementSibling,
	              after = false;
	          after = direction === 1;
	
	          var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
	
	          if (moveVector !== false) {
	            if (moveVector === 1 || moveVector === -1) {
	              after = moveVector === 1;
	            }
	
	            _silent = true;
	            setTimeout(_unsilent, 30);
	            capture();
	
	            if (after && !nextSibling) {
	              el.appendChild(dragEl);
	            } else {
	              target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
	            } // Undo chrome's scroll adjustment (has no effect on other browsers)
	
	
	            if (scrolledPastTop) {
	              scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
	            }
	
	            parentEl = dragEl.parentNode; // actualization
	            // must be done before animation
	
	            if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
	              targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
	            }
	
	            changed();
	            return completed(true);
	          }
	        }
	
	        if (el.contains(dragEl)) {
	          return completed(false);
	        }
	      }
	
	      return false;
	    },
	    _ignoreWhileAnimating: null,
	    _offMoveEvents: function _offMoveEvents() {
	      off(document, 'mousemove', this._onTouchMove);
	      off(document, 'touchmove', this._onTouchMove);
	      off(document, 'pointermove', this._onTouchMove);
	      off(document, 'dragover', nearestEmptyInsertDetectEvent);
	      off(document, 'mousemove', nearestEmptyInsertDetectEvent);
	      off(document, 'touchmove', nearestEmptyInsertDetectEvent);
	    },
	    _offUpEvents: function _offUpEvents() {
	      var ownerDocument = this.el.ownerDocument;
	      off(ownerDocument, 'mouseup', this._onDrop);
	      off(ownerDocument, 'touchend', this._onDrop);
	      off(ownerDocument, 'pointerup', this._onDrop);
	      off(ownerDocument, 'touchcancel', this._onDrop);
	      off(document, 'selectstart', this);
	    },
	    _onDrop: function _onDrop(
	    /**Event*/
	    evt) {
	      var el = this.el,
	          options = this.options; // Get the index of the dragged element within its parent
	
	      newIndex = index(dragEl);
	      newDraggableIndex = index(dragEl, options.draggable);
	      pluginEvent('drop', this, {
	        evt: evt
	      });
	      parentEl = dragEl && dragEl.parentNode; // Get again after plugin event
	
	      newIndex = index(dragEl);
	      newDraggableIndex = index(dragEl, options.draggable);
	
	      if (Sortable.eventCanceled) {
	        this._nulling();
	
	        return;
	      }
	
	      awaitingDragStarted = false;
	      isCircumstantialInvert = false;
	      pastFirstInvertThresh = false;
	      clearInterval(this._loopId);
	      clearTimeout(this._dragStartTimer);
	
	      _cancelNextTick(this.cloneId);
	
	      _cancelNextTick(this._dragStartId); // Unbind events
	
	
	      if (this.nativeDraggable) {
	        off(document, 'drop', this);
	        off(el, 'dragstart', this._onDragStart);
	      }
	
	      this._offMoveEvents();
	
	      this._offUpEvents();
	
	      if (Safari) {
	        css(document.body, 'user-select', '');
	      }
	
	      if (evt) {
	        if (moved) {
	          evt.cancelable && evt.preventDefault();
	          !options.dropBubble && evt.stopPropagation();
	        }
	
	        ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
	
	        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
	          // Remove clone(s)
	          cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
	        }
	
	        if (dragEl) {
	          if (this.nativeDraggable) {
	            off(dragEl, 'dragend', this);
	          }
	
	          _disableDraggable(dragEl);
	
	          dragEl.style['will-change'] = ''; // Remove classes
	          // ghostClass is added in dragStarted
	
	          if (moved && !awaitingDragStarted) {
	            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
	          }
	
	          toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event
	
	          _dispatchEvent({
	            sortable: this,
	            name: 'unchoose',
	            toEl: parentEl,
	            newIndex: null,
	            newDraggableIndex: null,
	            originalEvent: evt
	          });
	
	          if (rootEl !== parentEl) {
	            if (newIndex >= 0) {
	              // Add event
	              _dispatchEvent({
	                rootEl: parentEl,
	                name: 'add',
	                toEl: parentEl,
	                fromEl: rootEl,
	                originalEvent: evt
	              }); // Remove event
	
	
	              _dispatchEvent({
	                sortable: this,
	                name: 'remove',
	                toEl: parentEl,
	                originalEvent: evt
	              }); // drag from one list and drop into another
	
	
	              _dispatchEvent({
	                rootEl: parentEl,
	                name: 'sort',
	                toEl: parentEl,
	                fromEl: rootEl,
	                originalEvent: evt
	              });
	
	              _dispatchEvent({
	                sortable: this,
	                name: 'sort',
	                toEl: parentEl,
	                originalEvent: evt
	              });
	            }
	
	            putSortable && putSortable.save();
	          } else {
	            if (newIndex !== oldIndex) {
	              if (newIndex >= 0) {
	                // drag & drop within the same list
	                _dispatchEvent({
	                  sortable: this,
	                  name: 'update',
	                  toEl: parentEl,
	                  originalEvent: evt
	                });
	
	                _dispatchEvent({
	                  sortable: this,
	                  name: 'sort',
	                  toEl: parentEl,
	                  originalEvent: evt
	                });
	              }
	            }
	          }
	
	          if (Sortable.active) {
	            /* jshint eqnull:true */
	            if (newIndex == null || newIndex === -1) {
	              newIndex = oldIndex;
	              newDraggableIndex = oldDraggableIndex;
	            }
	
	            _dispatchEvent({
	              sortable: this,
	              name: 'end',
	              toEl: parentEl,
	              originalEvent: evt
	            }); // Save sorting
	
	
	            this.save();
	          }
	        }
	      }
	
	      this._nulling();
	    },
	    _nulling: function _nulling() {
	      pluginEvent('nulling', this);
	      rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
	      savedInputChecked.forEach(function (el) {
	        el.checked = true;
	      });
	      savedInputChecked.length = lastDx = lastDy = 0;
	    },
	    handleEvent: function handleEvent(
	    /**Event*/
	    evt) {
	      switch (evt.type) {
	        case 'drop':
	        case 'dragend':
	          this._onDrop(evt);
	
	          break;
	
	        case 'dragenter':
	        case 'dragover':
	          if (dragEl) {
	            this._onDragOver(evt);
	
	            _globalDragOver(evt);
	          }
	
	          break;
	
	        case 'selectstart':
	          evt.preventDefault();
	          break;
	      }
	    },
	
	    /**
	     * Serializes the item into an array of string.
	     * @returns {String[]}
	     */
	    toArray: function toArray() {
	      var order = [],
	          el,
	          children = this.el.children,
	          i = 0,
	          n = children.length,
	          options = this.options;
	
	      for (; i < n; i++) {
	        el = children[i];
	
	        if (closest(el, options.draggable, this.el, false)) {
	          order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
	        }
	      }
	
	      return order;
	    },
	
	    /**
	     * Sorts the elements according to the array.
	     * @param  {String[]}  order  order of the items
	     */
	    sort: function sort(order) {
	      var items = {},
	          rootEl = this.el;
	      this.toArray().forEach(function (id, i) {
	        var el = rootEl.children[i];
	
	        if (closest(el, this.options.draggable, rootEl, false)) {
	          items[id] = el;
	        }
	      }, this);
	      order.forEach(function (id) {
	        if (items[id]) {
	          rootEl.removeChild(items[id]);
	          rootEl.appendChild(items[id]);
	        }
	      });
	    },
	
	    /**
	     * Save the current sorting
	     */
	    save: function save() {
	      var store = this.options.store;
	      store && store.set && store.set(this);
	    },
	
	    /**
	     * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
	     * @param   {HTMLElement}  el
	     * @param   {String}       [selector]  default: `options.draggable`
	     * @returns {HTMLElement|null}
	     */
	    closest: function closest$1(el, selector) {
	      return closest(el, selector || this.options.draggable, this.el, false);
	    },
	
	    /**
	     * Set/get option
	     * @param   {string} name
	     * @param   {*}      [value]
	     * @returns {*}
	     */
	    option: function option(name, value) {
	      var options = this.options;
	
	      if (value === void 0) {
	        return options[name];
	      } else {
	        var modifiedValue = PluginManager.modifyOption(this, name, value);
	
	        if (typeof modifiedValue !== 'undefined') {
	          options[name] = modifiedValue;
	        } else {
	          options[name] = value;
	        }
	
	        if (name === 'group') {
	          _prepareGroup(options);
	        }
	      }
	    },
	
	    /**
	     * Destroy
	     */
	    destroy: function destroy() {
	      pluginEvent('destroy', this);
	      var el = this.el;
	      el[expando] = null;
	      off(el, 'mousedown', this._onTapStart);
	      off(el, 'touchstart', this._onTapStart);
	      off(el, 'pointerdown', this._onTapStart);
	
	      if (this.nativeDraggable) {
	        off(el, 'dragover', this);
	        off(el, 'dragenter', this);
	      } // Remove draggable attributes
	
	
	      Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
	        el.removeAttribute('draggable');
	      });
	
	      this._onDrop();
	
	      sortables.splice(sortables.indexOf(this.el), 1);
	      this.el = el = null;
	    },
	    _hideClone: function _hideClone() {
	      if (!cloneHidden) {
	        pluginEvent('hideClone', this);
	        if (Sortable.eventCanceled) return;
	        css(cloneEl, 'display', 'none');
	
	        if (this.options.removeCloneOnHide && cloneEl.parentNode) {
	          cloneEl.parentNode.removeChild(cloneEl);
	        }
	
	        cloneHidden = true;
	      }
	    },
	    _showClone: function _showClone(putSortable) {
	      if (putSortable.lastPutMode !== 'clone') {
	        this._hideClone();
	
	        return;
	      }
	
	      if (cloneHidden) {
	        pluginEvent('showClone', this);
	        if (Sortable.eventCanceled) return; // show clone at dragEl or original position
	
	        if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
	          rootEl.insertBefore(cloneEl, dragEl);
	        } else if (nextEl) {
	          rootEl.insertBefore(cloneEl, nextEl);
	        } else {
	          rootEl.appendChild(cloneEl);
	        }
	
	        if (this.options.group.revertClone) {
	          this.animate(dragEl, cloneEl);
	        }
	
	        css(cloneEl, 'display', '');
	        cloneHidden = false;
	      }
	    }
	  };
	
	  function _globalDragOver(
	  /**Event*/
	  evt) {
	    if (evt.dataTransfer) {
	      evt.dataTransfer.dropEffect = 'move';
	    }
	
	    evt.cancelable && evt.preventDefault();
	  }
	
	  function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
	    var evt,
	        sortable = fromEl[expando],
	        onMoveFn = sortable.options.onMove,
	        retVal; // Support for new CustomEvent feature
	
	    if (window.CustomEvent && !IE11OrLess && !Edge) {
	      evt = new CustomEvent('move', {
	        bubbles: true,
	        cancelable: true
	      });
	    } else {
	      evt = document.createEvent('Event');
	      evt.initEvent('move', true, true);
	    }
	
	    evt.to = toEl;
	    evt.from = fromEl;
	    evt.dragged = dragEl;
	    evt.draggedRect = dragRect;
	    evt.related = targetEl || toEl;
	    evt.relatedRect = targetRect || getRect(toEl);
	    evt.willInsertAfter = willInsertAfter;
	    evt.originalEvent = originalEvent;
	    fromEl.dispatchEvent(evt);
	
	    if (onMoveFn) {
	      retVal = onMoveFn.call(sortable, evt, originalEvent);
	    }
	
	    return retVal;
	  }
	
	  function _disableDraggable(el) {
	    el.draggable = false;
	  }
	
	  function _unsilent() {
	    _silent = false;
	  }
	
	  function _ghostIsLast(evt, vertical, sortable) {
	    var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
	    var spacer = 10;
	    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
	  }
	
	  function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
	    var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
	        targetLength = vertical ? targetRect.height : targetRect.width,
	        targetS1 = vertical ? targetRect.top : targetRect.left,
	        targetS2 = vertical ? targetRect.bottom : targetRect.right,
	        invert = false;
	
	    if (!invertSwap) {
	      // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
	      if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
	        // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
	        // check if past first invert threshold on side opposite of lastDirection
	        if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
	          // past first invert threshold, do not restrict inverted threshold to dragEl shadow
	          pastFirstInvertThresh = true;
	        }
	
	        if (!pastFirstInvertThresh) {
	          // dragEl shadow (target move distance shadow)
	          if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
	          : mouseOnAxis > targetS2 - targetMoveDistance) {
	            return -lastDirection;
	          }
	        } else {
	          invert = true;
	        }
	      } else {
	        // Regular
	        if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
	          return _getInsertDirection(target);
	        }
	      }
	    }
	
	    invert = invert || invertSwap;
	
	    if (invert) {
	      // Invert of regular
	      if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
	        return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
	      }
	    }
	
	    return 0;
	  }
	  /**
	   * Gets the direction dragEl must be swapped relative to target in order to make it
	   * seem that dragEl has been "inserted" into that element's position
	   * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
	   * @return {Number}                   Direction dragEl must be swapped
	   */
	
	
	  function _getInsertDirection(target) {
	    if (index(dragEl) < index(target)) {
	      return 1;
	    } else {
	      return -1;
	    }
	  }
	  /**
	   * Generate id
	   * @param   {HTMLElement} el
	   * @returns {String}
	   * @private
	   */
	
	
	  function _generateId(el) {
	    var str = el.tagName + el.className + el.src + el.href + el.textContent,
	        i = str.length,
	        sum = 0;
	
	    while (i--) {
	      sum += str.charCodeAt(i);
	    }
	
	    return sum.toString(36);
	  }
	
	  function _saveInputCheckedState(root) {
	    savedInputChecked.length = 0;
	    var inputs = root.getElementsByTagName('input');
	    var idx = inputs.length;
	
	    while (idx--) {
	      var el = inputs[idx];
	      el.checked && savedInputChecked.push(el);
	    }
	  }
	
	  function _nextTick(fn) {
	    return setTimeout(fn, 0);
	  }
	
	  function _cancelNextTick(id) {
	    return clearTimeout(id);
	  } // Fixed #973:
	
	
	  if (documentExists) {
	    on(document, 'touchmove', function (evt) {
	      if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
	        evt.preventDefault();
	      }
	    });
	  } // Export utils
	
	
	  Sortable.utils = {
	    on: on,
	    off: off,
	    css: css,
	    find: find,
	    is: function is(el, selector) {
	      return !!closest(el, selector, el, false);
	    },
	    extend: extend,
	    throttle: throttle,
	    closest: closest,
	    toggleClass: toggleClass,
	    clone: clone,
	    index: index,
	    nextTick: _nextTick,
	    cancelNextTick: _cancelNextTick,
	    detectDirection: _detectDirection,
	    getChild: getChild
	  };
	  /**
	   * Get the Sortable instance of an element
	   * @param  {HTMLElement} element The element
	   * @return {Sortable|undefined}         The instance of Sortable
	   */
	
	  Sortable.get = function (element) {
	    return element[expando];
	  };
	  /**
	   * Mount a plugin to Sortable
	   * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
	   */
	
	
	  Sortable.mount = function () {
	    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
	      plugins[_key] = arguments[_key];
	    }
	
	    if (plugins[0].constructor === Array) plugins = plugins[0];
	    plugins.forEach(function (plugin) {
	      if (!plugin.prototype || !plugin.prototype.constructor) {
	        throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
	      }
	
	      if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
	      PluginManager.mount(plugin);
	    });
	  };
	  /**
	   * Create sortable instance
	   * @param {HTMLElement}  el
	   * @param {Object}      [options]
	   */
	
	
	  Sortable.create = function (el, options) {
	    return new Sortable(el, options);
	  }; // Export
	
	
	  Sortable.version = version;
	
	  var autoScrolls = [],
	      scrollEl,
	      scrollRootEl,
	      scrolling = false,
	      lastAutoScrollX,
	      lastAutoScrollY,
	      touchEvt$1,
	      pointerElemChangedInterval;
	
	  function AutoScrollPlugin() {
	    function AutoScroll() {
	      this.defaults = {
	        scroll: true,
	        scrollSensitivity: 30,
	        scrollSpeed: 10,
	        bubbleScroll: true
	      }; // Bind all private methods
	
	      for (var fn in this) {
	        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
	          this[fn] = this[fn].bind(this);
	        }
	      }
	    }
	
	    AutoScroll.prototype = {
	      dragStarted: function dragStarted(_ref) {
	        var originalEvent = _ref.originalEvent;
	
	        if (this.sortable.nativeDraggable) {
	          on(document, 'dragover', this._handleAutoScroll);
	        } else {
	          if (this.options.supportPointer) {
	            on(document, 'pointermove', this._handleFallbackAutoScroll);
	          } else if (originalEvent.touches) {
	            on(document, 'touchmove', this._handleFallbackAutoScroll);
	          } else {
	            on(document, 'mousemove', this._handleFallbackAutoScroll);
	          }
	        }
	      },
	      dragOverCompleted: function dragOverCompleted(_ref2) {
	        var originalEvent = _ref2.originalEvent;
	
	        // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
	        if (!this.options.dragOverBubble && !originalEvent.rootEl) {
	          this._handleAutoScroll(originalEvent);
	        }
	      },
	      drop: function drop() {
	        if (this.sortable.nativeDraggable) {
	          off(document, 'dragover', this._handleAutoScroll);
	        } else {
	          off(document, 'pointermove', this._handleFallbackAutoScroll);
	          off(document, 'touchmove', this._handleFallbackAutoScroll);
	          off(document, 'mousemove', this._handleFallbackAutoScroll);
	        }
	
	        clearPointerElemChangedInterval();
	        clearAutoScrolls();
	        cancelThrottle();
	      },
	      nulling: function nulling() {
	        touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
	        autoScrolls.length = 0;
	      },
	      _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
	        this._handleAutoScroll(evt, true);
	      },
	      _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
	        var _this = this;
	
	        var x = (evt.touches ? evt.touches[0] : evt).clientX,
	            y = (evt.touches ? evt.touches[0] : evt).clientY,
	            elem = document.elementFromPoint(x, y);
	        touchEvt$1 = evt; // IE does not seem to have native autoscroll,
	        // Edge's autoscroll seems too conditional,
	        // MACOS Safari does not have autoscroll,
	        // Firefox and Chrome are good
	
	        if (fallback || Edge || IE11OrLess || Safari) {
	          autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change
	
	          var ogElemScroller = getParentAutoScrollElement(elem, true);
	
	          if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
	            pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour
	
	            pointerElemChangedInterval = setInterval(function () {
	              var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
	
	              if (newElem !== ogElemScroller) {
	                ogElemScroller = newElem;
	                clearAutoScrolls();
	              }
	
	              autoScroll(evt, _this.options, newElem, fallback);
	            }, 10);
	            lastAutoScrollX = x;
	            lastAutoScrollY = y;
	          }
	        } else {
	          // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
	          if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
	            clearAutoScrolls();
	            return;
	          }
	
	          autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
	        }
	      }
	    };
	    return _extends(AutoScroll, {
	      pluginName: 'scroll',
	      initializeByDefault: true
	    });
	  }
	
	  function clearAutoScrolls() {
	    autoScrolls.forEach(function (autoScroll) {
	      clearInterval(autoScroll.pid);
	    });
	    autoScrolls = [];
	  }
	
	  function clearPointerElemChangedInterval() {
	    clearInterval(pointerElemChangedInterval);
	  }
	
	  var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
	    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
	    if (!options.scroll) return;
	    var x = (evt.touches ? evt.touches[0] : evt).clientX,
	        y = (evt.touches ? evt.touches[0] : evt).clientY,
	        sens = options.scrollSensitivity,
	        speed = options.scrollSpeed,
	        winScroller = getWindowScrollingElement();
	    var scrollThisInstance = false,
	        scrollCustomFn; // New scroll root, set scrollEl
	
	    if (scrollRootEl !== rootEl) {
	      scrollRootEl = rootEl;
	      clearAutoScrolls();
	      scrollEl = options.scroll;
	      scrollCustomFn = options.scrollFn;
	
	      if (scrollEl === true) {
	        scrollEl = getParentAutoScrollElement(rootEl, true);
	      }
	    }
	
	    var layersOut = 0;
	    var currentParent = scrollEl;
	
	    do {
	      var el = currentParent,
	          rect = getRect(el),
	          top = rect.top,
	          bottom = rect.bottom,
	          left = rect.left,
	          right = rect.right,
	          width = rect.width,
	          height = rect.height,
	          canScrollX = void 0,
	          canScrollY = void 0,
	          scrollWidth = el.scrollWidth,
	          scrollHeight = el.scrollHeight,
	          elCSS = css(el),
	          scrollPosX = el.scrollLeft,
	          scrollPosY = el.scrollTop;
	
	      if (el === winScroller) {
	        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
	        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
	      } else {
	        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
	        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
	      }
	
	      var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
	      var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
	
	      if (!autoScrolls[layersOut]) {
	        for (var i = 0; i <= layersOut; i++) {
	          if (!autoScrolls[i]) {
	            autoScrolls[i] = {};
	          }
	        }
	      }
	
	      if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
	        autoScrolls[layersOut].el = el;
	        autoScrolls[layersOut].vx = vx;
	        autoScrolls[layersOut].vy = vy;
	        clearInterval(autoScrolls[layersOut].pid);
	
	        if (vx != 0 || vy != 0) {
	          scrollThisInstance = true;
	          /* jshint loopfunc:true */
	
	          autoScrolls[layersOut].pid = setInterval(function () {
	            // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
	            if (isFallback && this.layer === 0) {
	              Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely
	
	            }
	
	            var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
	            var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
	
	            if (typeof scrollCustomFn === 'function') {
	              if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
	                return;
	              }
	            }
	
	            scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
	          }.bind({
	            layer: layersOut
	          }), 24);
	        }
	      }
	
	      layersOut++;
	    } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
	
	    scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
	  }, 30);
	
	  var drop = function drop(_ref) {
	    var originalEvent = _ref.originalEvent,
	        putSortable = _ref.putSortable,
	        dragEl = _ref.dragEl,
	        activeSortable = _ref.activeSortable,
	        dispatchSortableEvent = _ref.dispatchSortableEvent,
	        hideGhostForTarget = _ref.hideGhostForTarget,
	        unhideGhostForTarget = _ref.unhideGhostForTarget;
	    if (!originalEvent) return;
	    var toSortable = putSortable || activeSortable;
	    hideGhostForTarget();
	    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
	    var target = document.elementFromPoint(touch.clientX, touch.clientY);
	    unhideGhostForTarget();
	
	    if (toSortable && !toSortable.el.contains(target)) {
	      dispatchSortableEvent('spill');
	      this.onSpill({
	        dragEl: dragEl,
	        putSortable: putSortable
	      });
	    }
	  };
	
	  function Revert() {}
	
	  Revert.prototype = {
	    startIndex: null,
	    dragStart: function dragStart(_ref2) {
	      var oldDraggableIndex = _ref2.oldDraggableIndex;
	      this.startIndex = oldDraggableIndex;
	    },
	    onSpill: function onSpill(_ref3) {
	      var dragEl = _ref3.dragEl,
	          putSortable = _ref3.putSortable;
	      this.sortable.captureAnimationState();
	
	      if (putSortable) {
	        putSortable.captureAnimationState();
	      }
	
	      var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
	
	      if (nextSibling) {
	        this.sortable.el.insertBefore(dragEl, nextSibling);
	      } else {
	        this.sortable.el.appendChild(dragEl);
	      }
	
	      this.sortable.animateAll();
	
	      if (putSortable) {
	        putSortable.animateAll();
	      }
	    },
	    drop: drop
	  };
	
	  _extends(Revert, {
	    pluginName: 'revertOnSpill'
	  });
	
	  function Remove() {}
	
	  Remove.prototype = {
	    onSpill: function onSpill(_ref4) {
	      var dragEl = _ref4.dragEl,
	          putSortable = _ref4.putSortable;
	      var parentSortable = putSortable || this.sortable;
	      parentSortable.captureAnimationState();
	      dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
	      parentSortable.animateAll();
	    },
	    drop: drop
	  };
	
	  _extends(Remove, {
	    pluginName: 'removeOnSpill'
	  });
	
	  var lastSwapEl;
	
	  function SwapPlugin() {
	    function Swap() {
	      this.defaults = {
	        swapClass: 'sortable-swap-highlight'
	      };
	    }
	
	    Swap.prototype = {
	      dragStart: function dragStart(_ref) {
	        var dragEl = _ref.dragEl;
	        lastSwapEl = dragEl;
	      },
	      dragOverValid: function dragOverValid(_ref2) {
	        var completed = _ref2.completed,
	            target = _ref2.target,
	            onMove = _ref2.onMove,
	            activeSortable = _ref2.activeSortable,
	            changed = _ref2.changed,
	            cancel = _ref2.cancel;
	        if (!activeSortable.options.swap) return;
	        var el = this.sortable.el,
	            options = this.options;
	
	        if (target && target !== el) {
	          var prevSwapEl = lastSwapEl;
	
	          if (onMove(target) !== false) {
	            toggleClass(target, options.swapClass, true);
	            lastSwapEl = target;
	          } else {
	            lastSwapEl = null;
	          }
	
	          if (prevSwapEl && prevSwapEl !== lastSwapEl) {
	            toggleClass(prevSwapEl, options.swapClass, false);
	          }
	        }
	
	        changed();
	        completed(true);
	        cancel();
	      },
	      drop: function drop(_ref3) {
	        var activeSortable = _ref3.activeSortable,
	            putSortable = _ref3.putSortable,
	            dragEl = _ref3.dragEl;
	        var toSortable = putSortable || this.sortable;
	        var options = this.options;
	        lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);
	
	        if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
	          if (dragEl !== lastSwapEl) {
	            toSortable.captureAnimationState();
	            if (toSortable !== activeSortable) activeSortable.captureAnimationState();
	            swapNodes(dragEl, lastSwapEl);
	            toSortable.animateAll();
	            if (toSortable !== activeSortable) activeSortable.animateAll();
	          }
	        }
	      },
	      nulling: function nulling() {
	        lastSwapEl = null;
	      }
	    };
	    return _extends(Swap, {
	      pluginName: 'swap',
	      eventProperties: function eventProperties() {
	        return {
	          swapItem: lastSwapEl
	        };
	      }
	    });
	  }
	
	  function swapNodes(n1, n2) {
	    var p1 = n1.parentNode,
	        p2 = n2.parentNode,
	        i1,
	        i2;
	    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
	    i1 = index(n1);
	    i2 = index(n2);
	
	    if (p1.isEqualNode(p2) && i1 < i2) {
	      i2++;
	    }
	
	    p1.insertBefore(n2, p1.children[i1]);
	    p2.insertBefore(n1, p2.children[i2]);
	  }
	
	  var multiDragElements = [],
	      multiDragClones = [],
	      lastMultiDragSelect,
	      // for selection with modifier key down (SHIFT)
	  multiDragSortable,
	      initialFolding = false,
	      // Initial multi-drag fold when drag started
	  folding = false,
	      // Folding any other time
	  dragStarted = false,
	      dragEl$1,
	      clonesFromRect,
	      clonesHidden;
	
	  function MultiDragPlugin() {
	    function MultiDrag(sortable) {
	      // Bind all private methods
	      for (var fn in this) {
	        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
	          this[fn] = this[fn].bind(this);
	        }
	      }
	
	      if (sortable.options.supportPointer) {
	        on(document, 'pointerup', this._deselectMultiDrag);
	      } else {
	        on(document, 'mouseup', this._deselectMultiDrag);
	        on(document, 'touchend', this._deselectMultiDrag);
	      }
	
	      on(document, 'keydown', this._checkKeyDown);
	      on(document, 'keyup', this._checkKeyUp);
	      this.defaults = {
	        selectedClass: 'sortable-selected',
	        multiDragKey: null,
	        setData: function setData(dataTransfer, dragEl) {
	          var data = '';
	
	          if (multiDragElements.length && multiDragSortable === sortable) {
	            multiDragElements.forEach(function (multiDragElement, i) {
	              data += (!i ? '' : ', ') + multiDragElement.textContent;
	            });
	          } else {
	            data = dragEl.textContent;
	          }
	
	          dataTransfer.setData('Text', data);
	        }
	      };
	    }
	
	    MultiDrag.prototype = {
	      multiDragKeyDown: false,
	      isMultiDrag: false,
	      delayStartGlobal: function delayStartGlobal(_ref) {
	        var dragged = _ref.dragEl;
	        dragEl$1 = dragged;
	      },
	      delayEnded: function delayEnded() {
	        this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
	      },
	      setupClone: function setupClone(_ref2) {
	        var sortable = _ref2.sortable,
	            cancel = _ref2.cancel;
	        if (!this.isMultiDrag) return;
	
	        for (var i = 0; i < multiDragElements.length; i++) {
	          multiDragClones.push(clone(multiDragElements[i]));
	          multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
	          multiDragClones[i].draggable = false;
	          multiDragClones[i].style['will-change'] = '';
	          toggleClass(multiDragClones[i], this.options.selectedClass, false);
	          multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
	        }
	
	        sortable._hideClone();
	
	        cancel();
	      },
	      clone: function clone(_ref3) {
	        var sortable = _ref3.sortable,
	            rootEl = _ref3.rootEl,
	            dispatchSortableEvent = _ref3.dispatchSortableEvent,
	            cancel = _ref3.cancel;
	        if (!this.isMultiDrag) return;
	
	        if (!this.options.removeCloneOnHide) {
	          if (multiDragElements.length && multiDragSortable === sortable) {
	            insertMultiDragClones(true, rootEl);
	            dispatchSortableEvent('clone');
	            cancel();
	          }
	        }
	      },
	      showClone: function showClone(_ref4) {
	        var cloneNowShown = _ref4.cloneNowShown,
	            rootEl = _ref4.rootEl,
	            cancel = _ref4.cancel;
	        if (!this.isMultiDrag) return;
	        insertMultiDragClones(false, rootEl);
	        multiDragClones.forEach(function (clone) {
	          css(clone, 'display', '');
	        });
	        cloneNowShown();
	        clonesHidden = false;
	        cancel();
	      },
	      hideClone: function hideClone(_ref5) {
	        var _this = this;
	
	        var sortable = _ref5.sortable,
	            cloneNowHidden = _ref5.cloneNowHidden,
	            cancel = _ref5.cancel;
	        if (!this.isMultiDrag) return;
	        multiDragClones.forEach(function (clone) {
	          css(clone, 'display', 'none');
	
	          if (_this.options.removeCloneOnHide && clone.parentNode) {
	            clone.parentNode.removeChild(clone);
	          }
	        });
	        cloneNowHidden();
	        clonesHidden = true;
	        cancel();
	      },
	      dragStartGlobal: function dragStartGlobal(_ref6) {
	        var sortable = _ref6.sortable;
	
	        if (!this.isMultiDrag && multiDragSortable) {
	          multiDragSortable.multiDrag._deselectMultiDrag();
	        }
	
	        multiDragElements.forEach(function (multiDragElement) {
	          multiDragElement.sortableIndex = index(multiDragElement);
	        }); // Sort multi-drag elements
	
	        multiDragElements = multiDragElements.sort(function (a, b) {
	          return a.sortableIndex - b.sortableIndex;
	        });
	        dragStarted = true;
	      },
	      dragStarted: function dragStarted(_ref7) {
	        var _this2 = this;
	
	        var sortable = _ref7.sortable;
	        if (!this.isMultiDrag) return;
	
	        if (this.options.sort) {
	          // Capture rects,
	          // hide multi drag elements (by positioning them absolute),
	          // set multi drag elements rects to dragRect,
	          // show multi drag elements,
	          // animate to rects,
	          // unset rects & remove from DOM
	          sortable.captureAnimationState();
	
	          if (this.options.animation) {
	            multiDragElements.forEach(function (multiDragElement) {
	              if (multiDragElement === dragEl$1) return;
	              css(multiDragElement, 'position', 'absolute');
	            });
	            var dragRect = getRect(dragEl$1, false, true, true);
	            multiDragElements.forEach(function (multiDragElement) {
	              if (multiDragElement === dragEl$1) return;
	              setRect(multiDragElement, dragRect);
	            });
	            folding = true;
	            initialFolding = true;
	          }
	        }
	
	        sortable.animateAll(function () {
	          folding = false;
	          initialFolding = false;
	
	          if (_this2.options.animation) {
	            multiDragElements.forEach(function (multiDragElement) {
	              unsetRect(multiDragElement);
	            });
	          } // Remove all auxiliary multidrag items from el, if sorting enabled
	
	
	          if (_this2.options.sort) {
	            removeMultiDragElements();
	          }
	        });
	      },
	      dragOver: function dragOver(_ref8) {
	        var target = _ref8.target,
	            completed = _ref8.completed,
	            cancel = _ref8.cancel;
	
	        if (folding && ~multiDragElements.indexOf(target)) {
	          completed(false);
	          cancel();
	        }
	      },
	      revert: function revert(_ref9) {
	        var fromSortable = _ref9.fromSortable,
	            rootEl = _ref9.rootEl,
	            sortable = _ref9.sortable,
	            dragRect = _ref9.dragRect;
	
	        if (multiDragElements.length > 1) {
	          // Setup unfold animation
	          multiDragElements.forEach(function (multiDragElement) {
	            sortable.addAnimationState({
	              target: multiDragElement,
	              rect: folding ? getRect(multiDragElement) : dragRect
	            });
	            unsetRect(multiDragElement);
	            multiDragElement.fromRect = dragRect;
	            fromSortable.removeAnimationState(multiDragElement);
	          });
	          folding = false;
	          insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
	        }
	      },
	      dragOverCompleted: function dragOverCompleted(_ref10) {
	        var sortable = _ref10.sortable,
	            isOwner = _ref10.isOwner,
	            insertion = _ref10.insertion,
	            activeSortable = _ref10.activeSortable,
	            parentEl = _ref10.parentEl,
	            putSortable = _ref10.putSortable;
	        var options = this.options;
	
	        if (insertion) {
	          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
	          if (isOwner) {
	            activeSortable._hideClone();
	          }
	
	          initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location
	
	          if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
	            // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
	            var dragRectAbsolute = getRect(dragEl$1, false, true, true);
	            multiDragElements.forEach(function (multiDragElement) {
	              if (multiDragElement === dragEl$1) return;
	              setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
	              // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
	
	              parentEl.appendChild(multiDragElement);
	            });
	            folding = true;
	          } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
	
	
	          if (!isOwner) {
	            // Only remove if not folding (folding will remove them anyways)
	            if (!folding) {
	              removeMultiDragElements();
	            }
	
	            if (multiDragElements.length > 1) {
	              var clonesHiddenBefore = clonesHidden;
	
	              activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden
	
	
	              if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
	                multiDragClones.forEach(function (clone) {
	                  activeSortable.addAnimationState({
	                    target: clone,
	                    rect: clonesFromRect
	                  });
	                  clone.fromRect = clonesFromRect;
	                  clone.thisAnimationDuration = null;
	                });
	              }
	            } else {
	              activeSortable._showClone(sortable);
	            }
	          }
	        }
	      },
	      dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
	        var dragRect = _ref11.dragRect,
	            isOwner = _ref11.isOwner,
	            activeSortable = _ref11.activeSortable;
	        multiDragElements.forEach(function (multiDragElement) {
	          multiDragElement.thisAnimationDuration = null;
	        });
	
	        if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
	          clonesFromRect = _extends({}, dragRect);
	          var dragMatrix = matrix(dragEl$1, true);
	          clonesFromRect.top -= dragMatrix.f;
	          clonesFromRect.left -= dragMatrix.e;
	        }
	      },
	      dragOverAnimationComplete: function dragOverAnimationComplete() {
	        if (folding) {
	          folding = false;
	          removeMultiDragElements();
	        }
	      },
	      drop: function drop(_ref12) {
	        var evt = _ref12.originalEvent,
	            rootEl = _ref12.rootEl,
	            parentEl = _ref12.parentEl,
	            sortable = _ref12.sortable,
	            dispatchSortableEvent = _ref12.dispatchSortableEvent,
	            oldIndex = _ref12.oldIndex,
	            putSortable = _ref12.putSortable;
	        var toSortable = putSortable || this.sortable;
	        if (!evt) return;
	        var options = this.options,
	            children = parentEl.children; // Multi-drag selection
	
	        if (!dragStarted) {
	          if (options.multiDragKey && !this.multiDragKeyDown) {
	            this._deselectMultiDrag();
	          }
	
	          toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));
	
	          if (!~multiDragElements.indexOf(dragEl$1)) {
	            multiDragElements.push(dragEl$1);
	            dispatchEvent({
	              sortable: sortable,
	              rootEl: rootEl,
	              name: 'select',
	              targetEl: dragEl$1,
	              originalEvt: evt
	            }); // Modifier activated, select from last to dragEl
	
	            if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
	              var lastIndex = index(lastMultiDragSelect),
	                  currentIndex = index(dragEl$1);
	
	              if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
	                // Must include lastMultiDragSelect (select it), in case modified selection from no selection
	                // (but previous selection existed)
	                var n, i;
	
	                if (currentIndex > lastIndex) {
	                  i = lastIndex;
	                  n = currentIndex;
	                } else {
	                  i = currentIndex;
	                  n = lastIndex + 1;
	                }
	
	                for (; i < n; i++) {
	                  if (~multiDragElements.indexOf(children[i])) continue;
	                  toggleClass(children[i], options.selectedClass, true);
	                  multiDragElements.push(children[i]);
	                  dispatchEvent({
	                    sortable: sortable,
	                    rootEl: rootEl,
	                    name: 'select',
	                    targetEl: children[i],
	                    originalEvt: evt
	                  });
	                }
	              }
	            } else {
	              lastMultiDragSelect = dragEl$1;
	            }
	
	            multiDragSortable = toSortable;
	          } else {
	            multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
	            lastMultiDragSelect = null;
	            dispatchEvent({
	              sortable: sortable,
	              rootEl: rootEl,
	              name: 'deselect',
	              targetEl: dragEl$1,
	              originalEvt: evt
	            });
	          }
	        } // Multi-drag drop
	
	
	        if (dragStarted && this.isMultiDrag) {
	          // Do not "unfold" after around dragEl if reverted
	          if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
	            var dragRect = getRect(dragEl$1),
	                multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
	            if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
	            toSortable.captureAnimationState();
	
	            if (!initialFolding) {
	              if (options.animation) {
	                dragEl$1.fromRect = dragRect;
	                multiDragElements.forEach(function (multiDragElement) {
	                  multiDragElement.thisAnimationDuration = null;
	
	                  if (multiDragElement !== dragEl$1) {
	                    var rect = folding ? getRect(multiDragElement) : dragRect;
	                    multiDragElement.fromRect = rect; // Prepare unfold animation
	
	                    toSortable.addAnimationState({
	                      target: multiDragElement,
	                      rect: rect
	                    });
	                  }
	                });
	              } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
	              // properly they must all be removed
	
	
	              removeMultiDragElements();
	              multiDragElements.forEach(function (multiDragElement) {
	                if (children[multiDragIndex]) {
	                  parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
	                } else {
	                  parentEl.appendChild(multiDragElement);
	                }
	
	                multiDragIndex++;
	              }); // If initial folding is done, the elements may have changed position because they are now
	              // unfolding around dragEl, even though dragEl may not have his index changed, so update event
	              // must be fired here as Sortable will not.
	
	              if (oldIndex === index(dragEl$1)) {
	                var update = false;
	                multiDragElements.forEach(function (multiDragElement) {
	                  if (multiDragElement.sortableIndex !== index(multiDragElement)) {
	                    update = true;
	                    return;
	                  }
	                });
	
	                if (update) {
	                  dispatchSortableEvent('update');
	                }
	              }
	            } // Must be done after capturing individual rects (scroll bar)
	
	
	            multiDragElements.forEach(function (multiDragElement) {
	              unsetRect(multiDragElement);
	            });
	            toSortable.animateAll();
	          }
	
	          multiDragSortable = toSortable;
	        } // Remove clones if necessary
	
	
	        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
	          multiDragClones.forEach(function (clone) {
	            clone.parentNode && clone.parentNode.removeChild(clone);
	          });
	        }
	      },
	      nullingGlobal: function nullingGlobal() {
	        this.isMultiDrag = dragStarted = false;
	        multiDragClones.length = 0;
	      },
	      destroyGlobal: function destroyGlobal() {
	        this._deselectMultiDrag();
	
	        off(document, 'pointerup', this._deselectMultiDrag);
	        off(document, 'mouseup', this._deselectMultiDrag);
	        off(document, 'touchend', this._deselectMultiDrag);
	        off(document, 'keydown', this._checkKeyDown);
	        off(document, 'keyup', this._checkKeyUp);
	      },
	      _deselectMultiDrag: function _deselectMultiDrag(evt) {
	        if (dragStarted) return; // Only deselect if selection is in this sortable
	
	        if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable
	
	        if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click
	
	        if (evt && evt.button !== 0) return;
	
	        while (multiDragElements.length) {
	          var el = multiDragElements[0];
	          toggleClass(el, this.options.selectedClass, false);
	          multiDragElements.shift();
	          dispatchEvent({
	            sortable: this.sortable,
	            rootEl: this.sortable.el,
	            name: 'deselect',
	            targetEl: el,
	            originalEvt: evt
	          });
	        }
	      },
	      _checkKeyDown: function _checkKeyDown(evt) {
	        if (evt.key === this.options.multiDragKey) {
	          this.multiDragKeyDown = true;
	        }
	      },
	      _checkKeyUp: function _checkKeyUp(evt) {
	        if (evt.key === this.options.multiDragKey) {
	          this.multiDragKeyDown = false;
	        }
	      }
	    };
	    return _extends(MultiDrag, {
	      // Static methods & properties
	      pluginName: 'multiDrag',
	      utils: {
	        /**
	         * Selects the provided multi-drag item
	         * @param  {HTMLElement} el    The element to be selected
	         */
	        select: function select(el) {
	          var sortable = el.parentNode[expando];
	          if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;
	
	          if (multiDragSortable && multiDragSortable !== sortable) {
	            multiDragSortable.multiDrag._deselectMultiDrag();
	
	            multiDragSortable = sortable;
	          }
	
	          toggleClass(el, sortable.options.selectedClass, true);
	          multiDragElements.push(el);
	        },
	
	        /**
	         * Deselects the provided multi-drag item
	         * @param  {HTMLElement} el    The element to be deselected
	         */
	        deselect: function deselect(el) {
	          var sortable = el.parentNode[expando],
	              index = multiDragElements.indexOf(el);
	          if (!sortable || !sortable.options.multiDrag || !~index) return;
	          toggleClass(el, sortable.options.selectedClass, false);
	          multiDragElements.splice(index, 1);
	        }
	      },
	      eventProperties: function eventProperties() {
	        var _this3 = this;
	
	        var oldIndicies = [],
	            newIndicies = [];
	        multiDragElements.forEach(function (multiDragElement) {
	          oldIndicies.push({
	            multiDragElement: multiDragElement,
	            index: multiDragElement.sortableIndex
	          }); // multiDragElements will already be sorted if folding
	
	          var newIndex;
	
	          if (folding && multiDragElement !== dragEl$1) {
	            newIndex = -1;
	          } else if (folding) {
	            newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
	          } else {
	            newIndex = index(multiDragElement);
	          }
	
	          newIndicies.push({
	            multiDragElement: multiDragElement,
	            index: newIndex
	          });
	        });
	        return {
	          items: _toConsumableArray(multiDragElements),
	          clones: [].concat(multiDragClones),
	          oldIndicies: oldIndicies,
	          newIndicies: newIndicies
	        };
	      },
	      optionListeners: {
	        multiDragKey: function multiDragKey(key) {
	          key = key.toLowerCase();
	
	          if (key === 'ctrl') {
	            key = 'Control';
	          } else if (key.length > 1) {
	            key = key.charAt(0).toUpperCase() + key.substr(1);
	          }
	
	          return key;
	        }
	      }
	    });
	  }
	
	  function insertMultiDragElements(clonesInserted, rootEl) {
	    multiDragElements.forEach(function (multiDragElement, i) {
	      var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
	
	      if (target) {
	        rootEl.insertBefore(multiDragElement, target);
	      } else {
	        rootEl.appendChild(multiDragElement);
	      }
	    });
	  }
	  /**
	   * Insert multi-drag clones
	   * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
	   * @param  {HTMLElement} rootEl
	   */
	
	
	  function insertMultiDragClones(elementsInserted, rootEl) {
	    multiDragClones.forEach(function (clone, i) {
	      var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
	
	      if (target) {
	        rootEl.insertBefore(clone, target);
	      } else {
	        rootEl.appendChild(clone);
	      }
	    });
	  }
	
	  function removeMultiDragElements() {
	    multiDragElements.forEach(function (multiDragElement) {
	      if (multiDragElement === dragEl$1) return;
	      multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
	    });
	  }
	
	  Sortable.mount(new AutoScrollPlugin());
	  Sortable.mount(Remove, Revert);
	
	  Sortable.mount(new SwapPlugin());
	  Sortable.mount(new MultiDragPlugin());
	
	  return Sortable;
	
	}));


/***/ },
/* 68 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(68);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 70 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.2805a6c1.js